import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, ReplaySubject, Subject, throwError } from 'rxjs';
import { HttpClient , HttpHeaders, HttpRequest, HttpResponse} from '@angular/common/http';
// import { Http, Response, Headers, RequestOptions,RequestOptionsArgs,ResponseContentType } from '@angular/http';
import { GenService } from './gen-ser.service';
import { Plant, Region, SaleChannel, ProjectManager, ProjectEngineer, ProductVariant, EquipmentType, RefMonth, DesignEngineer, AdvancePayPercent, AdvancePayMilestone, AdvancePayCondition, YesNoOption, LDPercentDef, LDCAPDef, DeliveryTermDef, PaymentTermDef, BusbarMaterialDef, ApplicabilityOptionDef, BusbarSleeveDef, FeederTypeDef, PanelNumDef, JobComplexityDef, configDefs, JobPriorityDef, SalesOrder, SubSalesOrder, MarketingEngineer, WarrantyInMonth, MechanicalDesignEngineer, ConfigItems, ElectricalDesignEngineer, ContractualDeliveryWeeks, WarrantyMonths, InsulationLevel, SuborderNumbers, KIOSKApplicability, BreakerType, ManufacturtingStrategy, PBGPayCondition, CPBGPayCondition,retentionPaymentCondition,retentionMilestone,MarketingIP, PmCommercialIP, PmTechnicalIP, ScmIP, EnggDrawIP, EnggProcureIP, PurchasePOIP, PlanningIP, PurchaseMaterialReceiptIP, ProductionIP, QualityIP, LogisticIP, StoreIP, Equipment, RevenueMonth, PlannedDateToken, ActualDateToken, PartialDelivery, RequestDateToken, ProjStatus, UserType, MyTaskType, User, C30Engineer, ServerSockEvent, ElectricalTestingEngineer, MechanicalTestingEngineer, BoardnameDef, DelayReason,RelayConfig, OrderType, EmailGrp, SuperAdmin, RelayConfigUI, GenDataType, GenUserDef, DatasheetNumbers, OptionsDef, OptionsSubOptsDef, OptionsConnectedDef, ReqNonReqOption, DSBreakerPS, OptionsConnectedValueDef, DSForceCooling } from './misc-classes';
import { MatLegacyDialog as MatDialog, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { MatLegacySnackBar as MatSnackBar } from '@angular/material/legacy-snack-bar';
import { LoaderDialog } from '../dialogs/loader-dialog/loader-dialog';
import io, { Socket } from 'socket.io-client';
import { CookieService } from 'ngx-cookie-service';
import { catchError, map } from 'rxjs/operators';
import { ConfigurationService } from './configuration.service';
// import { HttpHeaders } from '@angular/common/http';

@Injectable()
export class DataService{

    private static getDataDefinitionsUrl = '/getdatadefinitions';
    private static getDataDefinitionsUrlPR = '/getdatadefinitionPR';
    private static saveSalesOrder = '/savesalesorder';
    private static getSalesOrder = '/getsalesorder';
    private static getSalesOrder_2 = '/getsalesorder_2';
    private static getSalesOrderByCustomerName = '/getsalesorder_by_customername';
    private static getAllSalesOrderUrl= '/getallsalesorder';
    private static getAllSalesOrderUrlPR= '/getallsalesorderPR';
    private static downloadFile:string = '/downloadexcel';
    private static getUserListUrl:string = '/getuserlist'; 
    private static deleteSalesOrder:string = '/delsaleorder';
    private static getSOLockUrl:string = '/locksaleorder'; 
    private static releaseSOLockUrl:string = '/releasesolock'; 
    private static downloadFileUrl:string = '/downloadrtc';
    private static sendaisc40:string = '/aisc40';
    private static getDeletedSaleOrder:string = '/getDelSaleOrd';
    private static getDelSubSaleOrder:string = '/getDelSubSaleOrd';
    private static getLogFile:string = '/getLogFile';
    private static createDatasheetVersionUrl:string = '/createdatasheetversion';
    private static getDatasheetVersionUrl:string = '/getdatasheetversion';
    private static deleteSubSalesOrder:string = '/delsubsaleorder';
    private static deleteDatasheet:string = '/deldatasheet';
    private static downloadFileKPI:string = '/downloadexcelkpi'; 
    private static getAllSalesOrderUrl_2= '/getallsalesorder_2';
    private static downloadPdf:string = '/downloadpdf';
    private static uploadPdf:string = '/uploadpdf';
    // private static fetchSapData:string = '/fetchSapData';
    private static fetchSapData:string = '/fetchsalesorder_sap';
    private static getSapSynchInfo:string = '/getSAPSyncStatus';
    private static fetchMigoSapData:string = '/fetchmigo_sap';
    private static fetchMaterialSapData:string = '/fetchmaterial_sap';
    private static fetchDispatchSapData:string = '/fetchdispatch_sap';



    private _accessLevel:string = '';
    private _userName:string = '';
    private _userType:UserType = UserType.UNKNOWN;
    private _userId:string = '-';
    private _userMyTaskGroup:MyTaskType = MyTaskType.UNKNOWN;
    private _companyName:string = 'INABB EPDS 3410 Air Insulated Switchgear ';//'Loading...';
    public currPageName:string = "";
    public additionalPageDetails:string = "";

    private _plants:Array<Plant> = [];
    private _regions:Array<Region> = [];
    private _ordertypes:Array<OrderType> = [];
    private _relayconfigs:Array<RelayConfig> = [];
    private _relayconfigs_ui:Array<RelayConfigUI> = [];
    private _saleChannels:Array<SaleChannel> = [];
    private _projectManagers:Array<ProjectManager> = []
    private _emailGrp:Array<EmailGrp> = []
    private _superAdmin:Array<SuperAdmin> = [];
    private _natureOfIssuesList:Array<GenDataType> = [];
    private _changeNoteTypeList:Array<GenDataType> = [];
    private _approverL1List:Array<GenUserDef> = [];
    private _approverL2List:Array<GenUserDef> = [];
    private _projectEngineers:Array<ProjectEngineer> = [];
    private _productVariants:Array<ProductVariant> = [];
    private _typeOfEquipments:Array<EquipmentType> = [];
    private _generalEquipmentTypeIds:Array<string> = [];
    private _mechanicalDesignEngineer: Array<MechanicalDesignEngineer> = [];
    private _refMonths:Array<RefMonth> = [];
    private _designEngineers:Array<DesignEngineer> = [];
    private _marketingEngineers :Array<MarketingEngineer> = [];
    private _elecTestEngineers:Array<ElectricalTestingEngineer> = []
    private _mechTestEngineers:Array<MechanicalTestingEngineer> = []
    private _warrantyInMonths : Array<WarrantyInMonth> = [];
    private _advancePayPercents:Array<AdvancePayPercent> = [];
    private _advancePayMilestones:Array<AdvancePayMilestone> = [];
    private _advancePayMilestonesABGACG:Array<AdvancePayMilestone> = [];
    private _advancePayConditions:Array<AdvancePayCondition> = [];
    private _yesNoOptions:Array<YesNoOption> = []; 
    private _ldPercentList:Array<LDPercentDef> = [];
    private _ldCAPList:Array<LDCAPDef> = [];
    private _deliveryTermList:Array<DeliveryTermDef> = [];
    private _paymentTermList:Array<PaymentTermDef>= [];
    private _busbarMaterialList:Array<BusbarMaterialDef> = []
    private _applicabilityOptions:Array<ApplicabilityOptionDef> = [];
    private _applicabilityOptions_2:Array<ApplicabilityOptionDef> = [];
    private _busbarSleeves:Array<BusbarSleeveDef> = [];
    private _noOfPanelsList:Array<PanelNumDef> = [];
    private _noOfFeederTypeList:Array<FeederTypeDef> = [];
    private _jobComplexityList:Array<JobComplexityDef> = [];
    private _jobPriorityList:Array<JobPriorityDef> = [];
    private _configItems: Array<ConfigItems> = [];
    private _electricalDesignEngineer: Array<ElectricalDesignEngineer> = [];
    private _c30DesignEngineer: Array<C30Engineer> = [];
    private _contractualDeliveryWeeks: Array<ContractualDeliveryWeeks> = [];
    private _warrantyMonths: Array<WarrantyMonths> = [];
    private _insulationLevel: Array<InsulationLevel> = [];
    private _suborderNumbers : Array<SuborderNumbers> = [];
    private _datasheetNumbers : Array<DatasheetNumbers> = [];
    private _kioskApplicability : Array<KIOSKApplicability> = [];
    private _breakerType : Array<BreakerType> = [];
    private _manufacturtingStrategy : Array<ManufacturtingStrategy> = [];
    private _pbgPayCondition: Array<PBGPayCondition> = [];
    private _cpbgPayCondition: Array<CPBGPayCondition> = [];
    private _retentionPayConditions: Array<retentionPaymentCondition> = [];
    private _retentionMilestone : Array<retentionMilestone> = [];
    private _revenueMonths:Array<RevenueMonth> = [];
    private _projStatusList:Array<ProjStatus> = [];
    private _boardnameList:Array<BoardnameDef>= [];
    private _delayReasonList:Array<DelayReason>=[];
    private _tempRiseList:Array<OptionsDef> = [];
    private _earthingSystemList:Array<OptionsDef> = [];
    private _vcbModel:Array<OptionsConnectedDef> = [];
    private _generalVcbModelIds:Array<string> = [];
    private _vcbModelDetail:Array<OptionsConnectedDef> = [];
    private _generalVcbModelDetailIds:Array<string> = [];
    private _vcbType:Array<OptionsDef> = [];
    private _vcbPole:Array<OptionsDef> = [];
    private _lvCompDoor:Array<OptionsDef> = [];
    private _forLVCompDoorDetail:Array<OptionsDef> = [];
    private _restOfPanel:Array<OptionsDef> = [];
    private _lvCompDoorV2:Array<OptionsDef> = [];
    private _breakerCompDoor:Array<OptionsDef> = [];
    private _rearCover:Array<OptionsDef> = [];
    private _powerCable:Array<OptionsDef> = [];
    private _controlCable:Array<OptionsDef> = [];
    private _busductEntry:Array<OptionsDef> = [];
    private _cableRun:Array<OptionsDef> = [];
    private _cableRunList:Array<OptionsDef> = [];
    private _singleCoreCables:Array<OptionsConnectedDef> = [];
    private _generalSingleCoreCablesIds:Array<string> = [];
    private _exhType:Array<OptionsDef> = [];
    private _reqNonReqOptions:Array<ReqNonReqOption> = [];
    private _applicabilityOptions_UVCoil:Array<ApplicabilityOptionDef> = [];
    private _feederRatingBPList:Array<OptionsDef>=[]; // Reused for UV Coil Detail
    private _feederRatingBP:Array<OptionsConnectedDef>=[];
    private _generalFeederRatingBPIds:Array<string>=[];
    private _switchingList:Array<OptionsDef> = [];
    private _dsBreakerPS :Array<DSBreakerPS>=[];
    private _forceCoolingVCBCurr:Array<OptionsConnectedDef> = [];
    private _generalForceCoolingVCBCurrIds:Array<string> = [];
    private _forceCooling: Array<DSForceCooling> = [];
    private _locationOfFans:Array<OptionsDef> = [];
    private _silverPlt:Array<OptionsDef>=[];
    private _feederTypeNBList:Array<OptionsDef>=[];
    private _mainBusbarCB:Array<OptionsDef>=[];
    private _feederConn:Array<OptionsDef> = [];
    private _materialMBB:Array<OptionsDef> = [];
    private _htSleevesMake:Array<OptionsDef> = [];
    private _phaseIdentification:Array<OptionsConnectedDef> = [];
    private _generalPhaseIdentificationIds:Array<string> = [];
    private _earthBBSize:Array<OptionsConnectedDef> = [];
    private _generalEarthBBSizeIds:Array<string> = [];
    private _earthBBSizeDetail:Array<OptionsDef> = [];
    private _applicFrontDrEndCvr:Array<OptionsDef> = [];
    private _sptColorList:Array<OptionsDef> = [];
    private _typPaintProc:Array<OptionsConnectedDef> = [];
    private _generalTypPaintProcIds:Array<string> = [];
    private _paintProcDoc:Array<OptionsConnectedDef> = [];
    private _generalPaintProcDocIds:Array<string> = [];
    private _mimic:Array<OptionsDef> = [];
    private _mimicV2:Array<OptionsDef> = [];
    private _closeTripCirc:Array<OptionsDef> = [];
    private _addTripCoil:Array<OptionsDef> = [];
    private _meteringConAux:Array<OptionsDef> = [];
    private _spaceHeater:Array<OptionsDef> = [];
    private _annunCirc:Array<OptionsDef> = [];
    private _conWireTyp:Array<OptionsDef> = [];
    private _conWireTypDetail:Array<OptionsDef> = [];
    private _applicStand:Array<OptionsConnectedDef> = [];
    private _generalApplicStandIds:Array<string> = [];
    private _insulationGrade: Array<OptionsConnectedDef> = [];
    private _generalInsulationGradeIds:Array<string> = [];
    private _wireTypV2: Array<OptionsDef> = [];
    private _wireTypV2Detail: Array<OptionsDef> = [];
    private _ctCirc: Array<OptionsDef> = [];
    private _ctCircColor: Array<OptionsDef> = [];
    private _ptCirc: Array<OptionsDef> = [];
    private _ptCircColor: Array<OptionsDef> = [];
    private _dcConCirc: Array<OptionsDef> = [];
    private _dcConCircColor: Array<OptionsDef> = [];
    private _acConCirc: Array<OptionsDef> = [];
    private _acConCircColor: Array<OptionsDef> = [];
    private _earthWire: Array<OptionsDef> = [];
    private _earthWireColor: Array<OptionsDef> = [];
    private _hingeDoorEarth: Array<OptionsDef> = [];
    private _mainDCCirc: Array<OptionsDef> = [];
    private _mainDCCircColor: Array<OptionsDef> = [];
    private _mainACCirc: Array<OptionsDef> = [];
    private _mainACCircColor: Array<OptionsDef> = [];
    private _ferrulling: Array<OptionsDef> = [];
    private _ferrullingMat: Array<OptionsDef> = [];
    private _termBlockMat : Array<OptionsDef> = [];
    private _termBlockMake: Array<OptionsDef> = [];
    private _typeOfTermDisc: Array<OptionsDef> = [];
    private _typeOfTermNonDisc: Array<OptionsDef> = [];
    private _rackInOutMech: Array<OptionsConnectedDef> = [];
    private _generalRackInOutMechIds:Array<string> = [];
    private _ratedSingCap: Array<OptionsDef> = [];
    private _maxArcTime:Array<OptionsDef> = [];
    private _openingTime:Array<OptionsDef> = [];
    private _totalBreakTime:Array<OptionsDef> = [];
    private _closingTime:Array<OptionsDef> = [];
    private _ratedOpSeq:Array<OptionsDef> = [];
    private _cbClass:Array<OptionsDef> = [];
    private _maxDCComp:Array<OptionsConnectedDef> = [];
    private _generalMaxDCIds:Array<string> = [];
    private _cbFreeFix:Array<OptionsDef> = [];
    private _cbConVoltUVCoil:Array<OptionsDef> = [];
    private _vacContType:Array<OptionsDef> = [];
    private _cbCloseTripVolt:Array<OptionsDef> = [];
    private _cbLatchType:Array<OptionsDef> = [];
    private _ctMould : Array<OptionsDef> = [];
    private _ctMouldList : Array<OptionsDef> = [];
    private _ctCbCtType : Array<OptionsDef> = [];
    private _insulClass: Array<OptionsDef> = []; // Reused for Potential Transformer
    private _instruSafety: Array<OptionsDef> = [];
    private _ctShortTimeCurrDr: Array<OptionsDef> = [];
    private _ctCbCtRatio: Array<OptionsDef> = [];
    private _minPrimBalance: Array<OptionsDef> = [];
    private _basicInsuLvl: Array<OptionsDef> = [];
    private _potTrafoMountingTyp : Array<OptionsConnectedValueDef> = [];
    private _generalPotTrafoMountingTypIds:Array<string> = [];
    private _potTrafoMountingTypList : Array<OptionsDef> = [];
    private _numRelMake: Array<OptionsDef> = [];
    private _numRelMakeDetail: Array<OptionsDef> = [];
    private _numRelType: Array<OptionsDef> = [];
    private _numRelCommPrtcl: Array<OptionsConnectedDef> = [];
    private _generalNumRelCommPrtclIds:Array<string> = [];
    private _numRelCommPort : Array<OptionsConnectedDef> = [];
    private _generalNumRelCommPortIds:Array<string> = [];
    private _numRelTimeSync: Array<OptionsDef> = [];
    private _numRelCoating: Array<OptionsDef> = [];
    private _numRelTransReqRTDList: Array<OptionsDef> = []; // Reused for Numerical Relay & Annunciator
    private _auxRelTripCoil1_2: Array<OptionsDef> = []; // Reused for Auxiliary Relay Trip Coil 1 & 2
    private _metMultiMeterList: Array<OptionsDef> = []; // Reused for Multi Meter & Tri Vector Meter & Surge Arrestor
    private _metMultiComm: Array<OptionsDef> = [];
    private _metMultiCommPort : Array<OptionsDef> = [];
    private _metSpecificMake: Array<OptionsDef> = [];
    private _metTriComm: Array<OptionsDef> = [];
    private _metTriCommPort : Array<OptionsDef> = [];
    private _metAmmType: Array<OptionsDef> = [];
    private _metAmmDisplay: Array<OptionsConnectedDef> = [];
    private _generalMetAmmDisplayIds:Array<string> = [];
    private _surgeArr: Array<OptionsConnectedDef> = [];
    private _generalSurgeArrIds:Array<string> = [];
    private _typeDesg: Array<OptionsDef> = [];
    private _disCurrent: Array<OptionsDef> = [];
    private _annunTyp: Array<OptionsDef> = [];
    private _annunCommPort: Array<OptionsDef> = [];
    private _swBreakTrip: Array<OptionsDef> = [];
    private _swRemHandleType: Array<OptionsDef> = [];
    private _swVoltSelector: Array<OptionsDef> = [];
    private _ethCommArch : Array<OptionsConnectedValueDef> = [];
    private _generalEthCommArchIds:Array<string> = [];
    private _ethConfPopup : Array<OptionsConnectedDef> = [];
    private _generalEthConfPopupIds:Array<string> = [];
    private _ethRemComm : Array<OptionsDef> = [];
    private _ethAuxSupply : Array<OptionsDef> = [];
    private _ethPowerSup1_2 : Array<OptionsDef> = [];
    private _ethCoating : Array<OptionsDef> = [];
    private _ethMounting : Array<OptionsDef> = [];
    private _erthDeviceBus :Array<OptionsDef> = [];
    private _erthDeviceCable :Array<OptionsDef> = [];
    private _splDevVolIndicator:Array<OptionsDef> = [];
    private _splDevMounting:Array<OptionsDef> = [];
    private _splDevTempMSys:Array<OptionsDef> = [];
    private _splDevSensorTyp:Array<OptionsDef> = [];
    private _splDevTmsComm:Array<OptionsDef> = [];
    private _splDevList: Array<OptionsDef> = []; // Reused for all Special Devices lists
    private _ffrCoating:Array<OptionsDef> = [];
    private _swbActionPoints:Array<OptionsDef> = [];



    public isSocketEnabled = false;
    private _soLoadTimeArray:any = {};
    private _soLoadTimeArrayPR:any = {};
    private _soLoadDataArray:any = {};
    private _soLoadDataArrayPR:any = {};
    private _soReqTimeArray:any = {};
    private _soReqTimeArrayPR:any = {};
    private _soReqTimeArray_2:any = {};
    private _soLoadDataArray_2:any = {};
    private _soLoadTimeArray_2:any = {};



    socket:Socket;
    private url:string = '/';
    public maxSelDate:Date;

    public isUnitDataLoaded:boolean = false;
    private _dataDefsLoadTime:Date;
    
    public successOptions = {
        timeOut: 3000,
        showProgressBar: true,
        pauseOnHover: false,
        clickToClose: true,
        maxLength: 10
    };
    public failureOptions = {
        timeOut: 5000,
        showProgressBar: true,
        pauseOnHover: false,
        clickToClose: true,
        maxLength: 10
    };    
    
    public _currentSubMenuId:number = -1;
    serverEventSubscriber:Subject<any>;
    private syncedSAPDateSubject = new BehaviorSubject<Date>(null);
    syncedSAPDate$ = this.syncedSAPDateSubject.asObservable();
    constructor(private http:HttpClient,private _genSer: GenService,private snackBar: MatSnackBar,
            private dialog: MatDialog, private _cookie:CookieService, private _configurationService: ConfigurationService){
        this.getUserNameCookie();
        this.initDefs();
        if(this.isSocketEnabled == true)
            this.initSocketIO()
        // setTimeout(() => {
        //     this.getDataDefinitions();    
        // }, 100);
        
    }
    //properties start
    get companyName():string{
        return this._companyName;
    }
    get userName():string{
        return this._userName;
    }
    get userType():UserType{
        return this._userType;
    }
    get userMyTaskType():MyTaskType{
        return this._userMyTaskGroup;
    }
    get isAdmin():boolean{
        return this.userType == UserType.SUPER_ADMIN;
    }
    get isPMHOD():boolean{
        return this.userType == UserType.HOD_PROJECT_MANAGEMENT;
    }
    get hasAllAccess():boolean{
        if(this.userType == UserType.SUPER_ADMIN ){
            return true;
        }
        return false;
    }
    hasMarketingEditAccess():boolean{
        if(this.userType == UserType.SUPER_ADMIN 
            || this.userType == UserType.MARKETING
            || this.userType == UserType.HOD_MARKETING
            || this.userType == UserType.FINANCE
            || this.userType == UserType.HOD_FINANCE
            ){
            return true;
        }
        return false;
    }
    hasEnggDrawingEditAccess(_drawObj:EnggDrawIP):boolean{
        if(this.userType == UserType.SUPER_ADMIN 
            || this.userType == UserType.HOD_ENGINEERING
            || this.userType == UserType.HOD_PROJECT_MANAGEMENT
            || this.userType == UserType.HOD_SCM
            || this.userType == UserType.ELECTRICAL_ENGINEERING
            || this.userType == UserType.MECHANICAL_ENGINEERING
            || this.userType == UserType.C30_ENGINEERING
            || this.userType == UserType.SCM
             ){
            return true;
        }
        if(_drawObj && _drawObj.parentSORef){
            if( this.getProjectManagerEmailId(_drawObj.parentSORef.marketingIP.projectManagerId) == this.userId || 
                this.getProjectEngineerEmail(_drawObj.parentSORef.pmCommercial.projectEngineerId) == this.userId)
                {
                    return true;
                }
        }
        
        return false;      
    }
    hasEnggProcurementEditAccess(_procObj:EnggProcureIP):boolean{
        if(this.userType == UserType.SUPER_ADMIN || this.userType == UserType.MECHANICAL_ENGINEERING
            || this.userType == UserType.ELECTRICAL_ENGINEERING || this.userType == UserType.HOD_PROJECT_MANAGEMENT || this.userType == UserType.HOD_ENGINEERING
            || this.userType == UserType.C30_ENGINEERING){
            return true;
        }
        if(_procObj && _procObj.parentSORef){
            if( this.getProjectManagerEmailId(_procObj.parentSORef.marketingIP.projectManagerId) == this.userId || 
                this.getProjectEngineerEmail(_procObj.parentSORef.pmCommercial.projectEngineerId) == this.userId){
                    return true;
                }
        }
        return false;
    }
    hasPmCommercialEditAccess(_pmComObj: PmCommercialIP): boolean{
        if(this.userType == UserType.SUPER_ADMIN 
            || this.userType == UserType.PROJECT_MANAGEMENT
            || this.userType == UserType.HOD_PROJECT_MANAGEMENT
            || this.userType == UserType.HOD_MARKETING
            || this.userType == UserType.FINANCE
            || this.userType == UserType.HOD_FINANCE
            ){
            return true;
        }
        if(_pmComObj && _pmComObj.parentSORef){
            if( this.getMarketingEngineerEmail(_pmComObj.parentSORef.marketingIP.marketingEngineerId) == this.userId) 
                {
                    return true;
                }
        }
        return false;
    }
    hasPmTechnicalEditAccess(_pmTech: PmTechnicalIP): boolean{
        if(this.userType == UserType.SUPER_ADMIN 
            || this.userType == UserType.PROJECT_MANAGEMENT 
            || this.userType == UserType.HOD_PROJECT_MANAGEMENT
            || this.userType == UserType.HOD_MARKETING
            || this.userType == UserType.FINANCE
            || this.userType == UserType.HOD_FINANCE
            || this.userType == UserType.HOD_SCM
            || this.userType == UserType.HOD_ENGINEERING
            ){
            return true;
        }
        if(_pmTech && _pmTech.parentSORef){
            if(  this.getMarketingEngineerEmail(_pmTech.parentSORef.marketingIP.marketingEngineerId) == this.userId ||
                 this.getElecDesignEngineerEmailId(_pmTech.parentSubSORef.enggDrawIP.electricalDesignEngineerId) == this.userId||
                 this.getMechDesignEngineerEmail(_pmTech.parentSubSORef.enggDrawIP.mechanicalDesignEngineerId) == this.userId ) 
                {
                    return true;
                }
        }
        return false;
    }
    isNotSuperAdmin(): boolean{
        if(this.userType == UserType.SUPER_ADMIN)
        return true
    }
    get hasSCMEditAccess():boolean{
        if(this.userType == UserType.SUPER_ADMIN || this.userType == UserType.SCM
            || this.userType == UserType.HOD_SCM ){
            return true;
        }
        return false;
    }
    get hasPOEditAccess():boolean{
        if(this.userType == UserType.SUPER_ADMIN || this.userType == UserType.PURCHASE || this.userType == UserType.HOD_PURCHASE ){
            return true;
        }
        return false;
    }
    get hasMaterialReceiptEditAccess():boolean{
        if(this.userType == UserType.SUPER_ADMIN || this.userType == UserType.PURCHASE
            || this.userType == UserType.HOD_PURCHASE  ){
            return true;
        }
        return false;
    }
    get hasProductionEditAccess():boolean{
        if(this.userType == UserType.SUPER_ADMIN || this.userType == UserType.PRODUCTION 
            || this.userType == UserType.HOD_PRODUCTION || this.userType == UserType.PLANNING_PRODUCTION ){
                return true;
            }
            return false;   
    }
    get hasPlanningEditAccess():boolean{
        if(this.userType == UserType.SUPER_ADMIN || this.userType == UserType.PLANNING || this.userType == UserType.PLANNING_PRODUCTION
            || this.userType == UserType.HOD_PLANNING ){
            return true;
        }
        return false;
    }
    get hasTestingEditAccess():boolean{
        if(this.userType == UserType.SUPER_ADMIN || this.userType == UserType.TESTING 
            || this.userType == UserType.HOD_TESTING ){
            return true;
       }
        return false;
    }
    get hasStoresEditAccess():boolean{
        if(this.userType == UserType.SUPER_ADMIN || this.userType == UserType.STORES  || this.userType == UserType.HOD_STORES ){
            return true;
       }
        return false;
    }
    get hasLogisticsEditAccess():boolean{
        if(this.userType == UserType.SUPER_ADMIN || this.userType == UserType.LOGISTICS 
            || this.userType == UserType.HOD_LOGISTICS){
            return true;
       }
        return false;
    }
    get hasChangeNoteEditAccess(): boolean {
        if (this.userType == UserType.SUPER_ADMIN || this.userType == UserType.ELECTRICAL_ENGINEERING
            || this.userType == UserType.MECHANICAL_ENGINEERING) {
            return true;
        }
        return false;
    }
    get hasDatasheetEditAccess(): boolean {
        if (this.userType == UserType.SUPER_ADMIN || this.userType == UserType.PROJECT_MANAGEMENT ||
            this.userType == UserType.ELECTRICAL_ENGINEERING || this.userType == UserType.MECHANICAL_ENGINEERING
            || this.userType == UserType.MARKETING) {
            return true;
        }
        return false;
    }
    get hasDatasheetPMAccess(): boolean {
        if (this.userType == UserType.SUPER_ADMIN || this.userType == UserType.PROJECT_MANAGEMENT ||
            this.userType == UserType.HOD_PROJECT_MANAGEMENT) {
            return true;
        }
        return false;
    }
    get hasDatasheetEnggAccess(): boolean {
        if (this.userType == UserType.SUPER_ADMIN ||
            this.userType == UserType.ELECTRICAL_ENGINEERING || this.userType == UserType.MECHANICAL_ENGINEERING ||
            this.userType == UserType.HOD_ENGINEERING) {
            return true;
        }
        return false;
    }
    get hasReadOnlyAccess():boolean{
        if(this.userType == UserType.UNKNOWN ){
            return true;
        }
        return false;
    }
    get userId():string{
        return this._userId;
    }
    get plants():Array<Plant>{
        return this._plants;
    }
    get regions():Array<Region>{
        return this._regions;
    }
    get ordertypes():Array<OrderType>{
        return this._ordertypes;
    }
    get relayconfigs(): Array<RelayConfig>{
        return this._relayconfigs
    }
    get relayconfigs_ui(): Array<RelayConfigUI>{
        return this._relayconfigs_ui
    }
    get saleChannels():Array<SaleChannel>{
        return this._saleChannels;
    }
    get projectManagers():Array<ProjectManager>{
        return this._projectManagers;
    }
    get emailGroup():Array<EmailGrp>{
        return this._emailGrp;
    }
    get superAdmin():Array<SuperAdmin>{
        return this._superAdmin;
    }
    get natureOfIssuesList():Array<GenDataType>{
        return this._natureOfIssuesList;
    }
    get changeNoteTypeList():Array<GenDataType>{
        return this._changeNoteTypeList;
    }
    get approverL1List():Array<GenUserDef>{
        return this._approverL1List;
    }
    get approverL2List():Array<GenUserDef>{
        return this._approverL2List;
    }
    get projectEngineers():Array<ProjectEngineer>{
        return this._projectEngineers;
    }
    get productVariants():Array<ProductVariant>{
        return this._productVariants;
    }
    get typeOfEquipments():Array<EquipmentType>{
        return this._typeOfEquipments;
    }
    public isGeneralEquipmentType(_equipTypeId:string):boolean{
        return (this._generalEquipmentTypeIds.indexOf(_equipTypeId) >= 0)
    }
    public isVSCQtyEnable(_variantId:string,_equipTypeId:string, _brkrTypeID:string) :boolean{
        return ((_brkrTypeID == '004') && (_variantId == '001') && 
                (_equipTypeId == '009' || _equipTypeId == '010'));
    }
    get refMonths():Array<RefMonth>{
        return this._refMonths;
    }
    get designEngineers():Array<DesignEngineer>{
        return this._designEngineers;
    }
    get marketingEngineers():Array<MarketingEngineer>{
        return this._marketingEngineers;
    }
    get elecTestEngineers():Array<ElectricalTestingEngineer>{
        return this._elecTestEngineers;
    }
    get mechTestEngineers():Array<MechanicalTestingEngineer>{
        return this._mechTestEngineers;
    }
    get warrantyInMonths():Array<WarrantyInMonth>{
        return this._warrantyInMonths;
    }
    get advancePayPercents():Array<AdvancePayPercent>{
        return this._advancePayPercents;
    }
    get advancePayMilestones():Array<AdvancePayMilestone>{
        return this._advancePayMilestones;
    }
    get advancePayMilestonesABGACG():Array<AdvancePayMilestone>{
        return this._advancePayMilestonesABGACG;
    }
    get advancePayConditions():Array<AdvancePayCondition>{
        return this._advancePayConditions;
    }
    get yesNoOptions():Array<YesNoOption>{
        return this._yesNoOptions;
    }
    get projStatusOptions():Array<ProjStatus>{
        return this._projStatusList;
    }
    get ldPercentList():Array<LDPercentDef>{
        return this._ldPercentList;
    }
    get ldCAPList():Array<LDCAPDef>{
        return this._ldCAPList;
    }
    get deliveryTermList():Array<DeliveryTermDef>{
        return this._deliveryTermList;
    }
    get paymentTermList():Array<PaymentTermDef>{
        return this._paymentTermList;
    }
    get busbarMaterialList():Array<BusbarMaterialDef>{
        return this._busbarMaterialList;
    }
    get applicabilityOptions():Array<ApplicabilityOptionDef>{
        return this._applicabilityOptions;
    }
    get applicabilityOptions_2():Array<ApplicabilityOptionDef>{
        return this._applicabilityOptions_2;
    }
    get busbarSleeves():Array<BusbarSleeveDef>{
        return this._busbarSleeves;
    }
    get noOfPanelsList():Array<PanelNumDef>{
        return this._noOfPanelsList;
    }
    get noOfFeederTypeList():Array<FeederTypeDef>{
        return this._noOfFeederTypeList;
    }
    get jobComplexityList():Array<JobComplexityDef>{
        return this._jobComplexityList;
    }
    get jobPriorityList():Array<JobPriorityDef>{
        return this._jobPriorityList;
    }
    get mechanicalDesignEngineers(): Array<MechanicalDesignEngineer>{
        return this._mechanicalDesignEngineer;
    }
    get configItems():Array<ConfigItems>{
        return this._configItems;
    }
    get electricalDesignEngineer(): Array<ElectricalDesignEngineer> {
        return this._electricalDesignEngineer;
    }
    get c30Engineer():Array<C30Engineer>{
        return this._c30DesignEngineer;
    }
    get contractualDeliveryWeeks(): Array<ContractualDeliveryWeeks> {
        return this._contractualDeliveryWeeks;
    }
    get warrantyMonths(): Array<WarrantyMonths>{
        return this._warrantyMonths;
    }
    get insulationLevel(): Array<InsulationLevel> {
        return this._insulationLevel;
    }
    get suborderNumbers(): Array<SuborderNumbers> {
        return this._suborderNumbers;
    }
    get datasheetNumbers(): Array<DatasheetNumbers> {
        return this._datasheetNumbers;
    }
    get kioskApplicability(): Array<KIOSKApplicability> {
        return this._kioskApplicability;
    }
    get breakerType(): Array<BreakerType> {
        return this._breakerType;
    }
    get manufacturtingStrategy(): Array<ManufacturtingStrategy> {
        return this._manufacturtingStrategy;
    }
    get pbgPayCondition(): Array<PBGPayCondition>{
        return this._pbgPayCondition;
    }
    get cpbgPayCondition(): Array<CPBGPayCondition> {
        return this._cpbgPayCondition;
    }
    get retentionPayCondition(): Array<retentionPaymentCondition>{
        return this._retentionPayConditions;
    }
    get retentionMilestone():Array<retentionMilestone>{
        return this._retentionMilestone;
    }
    get revenueMonths():Array<RevenueMonth>{
        return this._revenueMonths;
    }
    get modifyPlanDate():boolean{
        return false;
    }
    get modifyReqDate():boolean{
        return false;
    }
    get tempRiseList():Array<OptionsDef>{
        return this._tempRiseList;
    }
    get earthingSystemList():Array<OptionsDef>{
        return this._earthingSystemList;
    }
    get vcbModel():Array<OptionsConnectedDef>{
        return this._vcbModel;
    }
    public isGeneralVcbModel(_id:string):boolean{
        return (this._generalVcbModelIds.indexOf(_id) >= 0)
    }
    get vcbModelDetail():Array<OptionsConnectedDef>{
        return this._vcbModelDetail;
    }
    public isGeneralVcbModelDetail(_id:string):boolean{
        return (this._generalVcbModelDetailIds.indexOf(_id) >= 0)
    }
    get vcbType():Array<OptionsDef>{
        return this._vcbType;
    }
    get vcbPole():Array<OptionsDef>{
        return this._vcbPole;
    }
    get lvCompDoor():Array<OptionsDef>{
        return this._lvCompDoor;
    }
    get forLVCompDoorDetail():Array<OptionsDef>{
        return this._forLVCompDoorDetail;
    }
    get restOfPanel():Array<OptionsDef>{
        return this._restOfPanel;
    }
    get lvCompDoorV2():Array<OptionsDef>{
        return this._lvCompDoorV2;
    }
    get breakerCompDoor():Array<OptionsDef>{
        return this._breakerCompDoor;
    }
    get rearCover():Array<OptionsDef>{
        return this._rearCover;
    }
    get powerCable():Array<OptionsDef>{
        return this._powerCable;
    }
    get controlCable():Array<OptionsDef>{
        return this._controlCable;
    }
    get busductEntry():Array<OptionsDef>{
        return this._busductEntry;
    }
    get cableRun():Array<OptionsDef>{
        return this._cableRun;
    }
    get cableRunList():Array<OptionsDef>{
        return this._cableRunList;
    }
    get singleCoreCables():Array<OptionsConnectedDef>{
        return this._singleCoreCables;
    }
    public isGeneralSingleCoreCables(_id:string):boolean{
        return (this._generalSingleCoreCablesIds.indexOf(_id) >= 0)
    }
    get exhType():Array<OptionsDef>{
        return this._exhType;
    }
    get reqNonReqOptions():Array<ReqNonReqOption>{
        return this._reqNonReqOptions;
    }
    get applicabilityOptions_UVCoil():Array<ApplicabilityOptionDef>{
        return this._applicabilityOptions_UVCoil;
    }
    get feederRatingBPList():Array<OptionsDef>{
        return this._feederRatingBPList;
    }
    get feederRatingBP():Array<OptionsConnectedDef>{
        return this._feederRatingBP;
    }
    public isGeneralFeederRatingBP(_id:string):boolean{
        return (this._generalFeederRatingBPIds.indexOf(_id) >= 0)
    }
    get switchingList():Array<OptionsDef>{
        return this._switchingList;
    }
    get dsBreakerPS():Array<DSBreakerPS>{
        return this._dsBreakerPS;
    }
    get forceCoolingVCBCurr():Array<OptionsConnectedDef>{
        return this._forceCoolingVCBCurr;
    }
    public isGeneralForceCoolingVCBCurr(_id:string):boolean{
        return (this._generalForceCoolingVCBCurrIds.indexOf(_id) >= 0)
    }
    get forceCooling():Array<DSForceCooling>{
        return this._forceCooling;
    }
    get locationOfFans():Array<OptionsDef>{
        return this._locationOfFans;
    }
    get silverPlt():Array<OptionsDef>{
        return this._silverPlt;
    }
    get feederTypeNBList():Array<OptionsDef>{
        return this._feederTypeNBList;
    }
    get mainBusbarCB():Array<OptionsDef>{
        return this._mainBusbarCB;
    }
    get feederConn():Array<OptionsDef>{
        return this._feederConn;
    }
    get materialMBB():Array<OptionsDef>{
        return this._materialMBB;
    }
    get htSleevesMake():Array<OptionsDef>{
        return this._htSleevesMake;
    }
    get phaseIdentification():Array<OptionsConnectedDef>{
        return this._phaseIdentification;
    }
    public isGeneralPhaseIdentification(_id:string):boolean{
        return (this._generalPhaseIdentificationIds.indexOf(_id) >= 0)
    }
    get earthBBSize():Array<OptionsConnectedDef>{
        return this._earthBBSize;
    }
    public isGeneralEarthBBSize(_id:string):boolean{
        return (this._generalEarthBBSizeIds.indexOf(_id) >= 0)
    }
    get earthBBSizeDetail():Array<OptionsDef>{
        return this._earthBBSizeDetail;
    }
    get applicFrontDrEndCvr():Array<OptionsDef>{
        return this._applicFrontDrEndCvr;
    }
    get sptColorList():Array<OptionsDef>{
        return this._sptColorList;
    }
    get typPaintProc():Array<OptionsConnectedDef>{
        return this._typPaintProc;
    }
    public isGeneralTypPaintProc(_id:string):boolean{
        return (this._generalTypPaintProcIds.indexOf(_id) >= 0)
    }
    get paintProcDoc():Array<OptionsConnectedDef>{
        return this._paintProcDoc;
    }
    public isGeneralPaintProcDoc(_id:string):boolean{
        return (this._generalPaintProcDocIds.indexOf(_id) >= 0)
    }
    get mimic():Array<OptionsDef>{
        return this._mimic;
    }
    get mimicV2():Array<OptionsDef>{
        return this._mimicV2;
    }
    get closeTripCirc():Array<OptionsDef>{
        return this._closeTripCirc;
    }
    get addTripCoil():Array<OptionsDef>{
        return this._addTripCoil;
    }
    get meteringConAux():Array<OptionsDef>{
        return this._meteringConAux;
    }
    get spaceHeater():Array<OptionsDef>{
        return this._spaceHeater;
    }
    get annunCirc():Array<OptionsDef>{
        return this._annunCirc;
    }
    get conWireTyp():Array<OptionsDef>{
        return this._conWireTyp;
    }
    get conWireTypDetail():Array<OptionsDef>{
        return this._conWireTypDetail;
    }
    get applicStand():Array<OptionsConnectedDef>{
        return this._applicStand;
    }
    public isGeneralApplicStand(_id:string):boolean{
        return (this._generalApplicStandIds.indexOf(_id) >= 0)
    }
    get insulationGrade():Array<OptionsConnectedDef>{
        return this._insulationGrade;
    }
    public isGeneralInsulationGrade(_id:string):boolean{
        return (this._generalInsulationGradeIds.indexOf(_id) >= 0)
    }
    get wireTypV2():Array<OptionsDef>{
        return this._wireTypV2;
    }
    get wireTypV2Detail():Array<OptionsDef>{
        return this._wireTypV2Detail;
    }
    get ctCirc():Array<OptionsDef>{
        return this._ctCirc;
    }
    get ctCircColor():Array<OptionsDef>{
        return this._ctCircColor;
    }
    get ptCirc():Array<OptionsDef>{
        return this._ptCirc;
    }
    get ptCircColor():Array<OptionsDef>{
        return this._ptCircColor;
    }
    get dcConCirc():Array<OptionsDef>{
        return this._dcConCirc;
    }
    get dcConCircColor():Array<OptionsDef>{
        return this._dcConCircColor;
    }
    get acConCirc():Array<OptionsDef>{
        return this._acConCirc;
    }
    get acConCircColor():Array<OptionsDef>{
        return this._acConCircColor;
    }
    get earthWire():Array<OptionsDef>{
        return this._earthWire;
    }
    get earthWireColor():Array<OptionsDef>{
        return this._earthWireColor;
    }
    get hingeDoorEarth():Array<OptionsDef>{
        return this._hingeDoorEarth;
    }
    get mainDCCirc():Array<OptionsDef>{
        return this._mainDCCirc;
    }
    get mainDCCircColor():Array<OptionsDef>{
        return this._mainDCCircColor;
    }
    get mainACCirc():Array<OptionsDef>{
        return this._mainACCirc;
    }
    get mainACCircColor():Array<OptionsDef>{
        return this._mainACCircColor;
    }
    get ferrulling():Array<OptionsDef>{
        return this._ferrulling;
    }
    get ferrullingMat():Array<OptionsDef>{
        return this._ferrullingMat;
    }
    get termBlockMat():Array<OptionsDef>{
        return this._termBlockMat;
    }
    get termBlockMake():Array<OptionsDef>{
        return this._termBlockMake;
    }
    get typeOfTermDisc():Array<OptionsDef>{
        return this._typeOfTermDisc;
    }
    get typeOfTermNonDisc():Array<OptionsDef>{
        return this._typeOfTermNonDisc;
    }
    get rackInOutMech():Array<OptionsConnectedDef>{
        return this._rackInOutMech;
    }
    public isGeneralRackInOutMech(_id:string):boolean{
        return (this._generalRackInOutMechIds.indexOf(_id) >= 0)
    }
    get ratedSingCap():Array<OptionsDef>{
        return this._ratedSingCap;
    }
    get maxArcTime():Array<OptionsDef>{
        return this._maxArcTime;
    }
    get openingTime():Array<OptionsDef>{
        return this._openingTime;
    }
    get totalBreakTime():Array<OptionsDef>{
        return this._totalBreakTime;
    }
    get closingTime():Array<OptionsDef>{
        return this._closingTime;
    }
    get ratedOpSeq():Array<OptionsDef>{
        return this._ratedOpSeq;
    }
    get cbClass():Array<OptionsDef>{
        return this._cbClass;
    }
    get maxDCComp():Array<OptionsConnectedDef>{
        return this._maxDCComp;
    }
    public isGeneralMaxDCComp(_id:string):boolean{
        return (this._generalMaxDCIds.indexOf(_id) >= 0)
    }
    get cbFreeFix():Array<OptionsDef>{
        return this._cbFreeFix;
    }
    get cbConVoltUVCoil():Array<OptionsDef>{
        return this._cbConVoltUVCoil;
    }
    get vacContType():Array<OptionsDef>{
        return this._vacContType;
    }
    get cbCloseTripVolt():Array<OptionsDef>{
        return this._cbCloseTripVolt;
    }
    get cbLatchType():Array<OptionsDef>{
        return this._cbLatchType;
    }
    get ctMould():Array<OptionsDef>{
        return this._ctMould;
    }
    get ctMouldList():Array<OptionsDef>{
        return this._ctMouldList;
    }
    get ctCbCtType():Array<OptionsDef>{
        return this._ctCbCtType;
    }
    get insulClass():Array<OptionsDef>{
        return this._insulClass;
    }
    get instruSafety():Array<OptionsDef>{
        return this._instruSafety;
    }
    get ctShortTimeCurrDr():Array<OptionsDef>{
        return this._ctShortTimeCurrDr;
    }
    get ctCbCtRatio():Array<OptionsDef>{
        return this._ctCbCtRatio;
    }
    get minPrimBalance():Array<OptionsDef>{
        return this._minPrimBalance;
    }
    get basicInsuLvl():Array<OptionsDef>{
        return this._basicInsuLvl;
    }
    get potTrafoMountingTyp():Array<OptionsConnectedValueDef>{
        return this._potTrafoMountingTyp;
    }
    public isGeneralPotTrafoMountingTyp(_id:string):boolean{
        return (this._generalPotTrafoMountingTypIds.indexOf(_id) >= 0)
    }
    get potTrafoMountingTypList():Array<OptionsDef>{
        return this._potTrafoMountingTypList;
    }
    get numRelMake():Array<OptionsDef>{
        return this._numRelMake;
    }
    get numRelMakeDetail():Array<OptionsDef>{
        return this._numRelMakeDetail;
    }
    get numRelType():Array<OptionsDef>{
        return this._numRelType;
    }
    get numRelCommPrtcl():Array<OptionsConnectedDef>{
        return this._numRelCommPrtcl;
    }
    public isGeneralNumRelCommPrtcl(_id:string):boolean{
        return (this._generalNumRelCommPrtclIds.indexOf(_id) >= 0)
    }
    get numRelCommPort():Array<OptionsConnectedDef>{
        return this._numRelCommPort;
    }
    public isGeneralNumRelCommPort(_id:string):boolean{
        return (this._generalNumRelCommPortIds.indexOf(_id) >= 0)
    }
    get numRelTimeSync():Array<OptionsDef>{
        return this._numRelTimeSync;
    }
    get numRelCoating():Array<OptionsDef>{
        return this._numRelCoating;
    }
    get numRelTransReqRTDList():Array<OptionsDef>{
        return this._numRelTransReqRTDList;
    }
    get auxRelTripCoil1_2():Array<OptionsDef>{
        return this._auxRelTripCoil1_2;
    }
    get metMultiMeterList():Array<OptionsDef>{
        return this._metMultiMeterList;
    }
    get metMultiComm():Array<OptionsDef>{
        return this._metMultiComm;
    }
    get metMultiCommPort():Array<OptionsDef>{
        return this._metMultiCommPort;
    }
    get metSpecificMake():Array<OptionsDef>{
        return this._metSpecificMake;
    }
    get metTriComm():Array<OptionsDef>{
        return this._metTriComm;
    }
    get metTriCommPort():Array<OptionsDef>{
        return this._metTriCommPort;
    }
    get metAmmType():Array<OptionsDef>{
        return this._metAmmType;
    }
    get metAmmDisplay():Array<OptionsConnectedDef>{
        return this._metAmmDisplay;
    }
    public isGeneralMetAmmDisplay(_id:string):boolean{
        return (this._generalMetAmmDisplayIds.indexOf(_id) >= 0)
    }
    get surgeArr():Array<OptionsConnectedDef>{
        return this._surgeArr;
    }
    public isGeneralSurgeArr(_id:string):boolean{
        return (this._generalSurgeArrIds.indexOf(_id) >= 0)
    }
    get typeDesg():Array<OptionsDef>{
        return this._typeDesg;
    }
    get disCurrent():Array<OptionsDef>{
        return this._disCurrent;
    }
    get annunTyp():Array<OptionsDef>{
        return this._annunTyp;
    }
    get annunCommPort():Array<OptionsDef>{
        return this._annunCommPort;
    }
    get swBreakTrip():Array<OptionsDef>{
        return this._swBreakTrip;
    }
    get swRemHandleType():Array<OptionsDef>{
        return this._swRemHandleType;
    }
    get swVoltSelector():Array<OptionsDef>{
        return this._swVoltSelector;
    }
    get ethCommArch():Array<OptionsConnectedValueDef>{
        return this._ethCommArch;
    }
    public isGeneralEthCommArch(_id:string):boolean{
        return (this._generalEthCommArchIds.indexOf(_id) >= 0)
    }
    get ethConfPopup():Array<OptionsConnectedDef>{
        return this._ethConfPopup;
    }
    public isGeneralEthConfPopup(_id:string):boolean{
        return (this._generalEthConfPopupIds.indexOf(_id) >= 0)
    }
    get ethRemComm():Array<OptionsDef>{
        return this._ethRemComm;
    }
    get ethAuxSupply():Array<OptionsDef>{
        return this._ethAuxSupply;
    }
    get ethPowerSup1_2():Array<OptionsDef>{
        return this._ethPowerSup1_2;
    }
    get ethCoating():Array<OptionsDef>{
        return this._ethCoating;
    }
    get ethMounting():Array<OptionsDef>{
        return this._ethMounting;
    }
    get erthDeviceBus():Array<OptionsDef>{
        return this._erthDeviceBus;
    }
    get erthDeviceCable():Array<OptionsDef>{
        return this._erthDeviceCable;
    }
    get splDevVolIndicator(): Array<OptionsDef> {
        return this._splDevVolIndicator;
    }
    get splDevMounting(): Array<OptionsDef> {
        return this._splDevMounting;
    }
    get splDevTempMSys(): Array<OptionsDef> {
        return this._splDevTempMSys;
    }
    get splDevSensorTyp(): Array<OptionsDef> {
        return this._splDevSensorTyp;
    }
    get splDevTmsComm(): Array<OptionsDef> {
        return this._splDevTmsComm;
    }
    get splDevList(): Array<OptionsDef> {
        return this._splDevList;
    }
    get ffrCoating():Array<OptionsDef>{
        return this._ffrCoating;
    }
    get swbActionPoints():Array<OptionsDef>{
        return this._swbActionPoints;
    }

    //properties end
    //private functions start
    private getUserNameCookie(){
        var _tmpUserName = this.getCookie('username');
        var _tmpUserEmail = this.getCookie('useremail');
        var _tmpUserGroupId = this.getCookie('uGroupId');
        if(_tmpUserName != '' && _tmpUserEmail != '' && _tmpUserGroupId != ''){
            this._userName = decodeURIComponent(_tmpUserName);
            this._userId = decodeURIComponent(_tmpUserEmail);
            this._userType = this.getUserTypeFrmUserGrpId(_tmpUserGroupId);
            this._userMyTaskGroup = this.getUserMyTaskGroupFrmUserGrpId(_tmpUserGroupId);
        }
        else{
            window.location.href = '/assets/login.html';   
        }
    }
    getUserTypeFrmUserGrpId(_userGroupId:string){
        switch(_userGroupId){
            case "001":
                return UserType.MARKETING;
            case "101":
                return UserType.HOD_MARKETING;
            case "002":
                return UserType.PROJECT_MANAGEMENT;
            case "102":
                return UserType.HOD_PROJECT_MANAGEMENT;
            case "012":
                return UserType.FINANCE;
            case "112":
                return UserType.HOD_FINANCE;
            case "003":
                return UserType.ELECTRICAL_ENGINEERING;
            case "004":
                return UserType.MECHANICAL_ENGINEERING;
            case "013":
                return UserType.C30_ENGINEERING;
            case "103":
                return UserType.HOD_ENGINEERING;
            case "005":
                return UserType.SCM;
            case "105":
                return UserType.HOD_SCM;
            case "006":
                return UserType.PURCHASE;
            case "106":
                return UserType.HOD_PURCHASE;
            case "007":
                return UserType.PRODUCTION;
            case "107":
                return UserType.HOD_PRODUCTION;
            case "008":
                return UserType.PLANNING;
            case "108":
                return UserType.HOD_PLANNING;
            case "009":
                return UserType.TESTING;
            case "109":
                return UserType.HOD_TESTING;
            case "010":
                return UserType.STORES;
            case "110":
                return UserType.HOD_STORES;
            case "011":
                return UserType.LOGISTICS;
            case "111":
                return UserType.HOD_LOGISTICS;
            case "015":
                return UserType.PLANNING_PRODUCTION;
            case "999":
                return UserType.SUPER_ADMIN;
        }

        return UserType.UNKNOWN;
    }
    getUserMyTaskGroupFrmUserGrpId(_userGroupId:string){
        switch (_userGroupId) {
            case "001":
                return MyTaskType.MARKETING;
            case "101":
                return MyTaskType.HEAD_MARKETING;
            case "002":
                return MyTaskType.PROJECT_MANAGEMENT;
            case "102":
                return MyTaskType.HEAD_PROJECT_MANAGEMENT;
            case "012":
                return MyTaskType.FINANCE;
            case "112":
                return MyTaskType.HEAD_FINANCE;
            case "003":
                return MyTaskType.ENGINEERING;
            case "004":
                return MyTaskType.ENGINEERING;
            case "013":
                return MyTaskType.ENGINEERING;
            case "103":
                return MyTaskType.HEAD_ENGINEERING;
            case "005":
                return MyTaskType.SCM;
            case "105":
                return MyTaskType.HEAD_SCM;
            case "006":
                return MyTaskType.PURCHASE_PO;
            case "106":
                return MyTaskType.HEAD_PURCHASE_PO;
            case "007":
                return MyTaskType.PRODUCTION;
            case "107":
                return MyTaskType.HEAD_PRODUCTION;
            case "008":
                return MyTaskType.PLANNING;
            case "108":
                return MyTaskType.HEAD_PLANNING;
            case "009":
                return MyTaskType.TESTING;
            case "109":
                return MyTaskType.HEAD_TESTING;
            case "010":
                return MyTaskType.STORES;
            case "110":
                return MyTaskType.HEAD_STORES;
            case "011":
                return MyTaskType.LOGISTICS;
            case "111":
                return MyTaskType.HEAD_LOGISTICS;
            case "015":
                return MyTaskType.PLANNING_PRODUCTION;
            case "999":
                return MyTaskType.ADMIN;
        }
        return MyTaskType.UNKNOWN;
    }
    public getCookie(name: string) {
        return this._cookie.get(name);
        // let ca: Array<string> = document.cookie.split(';');
        // let caLen: number = ca.length;
        // let cookieName = `${name}=`;
        // let c: string;

        // for (let i: number = 0; i < caLen; i += 1) {
        //     c = ca[i].replace(/^\s+/g, '');
        //     if (c.indexOf(cookieName) == 0) {
        //         return c.substring(cookieName.length, c.length);
        //     }
        // }
        // return '';
    }
    public setCookie(name: string, value:string, expires:Date = null){
        if(expires == null){
            var _dt = new Date();
            _dt.setMonth(_dt.getMonth() + 1);
            expires = _dt;
        }
        this._cookie.set(name, value, expires);
    }
    private getDocTypeData(_data:Array<any>,_docType:string):any{
        let _docData:any = _data.find((_tmpObj:any) =>{
            return _tmpObj.doctype == _docType;
        });
        if(_docData) return _docData.data;
        return null;
    }

    private initDefs(){

        this._yesNoOptions = [];
        this._yesNoOptions.push(new YesNoOption("yes","Yes"));
        this._yesNoOptions.push(new YesNoOption("no","No"));

        this._applicabilityOptions = [];
        this._applicabilityOptions.push(new ApplicabilityOptionDef("001","Applicable"));
        this._applicabilityOptions.push(new ApplicabilityOptionDef("002","Not Applicable"));

        this._applicabilityOptions_2 = [];
        this._applicabilityOptions_2.push(new ApplicabilityOptionDef("001","Applicable"));
        this._applicabilityOptions_2.push(new ApplicabilityOptionDef("002","Not Applicable"));
        this._applicabilityOptions_2.push(new ApplicabilityOptionDef("003","Partially Applicable"));

        let _tmpSSO: Array<SuborderNumbers> = [];
        for(var i=1; i<=99; i++) {
            let _ssoName:string = (i < 10 ? '0'+i:i+'');
            _tmpSSO.push(new SuborderNumbers(_ssoName, _ssoName, true));
        }
        this._suborderNumbers = _tmpSSO;

        let _tmpDS: Array<DatasheetNumbers> = [];
        for(var i=1; i<=10; i++) {
            let _dsName:string = (i < 10 ? '0'+i:i+'');
            _tmpDS.push(new DatasheetNumbers(_dsName, _dsName, true));
        }
        this._datasheetNumbers = _tmpDS;

        this._projStatusList = [];
        this._projStatusList.push(new ProjStatus("live", "Live Order"));
        this._projStatusList.push(new ProjStatus("hold", "Hold Order"));
        this._projStatusList.push(new ProjStatus("cancel", "To be Cancelled"));

        this._retentionPayConditions = [];
        this._retentionPayConditions.push(new retentionPaymentCondition("5%", "5%"));
        this._retentionPayConditions.push(new retentionPaymentCondition("10%", "10%"));
        this._retentionPayConditions.push(new retentionPaymentCondition("NA", "Not Applicable"));

        this._retentionMilestone = [];
        this._retentionMilestone.push(new retentionMilestone("ATDS","Against Technical document Submission"));
        this._retentionMilestone.push(new retentionMilestone("ASAC","Against Site Activity Completion"));
        this._retentionMilestone.push(new retentionMilestone("HO","Handing Over"));

        this._forLVCompDoorDetail=[]
        this._forLVCompDoorDetail.push(new OptionsDef("001","IP 5X",true));

        this._reqNonReqOptions = [];
        this._reqNonReqOptions.push(new ReqNonReqOption("001","Required"));
        this._reqNonReqOptions.push(new ReqNonReqOption("002","Not Required"));

        this._applicabilityOptions_UVCoil = [];
        this._applicabilityOptions_UVCoil.push(new ApplicabilityOptionDef("001","Applicable for All Breaker"));
        this._applicabilityOptions_UVCoil.push(new ApplicabilityOptionDef("002","Not Applicable"));
        this._applicabilityOptions_UVCoil.push(new ApplicabilityOptionDef("003","Partially Applicable"));

        this._switchingList = [];
        this._switchingList.push(new OptionsDef("001","Single",true));
        this._switchingList.push(new OptionsDef("002","B2B",true));

        this._wireTypV2Detail=[];
        this._wireTypV2Detail.push(new OptionsDef("001","Tinned Copper",true));

        this._ctCircColor=[];
        this._ctCircColor.push(new OptionsDef("001","Red-Yellow-Blue-Black",true));

        this._ptCircColor = [];
        this._ptCircColor.push(new OptionsDef("001", "Red-Yellow-Blue-Black", true));

        this._hingeDoorEarth = [];
        this._hingeDoorEarth.push(new OptionsDef("001", "Braided Copper", true));

        this._termBlockMat = [];
        this._termBlockMat.push(new OptionsDef("001", "Polymide", true));

        // The _termBlockMake & _typeOfTerm are here temporarily defined. Once the inputs are finalised from the domain experts, these should be moved to the DB driven approach.
        this._termBlockMake = [];
        this._termBlockMake.push(new OptionsDef("001", "Elmex", true));
        this._termBlockMake.push(new OptionsDef("002", "Connectwell", true));
        this._termBlockMake.push(new OptionsDef("003", "Pheonix", true));
        this._termBlockMake.push(new OptionsDef("004", "Others", true));

        this._typeOfTermDisc = [];
        this._typeOfTermDisc.push(new OptionsDef("001", "Stud Type", true));

        this._typeOfTermNonDisc = [];
        this._typeOfTermNonDisc.push(new OptionsDef("001", "Stud Type", true));
        this._typeOfTermNonDisc.push(new OptionsDef("002", "Screw Type", true));
        this._typeOfTermNonDisc.push(new OptionsDef("003", "Spring Type", true));

        this._ratedSingCap = [];
        this._ratedSingCap.push(new OptionsDef("001", "400 Amp", true));

        this._maxArcTime = [];
        this._maxArcTime.push(new OptionsDef("001", "10-15 msec", true));

        this._openingTime = [];
        this._openingTime.push(new OptionsDef("001", "35-60 msec", true));

        this._totalBreakTime = [];
        this._totalBreakTime.push(new OptionsDef("001", "45-75 msec", true));

        this._closingTime = [];
        this._closingTime.push(new OptionsDef("001", "<80 ms", true));

        this._ratedOpSeq = [];
        this._ratedOpSeq.push(new OptionsDef("001", "O - 0.3Sec- CO-3MIN-CO", true));

        this._cbClass = [];
        this._cbClass.push(new OptionsDef("001", "E2, M2 & C2", true));

        this._cbFreeFix = [];
        this._cbFreeFix.push(new OptionsDef("001", "Trip Free", true));


        this._vacContType = [];
        this._vacContType.push(new OptionsDef("001", "Convac", true));

        this._ctCbCtType = [];
        this._ctCbCtType.push(new OptionsDef("001", "Dia", true));
        this._ctCbCtType.push(new OptionsDef("002", "L x W in mm", true));

        this._minPrimBalance = [];
        this._minPrimBalance.push(new OptionsDef("001", "5 Amp", true));

        this._basicInsuLvl = [];
        this._basicInsuLvl.push(new OptionsDef("001", "3 kV", true));

        this._numRelType = [];
        this._numRelType.push(new OptionsDef("001", "Numerical", true));

        this._typeDesg = [];
        this._typeDesg.push(new OptionsDef("001", "Metal Oxide", true));

        this._disCurrent = [];
        this._disCurrent.push(new OptionsDef("001", "10kA", true));

        this._splDevTmsComm = [];
        this._splDevTmsComm.push(new OptionsDef("001", "Modbus RS485", true));

        this._swbActionPoints = [];
        this._swbActionPoints.push(new OptionsDef("001", "Marketing Team", true));
        this._swbActionPoints.push(new OptionsDef("002", "Project Management Team", true));
        this._swbActionPoints.push(new OptionsDef("003", "Electrical Engineering Team", true));
        this._swbActionPoints.push(new OptionsDef("004", "Mechanical Engineering Team", true));
        this._swbActionPoints.push(new OptionsDef("005", "SCM Team", true));
        this._swbActionPoints.push(new OptionsDef("006", "Planning & Fulfilment", true));
        this._swbActionPoints.push(new OptionsDef("007", "Purchase", true));
        this._swbActionPoints.push(new OptionsDef("008", "Production", true));
        this._swbActionPoints.push(new OptionsDef("009", "Quality", true));

    }
    private heartBeatInterval:number = 15000;
    private isHeartBeatInitiated:boolean = false;
    private initSocketIO():void{
    this.socket = io(this.url);
        
        this.serverEventSubscriber = <Subject<any>> new Subject();

        this.socket.on('connect', () => {
            console.log('socket connected');
            if(this.isHeartBeatInitiated == false){
                this.isHeartBeatInitiated = true;
                setInterval(() => {
                    this.socket.emit('event',{"command":"heartbeat"});
                }, this.heartBeatInterval);
            }
            
        });


        this.socket.on('solockfail', (_data) => {
            //console.log('inside solockfail pointer', this.serverEventSubscriber)
            this.serverEventSubscriber.next([ServerSockEvent.SOLOCKFAIL, _data]);
        });

        this.socket.on('disconnect', function(){
             console.log('socket disconnected');
         });
    }
  
        
    private addDay(_dayTime:number):number{
        return _dayTime + (24 * 60 * 60 * 1000);
    }
    private checkAuthentication(_body){
        if(_body.status == 407){
            window.location.href = '/assets/login.html';
        }
    }
//.........private functions end......
    
//......public functions start.....

    public openSnackbar(_message:string, _action:string, _duration:number = 2000){
        this.snackBar.open(_message, _action, {
            duration: _duration,
          });
    }
    private loaderDialogRef:MatDialogRef<LoaderDialog> = null;
    public openLoader(){
        // if(this.loaderDialogRef){
        //     this.loaderDialogRef.close()
        // }
        // this.loaderDialogRef = this.dialog.open(LoaderDialog, {
        //     width: '250px',
        //     data: {  }
        //   });
    }
    public closeLoader(){
        // if(this.loaderDialogRef){
        //     this.loaderDialogRef.close();
        //     this.loaderDialogRef = null;
        // }
    }

    public triggerServerEvent(_commandType:string, _commandData:any){
        if(this.isHeartBeatInitiated){
            this.socket.emit('event',{"command":_commandType,"data":_commandData});
        }
    }
    subscribeToClientEvents():Observable<any>{
        if(this.serverEventSubscriber){
            return this.serverEventSubscriber.asObservable();
        }
        return null;
    }
    
    saveSalesOrder(_soOrder:SalesOrder):Observable<any>{
        let jsonObj:any = _soOrder.getJson();
        this.openLoader();
        let saveResp = this.http.post(DataService.saveSalesOrder,{"_data":jsonObj})
                .pipe(map((res:any) =>{ 
                    this.closeLoader();
                    let respJson = res;
                    this.checkAuthentication(respJson);
                    return respJson;
                }))
                .pipe(catchError((error:any) => throwError(error.json().error || 'Server error')))
        return saveResp;
    }
    // deleteSalesOrder(_soOrder:SalesOrder, _deleteReason:string):Observable<boolean>{
    //     this.openLoader();
    //     let saveResp = this.http.post(DataService.deleteSalesOrder,{"salesOrderId":_soOrder.salesOrderId,"deleteReason":_deleteReason})
    //             .pipe(map((res:any) =>{ 
    //                 this.closeLoader();
    //                 let respJson = res;
    //                 this.checkAuthentication(respJson);
    //                 if(respJson.status=="OK"){
    //                     return true;
    //                 }
    //                 else 
    //                     return false;
    //             })
    //             .pipe(catchError((error:any) => throwError(error.json().error || 'Server error')))
    //     return saveResp;
    // }

    deleteSalesOrder(_soOrder:SalesOrder, _deleteReason:string):Observable<boolean>{
        let jsonObj:any = _soOrder.getJson();
        this.openLoader();
        let saveResp = this.http.post(DataService.deleteSalesOrder,{"data":jsonObj,"deleteReason":_deleteReason})
                .pipe(map((res:any) =>{ 
                    this.closeLoader();
                    let respJson = res;
                    this.checkAuthentication(respJson);
                    if(respJson.status=="OK"){
                        return true;
                    }
                    else 
                        return false;
                }))
                .pipe(catchError((error:any) => throwError(error.json().error || 'Server error')))
        return saveResp;
    }

    deleteSubSalesOrder(_soOrder:SalesOrder,_soOrderdel:SalesOrder, _deleteReason:string):Observable<boolean>{
        let jsonObj:any = _soOrder.getJson();
        let jsonObjDel:any = _soOrderdel.getJson();
        this.openLoader();
        let saveResp = this.http.post(DataService.deleteSubSalesOrder,{"data":jsonObj,"datadel":jsonObjDel,"deleteReason":_deleteReason})
                .pipe(map((res:any) =>{ 
                    this.closeLoader();
                    let respJson = res;
                    this.checkAuthentication(respJson);
                    return respJson;
                }))
                .pipe(catchError((error:any) => throwError(error.json().error || 'Server error')))
        return saveResp;
    }
    deleteDatasheet(_soOrder:SalesOrder,_soOrderdel:SalesOrder, _deleteReason:string):Observable<boolean>{
        let jsonObj:any = _soOrder.getJson();
        let jsonObjDel:any = _soOrderdel.getJson();
        this.openLoader();
        let saveResp = this.http.post(DataService.deleteDatasheet,{"data":jsonObj,"datadel":jsonObjDel,"deleteReason":_deleteReason})
                .pipe(map((res:any) =>{ 
                    this.closeLoader();
                    let respJson = res;
                    this.checkAuthentication(respJson);
                    return respJson;
                }))
                .pipe(catchError((error:any) => throwError(error.json().error || 'Server error')))
        return saveResp;
    }
    getCachedAllSaleOrders(_opt:number = 0):Array<SalesOrder>{
        return this._soLoadDataArray[_opt];
    }

    getCachedAllSaleOrdersPR(_opt:number = 0):Array<SalesOrder>{
        return this._soLoadDataArrayPR[_opt];
    }
    getCachedAllSaleOrders_2(_opt:number = 0):Array<SalesOrder>{
        return this._soLoadDataArray_2[_opt];
    }
    getAllSalesOrder(_opt:number = 0):Observable<Array<SalesOrder>>{
        if(this._soReqTimeArray[_opt] && (((new Date()).getTime() - this._soReqTimeArray[_opt])/1000 < 5)){
            //if same request happends to be with 5 seconds, serve cached data
            let _repSub:ReplaySubject<Array<SalesOrder>> = new ReplaySubject<Array<SalesOrder>>();
            _repSub.next(this._soLoadDataArray[_opt]);
            return _repSub;
        }
        this.openLoader();
        let getResp = this.http.post(DataService.getAllSalesOrderUrl,{"opt":_opt,"loadtime":(this._soLoadTimeArray[_opt]?this._soLoadTimeArray[_opt]:0)})
        .pipe(map((res:any) =>{ 
            this.closeLoader();
            let respJson = res;
            this.checkAuthentication(respJson);
            if (respJson.status == "OK") {
                let _salesOrderObjList: Array<SalesOrder> = [];
                for (var i = 0; i < respJson.data.length; i++) {
                    _salesOrderObjList.push(SalesOrder.getObj(respJson.data[i].soData, respJson.data[i].tStamp));
                }

                this._soLoadDataArray[_opt] = _salesOrderObjList;
                this._soLoadTimeArray[_opt] = respJson.loadTime;
                this._soReqTimeArray[_opt] = new Date();

                return _salesOrderObjList;
            }
            else if (respJson.status == "NOUPDATE") {
                this._soReqTimeArray[_opt] = new Date();
                return this._soLoadDataArray[_opt];
            }
            else {
                return [];
            }
        }))
        .pipe(catchError((error:any) => throwError(error || 'Server error')))
        return getResp;
    }

    getAllSalesOrder_PR(_opt:number = 0):Observable<Array<SalesOrder>>{
        if(this._soReqTimeArrayPR[_opt] && (((new Date()).getTime() - this._soReqTimeArrayPR[_opt])/1000 < 5)){
            //if same request happends to be with 5 seconds, serve cached data
            let _repSub:ReplaySubject<Array<SalesOrder>> = new ReplaySubject<Array<SalesOrder>>();
            _repSub.next(this._soLoadDataArrayPR[_opt]);
            return _repSub;
        }
        this.openLoader();
        let getResp = this.http.post(DataService.getAllSalesOrderUrlPR,{"opt":_opt,"loadtime":(this._soLoadTimeArrayPR[_opt]?this._soLoadTimeArrayPR[_opt]:0)})
        .pipe(map((res:any) =>{ 
            this.closeLoader();
            let respJson = res;
            this.checkAuthentication(respJson);
            if (respJson.status == "OK") {
                let _salesOrderObjList: Array<SalesOrder> = [];
                for (var i = 0; i < respJson.data.length; i++) {
                    _salesOrderObjList.push(SalesOrder.getObj(respJson.data[i].soData, respJson.data[i].tStamp));
                }

                this._soLoadDataArrayPR[_opt] = _salesOrderObjList;
                this._soLoadTimeArrayPR[_opt] = respJson.loadTime;
                this._soReqTimeArrayPR[_opt] = new Date();

                return _salesOrderObjList;
            }
            else if (respJson.status == "NOUPDATE") {
                this._soReqTimeArrayPR[_opt] = new Date();
                return this._soLoadDataArrayPR[_opt];
            }
            else {
                return [];
            }
        }))
        .pipe(catchError((error:any) => throwError(error || 'Server error')))
        return getResp;
    }
    getAllSalesOrder_2(_opt:number = 0):Observable<Array<SalesOrder>>{
        if(this._soReqTimeArray_2[_opt] && (((new Date()).getTime() - this._soReqTimeArray_2[_opt])/1000 < 5)){
            //if same request happends to be with 5 seconds, serve cached data
            let _repSub:ReplaySubject<Array<SalesOrder>> = new ReplaySubject<Array<SalesOrder>>();
            _repSub.next(this._soLoadDataArray_2[_opt]);
            return _repSub;
        }
        this.openLoader();
        let getResp = this.http.post(DataService.getAllSalesOrderUrl_2,{"opt":_opt,"loadtime":(this._soLoadTimeArray_2[_opt]?this._soLoadTimeArray_2[_opt]:0)})
        .pipe(map((res:any) =>{ 
            setTimeout(() => {
            this.closeLoader();
              }, 1);
            let respJson = res;
            this.checkAuthentication(respJson);
            if (respJson.status == "OK") {
                let _salesOrderObjList: Array<SalesOrder> = [];
                for (var i = 0; i < respJson.data.length; i++) {
                    _salesOrderObjList.push(SalesOrder.getObj(respJson.data[i].soData, respJson.data[i].tStamp));
                }

                this._soLoadDataArray_2[_opt] = _salesOrderObjList;
                this._soLoadTimeArray_2[_opt] = respJson.loadTime;
                this._soReqTimeArray_2[_opt] = new Date();

                return _salesOrderObjList;
            }
            else if (respJson.status == "NOUPDATE") {
                this._soReqTimeArray_2[_opt] = new Date();
                return this._soLoadDataArray_2[_opt];
            }
            else {
                return [];
            }
        }))
        .pipe(catchError((error:any) => throwError(error || 'Server error')))
        return getResp;
    }
    getSalesOrder(_soId:string):Observable<SalesOrder>{
        this.openLoader();
        let getResp = this.http.post(DataService.getSalesOrder,{"_soId":_soId})
        .pipe(map((res:any) =>{ 
            this.closeLoader();
            let respJson = res;
            this.checkAuthentication(respJson);
            if(respJson.status=="OK"){
                return SalesOrder.getObj(respJson.data[0].data,respJson.data[0]._ts);
            }
            return null;
        }))
        .pipe(catchError((error:any) => throwError(error || 'Server error')))
        return getResp;
    }
    getSalesOrder_2(_soNo:string):Observable<SalesOrder>{
        setTimeout(() => {
            this.openLoader();  
          }, 1);
        let getResp = this.http.post(DataService.getSalesOrder_2,{"_soNo":_soNo})
        .pipe(map((res:any) =>{ 
            this.closeLoader();
            let respJson = res;
            this.checkAuthentication(respJson);
            if(respJson.status=="OK"){
                return SalesOrder.getObj(respJson.data[0].data,respJson.data[0]._ts);
            }
            return null;
        }))
        .pipe(catchError((error:any) => throwError(error || 'Server error')))
        return getResp;
    }

    getSalesOrderByCustomerName(_customerName:string):Observable<Array<SalesOrder>>{
        setTimeout(() => {
            this.openLoader();
        }, 1);

        let getResp = this.http.post(DataService.getSalesOrderByCustomerName, {"customer_name":_customerName})
        .pipe(map((res:any) =>{
            this.closeLoader();
            let respJson = res;
            this.checkAuthentication(respJson);

            if(respJson.status == "OK"){
                let _salesOrderList:Array<SalesOrder> = [];
                for(var i=0; i< respJson.data.length; i++){
                    _salesOrderList.push(SalesOrder.getObj(respJson.data[i].data,respJson.data[i]._ts));
                }
                return _salesOrderList;
            }
            return [];
        }))
        .pipe(catchError((error:any) => throwError(error || 'Server error')))
        return getResp;
    }

    getUserList():Observable<Array<User>>{
        this.openLoader();
        let getResp = this.http.post(DataService.getUserListUrl,{})
        .pipe(map((res:any) =>{ 
            this.closeLoader();
            let respJson = res;
            this.checkAuthentication(respJson);
            if(respJson.status == "OK") {
                let _tmpUserList:Array<User> = [];
                for(var i=0; i< respJson.data.length; i++){
                    _tmpUserList.push(
                        User.getObj(respJson.data[i])
                    );
                }
                _tmpUserList.sort((_a:User, _b:User) => {
                    if(_a.userEmail < _b.userEmail) return -1;
                    if(_a.userEmail > _b.userEmail) return 1;
                    return 0;
                });
                return _tmpUserList;
            }               
            
            return null;
        }))
        .pipe(catchError((error:any) => throwError(error || 'Server error')))
        return getResp;
    }

    getSOLock(_soId:string):Observable<any>{
        this.openLoader();
        let getResp = this.http.post(DataService.getSOLockUrl,{"soId":_soId})
        .pipe(map((res:any) =>{ 
            this.closeLoader();
            let respJson = res;
            this.checkAuthentication(respJson);
            
            return respJson;
        }))
        .pipe(catchError((error:any) => throwError(error || 'Server error')))
        return getResp;
    }

    releaseSOLock(_soId:string):Observable<any>{
        this.openLoader();
        let getResp = this.http.post(DataService.releaseSOLockUrl,{"soId":_soId})
        .pipe(map((res:any) =>{ 
            this.closeLoader();
            let respJson = res;
            this.checkAuthentication(respJson);
            
            return respJson;
        }))
        .pipe(catchError((error:any) => throwError(error || 'Server error')))
        return getResp;
    }


    getDataDefinitions():Observable<boolean>{
        //this.openLoader();
        if(this._dataDefsLoadTime != null){
            let _repSub:ReplaySubject<boolean> = new ReplaySubject<boolean>();
            _repSub.next(true);
            return _repSub;
        }
        let deflist = this.http.post(DataService.getDataDefinitionsUrl, {})
        .pipe(map((res:any) => {
            //this.closeLoader();
            let respJson = res;
            this.checkAuthentication(respJson);
            if(respJson.status == "OK"){
                let _tmpPlants: Array<Plant> = [];
                let _rawPlantData:any = this.getDocTypeData(respJson.data,'pm_plants');
                if(_rawPlantData != null){
                    for(var i=0; i<_rawPlantData.list.length; i++) {
                        if(_rawPlantData.list[i].is_active === true){
                            _tmpPlants.push(new Plant(_rawPlantData.list[i].plant_id, _rawPlantData.list[i].plant_name,_rawPlantData.list[i].is_active));
                        }
                        
                    }
                    this._plants = _tmpPlants;
                }                    

                let _tmpRegions: Array<Region> = [];
                let _rawRegionData:any = this.getDocTypeData(respJson.data,'pm_regions');
                if(_rawRegionData != null) {
                    for(var i=0; i<_rawRegionData.list.length; i++) {
                        if(_rawRegionData.list[i].is_active === true){
                            _tmpRegions.push(new Region(_rawRegionData.list[i].region_id, _rawRegionData.list[i].region_name, _rawRegionData.list[i].is_active));
                        }
                        
                    }
                    this._regions = _tmpRegions;
                }

                let _tmpOrderTypes: Array<OrderType> = [];
                let _rawOrderTypeData: any = this.getDocTypeData(respJson.data,'pm_ordertype');
                if(_rawOrderTypeData != null){
                    for(var i=0; i<_rawOrderTypeData.list.length;i++){
                        if(_rawOrderTypeData.list[i].is_active === true){
                            _tmpOrderTypes.push(new OrderType(_rawOrderTypeData.list[i].ordertype_id,_rawOrderTypeData.list[i].ordertype_name,_rawOrderTypeData.list[i].is_active));
                        }
                        
                        
                    }
                    this._ordertypes = _tmpOrderTypes;
                }

                let _tmpRelayConfigs: Array<RelayConfig> = [];
                let _tmpRelayConfigsUI: Array<RelayConfigUI> = [];
                let _rawRelayConfigData: any = this.getDocTypeData(respJson.data,'pm_relayconfig');
                if(_rawRelayConfigData != null){
                    for(var i=0; i<_rawRelayConfigData.list.length;i++){
                        if(_rawRelayConfigData.list[i].is_active === true){
                            _tmpRelayConfigs.push(new RelayConfig(_rawRelayConfigData.list[i].relayconfig_id,_rawRelayConfigData.list[i].relayconfig_name,_rawRelayConfigData.list[i].is_active));
                            _tmpRelayConfigsUI.push(new RelayConfigUI(_rawRelayConfigData.list[i].relayconfig_id,_rawRelayConfigData.list[i].relayconfig_name,_rawRelayConfigData.list[i].is_active));
                        }
                        
                        
                    }
                    this._relayconfigs = _tmpRelayConfigs;

                    //THIS IS TO ADD ANOTHER OPTION IN THE RELAY CONFIG FILTER IN THE UI
                    this._relayconfigs_ui = _tmpRelayConfigsUI;
                    this._relayconfigs_ui.push(new RelayConfigUI(null,"NA",true)); 

                    
                }
                   
                let _tmpSaleChannel: Array<SaleChannel> = [];
                let _rawSaleChannelData:any = this.getDocTypeData(respJson.data,'pm_saleChannels');
                if(_rawSaleChannelData != null) {
                    for(var i=0; i<_rawSaleChannelData.list.length; i++) {
                        if(_rawSaleChannelData.list[i].is_active === true){
                            _tmpSaleChannel.push(new SaleChannel(_rawSaleChannelData.list[i].sale_channel_id, _rawSaleChannelData.list[i].sale_channel_name, _rawSaleChannelData.list[i].is_active));
                        }
                        
                    }
                    this._saleChannels = _tmpSaleChannel;
                }

                let _tmpPm: Array<ProjectManager> = [];
                let _rawPMData:any = this.getDocTypeData(respJson.data,'pm_projectManagers');
                if(_rawPMData != null) {
                    for(var i=0; i<_rawPMData.list.length; i++) {
                        if(_rawPMData.list[i].is_active === true){
                            _tmpPm.push(new ProjectManager(_rawPMData.list[i].project_manager_id, _rawPMData.list[i].project_manager_name,_rawPMData.list[i].email_id, _rawPMData.list[i].is_active));
                        }
                        
                    }
                    _tmpPm.sort((_a:ProjectManager,_b:ProjectManager) => {
                        return ('' + _a.projectManagerName).localeCompare(_b.projectManagerName);
                    });
                    this._projectManagers = _tmpPm;
                }
                
                let _tmpPe: Array<ProjectEngineer> = [];
                let _rawPEData:any = this.getDocTypeData(respJson.data,'pm_projectEngineers');
                if(_rawPEData != null) {
                    for(var i=0; i<_rawPEData.list.length; i++) {
                        if(_rawPEData.list[i].is_active === true){
                            _tmpPe.push(new ProjectEngineer(_rawPEData.list[i].project_engineer_id, _rawPEData.list[i].project_engineer_name,_rawPEData.list[i].email_id, _rawPEData.list[i].is_active));
                        }
                        
                    }
                    _tmpPe.sort((_a:ProjectEngineer,_b:ProjectEngineer) => {
                        return ('' + _a.projectEngineerName).localeCompare(_b.projectEngineerName);
                    });
                    this._projectEngineers = _tmpPe;
                }
                
                let _tmpPV: Array<ProductVariant> = [];
                let _rawPVData:any = this.getDocTypeData(respJson.data,'pm_productVariants');
                if(_rawPVData != null) {
                    for(var i=0; i<_rawPVData.list.length; i++) {
                        if(_rawPVData.list[i].is_active === true){
                            _tmpPV.push(new ProductVariant(_rawPVData.list[i].product_variant_id, _rawPVData.list[i].product_variant_name, _rawPVData.list[i].engg_efforts, _rawPVData.list[i].is_active));
                        }
                        
                    }
                    configDefs.defTypeOfProducts = _tmpPV;
                    this._productVariants = _tmpPV;
                }

                let _tmpET: Array<EquipmentType> = [];
                let _tmpGnrlEquipTypeIds: Array<string> = [];
                let _rawETData:any = this.getDocTypeData(respJson.data,'pm_typeOfEquipments');
                if(_rawETData != null) {
                    for(var i=0; i<_rawETData.list.length; i++) {
                        if(_rawETData.list[i].is_active === true){
                            _tmpET.push(new EquipmentType(_rawETData.list[i].equipment_type_id, _rawETData.list[i].equipment_type_name,_rawETData.list[i].variant_ids, _rawETData.list[i].is_active));

                            if(_rawETData.list[i].variant_ids.length == 0){
                                _tmpGnrlEquipTypeIds.push(_rawETData.list[i].equipment_type_id);
                            }
                        }
                        
                    }
                    this._typeOfEquipments = _tmpET;
                    this._generalEquipmentTypeIds = _tmpGnrlEquipTypeIds;
                }

                let _tmpMDE: Array<MechanicalDesignEngineer> = [];
                let _rawMDEData:any = this.getDocTypeData(respJson.data,'pm_designEngineers');
                if(_rawMDEData != null) {
                    for(var i=0; i<_rawMDEData.list.length; i++) {
                        if(_rawMDEData.list[i].is_active === true){
                            _tmpMDE.push(new MechanicalDesignEngineer(_rawMDEData.list[i].design_engineer_id, _rawMDEData.list[i].design_engineer_name,_rawMDEData.list[i].email_id, _rawMDEData.list[i].is_active));
                        }
                        
                    }
                    this._mechanicalDesignEngineer = _tmpMDE;
                }

                let _tmpAPP: Array<AdvancePayPercent> = [];
                let _rawAPPData:any = this.getDocTypeData(respJson.data,'pm_advancePayPercents');
                if(_rawAPPData != null) {
                    for(var i=0; i<_rawAPPData.list.length; i++) {
                        if(_rawAPPData.list[i].is_active === true){}
                        _tmpAPP.push(new AdvancePayPercent(_rawAPPData.list[i].advance_pay_percent_id, _rawAPPData.list[i].advance_pay_percent_display, _rawAPPData.list[i].advance_pay_percent_value, _rawAPPData.list[i].is_active));
                    }
                    this._advancePayPercents = _tmpAPP;
                }

                let _tmpAPM: Array<AdvancePayMilestone> = [];
                let _rawAPMData:any = this.getDocTypeData(respJson.data,'pm_advancePayMilestones');
                if(_rawAPMData != null) {
                    for(var i=0; i<_rawAPMData.list.length; i++) {
                        if(_rawAPMData.list[i].is_active === true){
                            _tmpAPM.push(new AdvancePayMilestone(_rawAPMData.list[i].advance_pay_milestone_id, _rawAPMData.list[i].advance_pay_milestone_name, _rawAPMData.list[i].is_active));
                        }
                        
                    }
                    this._advancePayMilestones = _tmpAPM;
                }

                let _tmpAPMAbgAcg: Array<AdvancePayMilestone> = [];
                _tmpAPMAbgAcg.push(new AdvancePayMilestone("001","Along with Order",true));
                _tmpAPMAbgAcg.push(new AdvancePayMilestone("002","Against Drawing Approval",true));
                _tmpAPMAbgAcg.push(new AdvancePayMilestone("003","Against MFC",true));
                _tmpAPMAbgAcg.push(new AdvancePayMilestone("004","Against PO placement",true));
                _tmpAPMAbgAcg.push(new AdvancePayMilestone("005","Against Raw Material Identification",true));
                _tmpAPMAbgAcg.push(new AdvancePayMilestone("000","Not Applicable",true));

                this._advancePayMilestonesABGACG = _tmpAPMAbgAcg;

                let _tmpAPC: Array<AdvancePayCondition> = [];
                let _rawAPCData:any = this.getDocTypeData(respJson.data,'pm_advancePayConditions');
                if(_rawAPCData != null) {
                    for(var i=0; i<_rawAPCData.list.length; i++) {
                        if(_rawAPCData.list[i].is_active === true){
                            _tmpAPC.push(new AdvancePayCondition(_rawAPCData.list[i].advance_pay_condition_id, _rawAPCData.list[i].advance_pay_condition_name, _rawAPCData.list[i].is_active));
                        }
                        
                    }
                    this._advancePayConditions = _tmpAPC;
                }

                let _tmpLDP: Array<LDPercentDef> = [];
                let _rawLDPData:any = this.getDocTypeData(respJson.data,'pm_ldPercentList');
                if(_rawLDPData != null) {
                    for(var i=0; i<_rawLDPData.list.length; i++) {
                        if(_rawLDPData.list[i].is_active === true){
                            _tmpLDP.push(new LDPercentDef(_rawLDPData.list[i].ld_percent_id, _rawLDPData.list[i].ld_percent_name, _rawLDPData.list[i].is_active));
                        }
                       
                    }
                    this._ldPercentList = _tmpLDP;
                }

                let _tmpLDCAP: Array<LDCAPDef> = [];
                let _rawLDCAPData:any = this.getDocTypeData(respJson.data,'pm_ldCapList');
                if(_rawLDCAPData != null) {
                    for(var i=0; i<_rawLDCAPData.list.length; i++) {
                        if(_rawLDCAPData.list[i].is_active === true){
                            _tmpLDCAP.push(new LDCAPDef(_rawLDCAPData.list[i].ld_cap_id, _rawLDCAPData.list[i].ld_cap_name, _rawLDCAPData.list[i].is_active));
                        }
                        
                    }
                    this._ldCAPList = _tmpLDCAP;
                }

                let _tmpDTD: Array<DeliveryTermDef> = [];
                let _rawDTDData:any = this.getDocTypeData(respJson.data,'pm_deliveryTermList');
                if(_rawDTDData != null) {
                    for(var i=0; i<_rawDTDData.list.length; i++) {
                        if(_rawDTDData.list[i].is_active === true){
                            _tmpDTD.push(new DeliveryTermDef(_rawDTDData.list[i].delivery_term_id, _rawDTDData.list[i].delivery_term_name, _rawDTDData.list[i].is_active));
                        }
                        
                    }
                    this._deliveryTermList = _tmpDTD;
                }

                let _tmpPTD: Array<PaymentTermDef> = [];
                let _rawPTDData:any = this.getDocTypeData(respJson.data,'pm_paymentTermList');
                if(_rawPTDData != null) {
                    for(var i=0; i<_rawPTDData.list.length; i++) {
                        if(_rawPTDData.list[i].is_active === true){
                            _tmpPTD.push(new PaymentTermDef(_rawPTDData.list[i].payment_term_id, _rawPTDData.list[i].payment_term_name, _rawPTDData.list[i].is_active));
                        }
                        
                    }
                    this._paymentTermList = _tmpPTD;
                }

                let _tmpBMD: Array<BusbarMaterialDef> = [];
                let _rawBMDData:any = this.getDocTypeData(respJson.data,'pm_busbarMaterialList');
                if(_rawBMDData != null) {
                    for(var i=0; i<_rawBMDData.list.length; i++) {
                        if(_rawBMDData.list[i].is_active === true){
                            _tmpBMD.push(new BusbarMaterialDef(_rawBMDData.list[i].busbar_material_id, _rawBMDData.list[i].busbar_material_name, _rawBMDData.list[i].is_active));
                        }
                        
                    }
                    this._busbarMaterialList = _tmpBMD;
                }

                let _tmpBSD: Array<BusbarSleeveDef> = [];
                let _rawBSDData:any = this.getDocTypeData(respJson.data,'pm_busbarSleeves');
                if(_rawBSDData != null) {
                    for(var i=0; i<_rawBSDData.list.length; i++) {
                        if(_rawBSDData.list[i].is_active === true){
                            _tmpBSD.push(new BusbarSleeveDef(_rawBSDData.list[i].busbar_sleeve_id, _rawBSDData.list[i].busbar_sleeve_name, _rawBSDData.list[i].is_active));
                        }
                        
                    }
                    this._busbarSleeves = _tmpBSD;
                }

                let _tmpPND: Array<PanelNumDef> = [];
                let _rawPNDData:any = this.getDocTypeData(respJson.data,'pm_noOfPanelsList');
                if(_rawPNDData != null) {
                    for(var i=0; i<_rawPNDData.list.length; i++) {
                        if(_rawPNDData.list[i].is_active === true){
                            _tmpPND.push(new PanelNumDef(_rawPNDData.list[i].panel_id, _rawPNDData.list[i].panel_name,  _rawPNDData.list[i].engg_efforts, _rawPNDData.list[i].is_active));
                        }
                        
                    }
                    configDefs.defNoOfPanels = _tmpPND;
                    this._noOfPanelsList = _tmpPND;
                }

                let _tmpFTD: Array<FeederTypeDef> = [];
                let _rawFTDData:any = this.getDocTypeData(respJson.data,'pm_noOfFeederTypeList');
                if(_rawFTDData != null) {
                    for(var i=0; i<_rawFTDData.list.length; i++) {
                        if(_rawFTDData.list[i].is_active === true){
                            _tmpFTD.push(new FeederTypeDef(_rawFTDData.list[i].feeder_type_id, _rawFTDData.list[i].feeder_type_name, _rawFTDData.list[i].engg_efforts ,_rawFTDData.list[i].is_active));
                        }
                        
                    }
                    configDefs.defNoOfFeederList = _tmpFTD;
                    this._noOfFeederTypeList = _tmpFTD;
                }

                let _tmpJCD: Array<JobComplexityDef> = [];
                let _rawJCDData:any = this.getDocTypeData(respJson.data,'pm_jobComplexityList');
                if(_rawJCDData != null) {
                    for(var i=0; i<_rawJCDData.list.length; i++) {
                        if(_rawJCDData.list[i].is_active === true){
                            _tmpJCD.push(new JobComplexityDef(_rawJCDData.list[i].job_complexity_id, _rawJCDData.list[i].job_complexity_name, _rawJCDData.list[i].engg_efforts, _rawJCDData.list[i].is_active));
                        }
                        
                    }
                    configDefs.defComplexityOfJobs = _tmpJCD;
                    this._jobComplexityList = _tmpJCD;
                }

                let _tmpJPD: Array<JobPriorityDef> = [];
                let _rawJPDData:any = this.getDocTypeData(respJson.data,'pm_jobPriorityList');
                if(_rawJPDData != null) {
                    for(var i=0; i<_rawJPDData.list.length; i++) {
                        if(_rawJPDData.list[i].is_active === true){
                            _tmpJPD.push(new JobPriorityDef(_rawJPDData.list[i].job_priority_id, _rawJPDData.list[i].job_priority_name, _rawJPDData.list[i].engg_efforts , _rawJPDData.list[i].is_active));
                        }
                        
                    }
                    configDefs.defjobPriorityList = _tmpJPD;
                    this._jobPriorityList = _tmpJPD;
                }

                let _tmpConfig: Array<ConfigItems> = [];
                let _rawConfigData:any = this.getDocTypeData(respJson.data,'pm_configItems');
                if(_rawConfigData != null) {
                    for(var i=0; i<_rawConfigData.list.length; i++) {
                        if(_rawConfigData.list[i].is_active === true){
                            _tmpConfig.push(new ConfigItems(_rawConfigData.list[i].conf_id, _rawConfigData.list[i].conf_name, _rawConfigData.list[i].conf_para_name , _rawConfigData.list[i].conf_type , _rawConfigData.list[i].conf_value , _rawConfigData.list[i].order_no , _rawConfigData.list[i].is_active));
                            // if(_rawConfigData.list[i].conf_id == "001"){
                            //     configDefs.defSOCreationDays =  parseInt(_rawConfigData.list[i].conf_value);
                            // }
                            switch(_rawConfigData.list[i].conf_id){
                                case "001": configDefs.defSOCreationDays =  parseInt(_rawConfigData.list[i].conf_value);
                                            break;
                                case "002": configDefs.defSOReleaseDays =  parseInt(_rawConfigData.list[i].conf_value);
                                            break;                                                 
                                case "003":	 configDefs.defPlndOrdrHandidODDays =  parseInt(_rawConfigData.list[i].conf_value);
                                            break;   
                                // case "004": configDefs.defPlndSLDSubmissDays =  parseInt(_rawConfigData.list[i].conf_value);
                                //             break;   
                                case "005": configDefs.defPlndSchDrwBOMSubmissDays =  parseInt(_rawConfigData.list[i].conf_value);
                                            break;   
                                case "006": configDefs.defGAFDrwSubmissDays =  parseInt(_rawConfigData.list[i].conf_value);
                                            break;   
                                case "007": configDefs.defPlndGTPCTPTBBSizCalSubmissDays =  parseInt(_rawConfigData.list[i].conf_value);
                                            break;   
                                case "008": configDefs.defPlndDrawingApprovalDays =  parseInt(_rawConfigData.list[i].conf_value);
                                            break;   
                                case "009": configDefs.defPlndC40Days =  parseInt(_rawConfigData.list[i].conf_value);
                                            break;   
                                case "010": configDefs.defPlndC50Days =  parseInt(_rawConfigData.list[i].conf_value);
                                            break;   
                                case "011": configDefs.defPlndC60Days =  parseInt(_rawConfigData.list[i].conf_value);
                                            break;   
                                case "012": configDefs.defPlndImpBrkPORlsDays =  parseInt(_rawConfigData.list[i].conf_value);
                                            break;   
                                case "013": configDefs.defPlndImpVSCPORlsDays =  parseInt(_rawConfigData.list[i].conf_value);
                                            break;   
                                case "014": configDefs.defPlndAlstomGERlyPORlsDays =  parseInt(_rawConfigData.list[i].conf_value);
                                            break;   
                                case "015": configDefs.defPlndRelayPORlsDays =  parseInt(_rawConfigData.list[i].conf_value);
                                            break;   
                                case "016": configDefs.defPlndCBPORlsDays =  parseInt(_rawConfigData.list[i].conf_value);
                                            break;   
                                case "017": configDefs.defPlndCTPTPORlsDays =  parseInt(_rawConfigData.list[i].conf_value);
                                            break;   
                                case "018": configDefs.defPlndJumperPORlsDays =  parseInt(_rawConfigData.list[i].conf_value);
                                            break;   
                                case "019": configDefs.defPlndImpErthSwthPORlsDays =  parseInt(_rawConfigData.list[i].conf_value);
                                            break;   
                                case "020": configDefs.defPlndRychmSlvPORlsDays =  parseInt(_rawConfigData.list[i].conf_value);
                                            break;   
                                case "021": configDefs.defPlndMtrBoxPORlsDays =  parseInt(_rawConfigData.list[i].conf_value);
                                            break;   
                                case "022": configDefs.defPlndCBRcptPORlsWeeks =  parseInt(_rawConfigData.list[i].conf_value);
                                            break;   
                                case "023": configDefs.defPlndCTPTPORlsWeeks =  parseInt(_rawConfigData.list[i].conf_value);
                                            break;   
                                case "024": configDefs.defPlndRelayPORlsWeeks =  parseInt(_rawConfigData.list[i].conf_value);
                                            break;   
                                case "025": configDefs.defPlndJumperPORlsWeeks =  parseInt(_rawConfigData.list[i].conf_value);
                                            break;   
                                case "026": configDefs.defPlndMtrngBoxPORlsWeeks =  parseInt(_rawConfigData.list[i].conf_value);
                                            break;   
                                case "027": configDefs.defPlndImpEthSwthPORlsWeeks =  parseInt(_rawConfigData.list[i].conf_value);
                                            break;   
                                case "028": configDefs.defPlndRychmSlvRcptWeeks =  parseInt(_rawConfigData.list[i].conf_value);
                                            break;   
                                case "029": configDefs.defPlndImpBrkrRcptWeeks =  parseInt(_rawConfigData.list[i].conf_value);
                                            break;   
                                case "030": configDefs.defPlndImpVSCRcptWeeks =  parseInt(_rawConfigData.list[i].conf_value);
                                            break;   
                                case "031": configDefs.defPlndAlstomGERlyRcptWeeks =  parseInt(_rawConfigData.list[i].conf_value);
                                            break;   
                                case "032": configDefs.defPlndProdStartDays =  parseInt(_rawConfigData.list[i].conf_value);
                                            break;   
                                case "033": configDefs.defPlndProdEndDays =  parseInt(_rawConfigData.list[i].conf_value);
                                            break;   
                                case "034": configDefs.defPlndMechStikrDays =  parseInt(_rawConfigData.list[i].conf_value);
                                            break;   
                                case "035": configDefs.defPlndElecTestDays =  parseInt(_rawConfigData.list[i].conf_value);
                                            break;   
                                case "036": configDefs.defPlndFATDays =  parseInt(_rawConfigData.list[i].conf_value);
                                            break; 
                                case "037": configDefs.defPlndDispatchDays =  parseInt(_rawConfigData.list[i].conf_value);
                                            break; 
                                case "038": configDefs.defPlndBrkrPORlsDays =  parseInt(_rawConfigData.list[i].conf_value);
                                            break;
                                case "039": configDefs.defPlndSAPORlsDays =  parseInt(_rawConfigData.list[i].conf_value);
                                            break;                                             
                                case "040": configDefs.defPlndLooseMatIsuToDisp =  parseInt(_rawConfigData.list[i].conf_value);
                                            break;
                                case "041": configDefs.defPlndMechElecTestDays =  parseInt(_rawConfigData.list[i].conf_value);
                                            break;                                            
                                case "042": configDefs.defReqMechElecTestDays =  parseInt(_rawConfigData.list[i].conf_value);
                                            break;
                                case "043": configDefs.defReqFATDays =  parseInt(_rawConfigData.list[i].conf_value);
                                            break;
                                case "044": configDefs.defPlndGreStiDays =  parseInt(_rawConfigData.list[i].conf_value);
                                            break;
                                case "045": configDefs.defReqGreStiDays =  parseInt(_rawConfigData.list[i].conf_value);
                                            break;
                                case "046": configDefs.defReqDispatchDays =  parseInt(_rawConfigData.list[i].conf_value);
                                            break; 
                                case "047": configDefs.defPlndMatIsuToLineDays =  parseInt(_rawConfigData.list[i].conf_value);
                                            break;                                                         
                                case "048": configDefs.defReqMatIsuToLineDays =  parseInt(_rawConfigData.list[i].conf_value);
                                            break;
                                case "049": configDefs.defReqSARecptDays =  parseInt(_rawConfigData.list[i].conf_value);
                                            break;
                                case "050": configDefs.defPlndSARecptWeeks =  parseInt(_rawConfigData.list[i].conf_value);
                                            break; 
                                case "051": configDefs.defDaysPerWeek =  parseInt(_rawConfigData.list[i].conf_value);
                                            break; 
                                case "052": configDefs.defReqRelRecptDays =  parseInt(_rawConfigData.list[i].conf_value);
                                            break;
                                case "053": configDefs.defPlndRelRecptWeeks =  parseInt(_rawConfigData.list[i].conf_value);
                                            break; 
                                case "054": configDefs.defPlndCTPTRecptWeeks =  parseInt(_rawConfigData.list[i].conf_value);
                                            break; 
                                case "055": configDefs.defReqCTPTRecptDays =  parseInt(_rawConfigData.list[i].conf_value);
                                            break; 
                                case "056": configDefs.defPlndCTFinByPMToSCMDays =  parseInt(_rawConfigData.list[i].conf_value);
                                            break; 
                                case "057": configDefs.defPlndPacDispClrDays =  parseInt(_rawConfigData.list[i].conf_value);
                                            break; 
                                case "058": configDefs.defPlndCTFinalfrmSCMDays =  parseInt(_rawConfigData.list[i].conf_value);
                                            break; 
                                case "059": configDefs.defPlndCTFinlEnggToPMDays =  parseInt(_rawConfigData.list[i].conf_value);
                                            break; 
                                case "060": configDefs.defPlndGERelayPORelDays =  parseInt(_rawConfigData.list[i].conf_value);
                                            break; 
                                case "061": configDefs.defPlndLinLoadWeeks =  parseInt(_rawConfigData.list[i].conf_value);
                                            break; 
                                case "062": configDefs.defPlndPicLisIsuToStorDays =  parseInt(_rawConfigData.list[i].conf_value);
                                            break; 
                                case "063": configDefs.defReqPicLisIsuToStorDays =  parseInt(_rawConfigData.list[i].conf_value);
                                            break; 
                                case "064": configDefs.defReqImpBrekRecptDays =  parseInt(_rawConfigData.list[i].conf_value);
                                            break;
                                case "065": configDefs.defPlndImpVSCRecptDays =  parseInt(_rawConfigData.list[i].conf_value);
                                            break; 
                                case "066": configDefs.defReqImpVSCRecptDays =  parseInt(_rawConfigData.list[i].conf_value);
                                            break; 
                                case "067": configDefs.defPlndGERelayRecptWeek =  parseInt(_rawConfigData.list[i].conf_value);
                                            break; 
                                case "068": configDefs.defReqGERelayRecptDays =  parseInt(_rawConfigData.list[i].conf_value);
                                            break; 
                                case "069": configDefs.defReqJumRecptDays =  parseInt(_rawConfigData.list[i].conf_value);
                                            break; 
                                            
                                            
                                            
                                default: break;                                 
                            }
                        }
                       
                    }
                    this._configItems = _tmpConfig;
                }

                let _tmpME: Array<MarketingEngineer> = [];
                let _rawMEData:any = this.getDocTypeData(respJson.data,'pm_marketingEngineer');
                if(_rawMEData != null) {
                    for(var i=0; i<_rawMEData.list.length; i++) {
                        if(_rawMEData.list[i].is_active === true){
                            _tmpME.push(new MarketingEngineer(_rawMEData.list[i].marketing_engineer_id, _rawMEData.list[i].marketing_engineer_name,_rawMEData.list[i].email_id, _rawMEData.list[i].is_active));
                        }    
                    }
                    _tmpME.sort((_a:MarketingEngineer,_b:MarketingEngineer) => {
                        return ('' + _a.marketingEngineerName).localeCompare(_b.marketingEngineerName);
                    });
                    this._marketingEngineers = _tmpME;
                }

                let _tmpEDE: Array<ElectricalDesignEngineer> = [];
                let _rawEDEData:any = this.getDocTypeData(respJson.data,'pm_electricalDesignEngineer');
                if(_rawEDEData != null) {
                    for(var i=0; i<_rawEDEData.list.length; i++) {
                        if(_rawEDEData.list[i].is_active === true){
                            _tmpEDE.push(new ElectricalDesignEngineer(_rawEDEData.list[i].electrical_design_engineer_id, _rawEDEData.list[i].electrical_design_engineer_name, _rawEDEData.list[i].email_id,_rawEDEData.list[i].is_active));
                        }
                    }
                    this._electricalDesignEngineer = _tmpEDE;
                }

                this._c30DesignEngineer.push(new C30Engineer("001","Amit Nikumbha",this._configurationService.getSingleEmail('DATA_SERVICE_SUPPORT'), true));

                let _tmpCDW: Array<ContractualDeliveryWeeks> = [];
                let _rawCDWData:any = this.getDocTypeData(respJson.data,'pm_contractualDeliveryWeeks');
                if(_rawCDWData != null) {
                    for(var i=0; i<_rawCDWData.list.length; i++) {
                        if(_rawCDWData.list[i].is_active === true){
                            _tmpCDW.push(new ContractualDeliveryWeeks(_rawCDWData.list[i].contractual_delivery_weeks_id, _rawCDWData.list[i].contractual_delivery_weeks_name, _rawCDWData.list[i].contractual_delivery_weeks_count, _rawCDWData.list[i].is_active));
                        }
                    }
                    this._contractualDeliveryWeeks = _tmpCDW;
                }

                let _tmpWM: Array<WarrantyMonths> = [];
                let _rawWMData:any = this.getDocTypeData(respJson.data,'pm_warrantyMonths');
                if(_rawWMData != null) {
                    for(var i=0; i<_rawWMData.list.length; i++) {
                        if(_rawWMData.list[i].is_active === true){
                            _tmpWM.push(new WarrantyMonths(_rawWMData.list[i].warranty_months_id, _rawWMData.list[i].warranty_months_name, _rawWMData.list[i].warranty_months_count, _rawWMData.list[i].is_active));
                        } 
                    }
                    this._warrantyMonths = _tmpWM;
                }

                let _tmpIL: Array<InsulationLevel> = [];
                let _rawILData:any = this.getDocTypeData(respJson.data,'pm_insulationLevel');
                if(_rawILData != null) {
                    for(var i=0; i<_rawILData.list.length; i++) {
                        if(_rawILData.list[i].is_active === true){
                            _tmpIL.push(new InsulationLevel(_rawILData.list[i].insulation_level_id, _rawILData.list[i].insulation_level_name, _rawILData.list[i].insulation_level_value, _rawILData.list[i].is_active));
                        }
                        
                    }
                    this._insulationLevel = _tmpIL;
                }

                let _tmpMechTestEnggs: Array<MechanicalTestingEngineer> = [];
                let _rawMechTestEnggData:any = this.getDocTypeData(respJson.data,'pm_mechTestEngg');
                if(_rawMechTestEnggData != null) {
                    for(var i=0; i<_rawMechTestEnggData.list.length; i++) {
                        let _tmpMTE:MechanicalTestingEngineer = MechanicalTestingEngineer.getObj(_rawMechTestEnggData.list[i]);
                        if(_tmpMTE.isActive == true){
                            _tmpMechTestEnggs.push(_tmpMTE);
                        }                        
                    }
                    this._mechTestEngineers = _tmpMechTestEnggs;
                }

                let _tmpElecTestEnggs: Array<ElectricalTestingEngineer> = [];
                let _rawElecTestEnggData:any = this.getDocTypeData(respJson.data,'pm_elecTestEngg');
                if(_rawElecTestEnggData != null) {
                    for(var i=0; i<_rawElecTestEnggData.list.length; i++) {
                        let _tmpETE:ElectricalTestingEngineer = ElectricalTestingEngineer.getObj(_rawElecTestEnggData.list[i]);
                        if(_tmpETE.isActive == true){
                            _tmpElecTestEnggs.push(_tmpETE);
                        }                        
                    }
                    this._elecTestEngineers = _tmpElecTestEnggs;
                }

                // let _tmpSO: Array<SuborderNumbers> = [];
                // let _rawSOData:any = this.getDocTypeData(respJson.data,'pm_suborders');
                // if(_rawSOData != null) {
                //     for(var i=0; i<_rawSOData.list.length; i++) {
                //         if(_rawSOData.list[i].is_active === true){
                //             _tmpSO.push(new SuborderNumbers(_rawSOData.list[i].suborders_id, _rawSOData.list[i].suborders_name, _rawSOData.list[i].is_active));
                //         }
                        
                //     }
                //     this._suborderNumbers = _tmpSO;
                // }

                let _tmpKA: Array<KIOSKApplicability> = [];
                let _rawKAData:any = this.getDocTypeData(respJson.data,'pm_kioskApplicability');
                if(_rawKAData != null) {
                    for(var i=0; i<_rawKAData.list.length; i++) {
                        if(_rawKAData.list[i].is_active === true){
                            _tmpKA.push(new KIOSKApplicability(_rawKAData.list[i].kiosk_applicability_id, _rawKAData.list[i].kiosk_applicability_name, _rawKAData.list[i].kiosk_applicability_value , _rawKAData.list[i].is_active));
                        }
                        
                    }
                    this._kioskApplicability = _tmpKA;
                }

                let _tmpBT: Array<BreakerType> = [];
                let _rawBTData:any = this.getDocTypeData(respJson.data,'pm_breakerTypes');
                if(_rawBTData != null) {
                    for(var i=0; i<_rawBTData.list.length; i++) {
                        if(_rawBTData.list[i].is_active === true){
                            _tmpBT.push(new BreakerType(_rawBTData.list[i].breaker_type_id, _rawBTData.list[i].breaker_type_name, _rawBTData.list[i].breaker_type_value,_rawBTData.list[i].variant_ids, _rawBTData.list[i].is_active));
                        }
                        
                    }
                    this._breakerType = _tmpBT;
                }

                let _tmpMS: Array<ManufacturtingStrategy> = [];
                let _rawMSData:any = this.getDocTypeData(respJson.data,'pm_manufacturingStrategy');
                if(_rawMSData != null) {
                    for(var i=0; i<_rawMSData.list.length; i++) {
                        if(_rawMSData.list[i].is_active === true){
                            _tmpMS.push(new ManufacturtingStrategy(_rawMSData.list[i].manufacturing_strategy_id, _rawMSData.list[i].manufacturing_strategy_name, _rawMSData.list[i].manufacturing_strategy_value, _rawMSData.list[i].is_active));
                        }
                        
                    }
                    this._manufacturtingStrategy = _tmpMS;
                }

                let _tmpPBGPC: Array<PBGPayCondition> = [];
                let _rawPBGPCData:any = this.getDocTypeData(respJson.data,'pm_pbgPaymentCondition');
                if(_rawPBGPCData != null) {
                    for(var i=0; i<_rawPBGPCData.list.length; i++) {
                        if(_rawPBGPCData.list[i].is_active === true){
                            _tmpPBGPC.push(new PBGPayCondition(_rawPBGPCData.list[i].pbg_pay_condition_id, _rawPBGPCData.list[i].pbg_pay_condition_name, _rawPBGPCData.list[i].is_active));
                        }
                       
                    }
                    this._pbgPayCondition = _tmpPBGPC;
                }

                let _tmpCPBGPC: Array<CPBGPayCondition> = [];
                let _rawCPBGPCData:any = this.getDocTypeData(respJson.data,'pm_cpbgPaymentCondition');
                if(_rawCPBGPCData != null) {
                    for(var i=0; i<_rawCPBGPCData.list.length; i++) {
                        if(_rawCPBGPCData.list[i].is_active === true){
                            _tmpCPBGPC.push(new CPBGPayCondition(_rawCPBGPCData.list[i].cpbg_pay_condition_id, _rawCPBGPCData.list[i].cpbg_pay_condition_name, _rawCPBGPCData.list[i].is_active));
                        }
                        
                    }
                    this._cpbgPayCondition = _tmpCPBGPC;
                }
                let _tmpRevenueMonths:Array<RevenueMonth> = [];
                let _rawRevenueMonthsData:any = this.getDocTypeData(respJson.data,'revenue_months');
                if(_rawRevenueMonthsData != null){
                    for(var i=0;i<_rawRevenueMonthsData.list.length;i++){
                        let _tmpItem:any = _rawRevenueMonthsData.list[i];
                        if(_tmpItem.is_active == true){
                            _tmpRevenueMonths.push(new RevenueMonth(_tmpItem.month_id,_tmpItem.month_name,_tmpItem.value,_tmpItem.order_no));
                        }
                    }
                    _tmpRevenueMonths.sort((_a:RevenueMonth,_b:RevenueMonth) => {
                        return _a.orderNo - _b.orderNo;
                    });
                }
                this._revenueMonths = _tmpRevenueMonths;

                let _tmpEg: Array<EmailGrp> = [];
                let _rawEGData:any = this.getDocTypeData(respJson.data,'emailGrp');
                if(_rawEGData != null) {
                    for(var i=0; i<_rawEGData.list.length; i++) {
                        if(_rawEGData.list[i].is_active === true){
                            _tmpEg.push(new EmailGrp(_rawEGData.list[i].email_group_id, _rawEGData.list[i].email_group_name,_rawEGData.list[i].email_id, _rawEGData.list[i].is_active));
                        }
                        
                    }
                    _tmpEg.sort((_a:EmailGrp,_b:EmailGrp) => {
                        return ('' + _a.emailGrpName).localeCompare(_b.emailGrpName);
                    });
                    this._emailGrp = _tmpEg;
                }

                let _tmpSpAdGrp: Array<SuperAdmin> = [];
                let _rawSAData:any = this.getDocTypeData(respJson.data,'super_adminGrp');
                if(_rawSAData != null) {
                    for(var i=0; i<_rawSAData.list.length; i++) {
                        if(_rawSAData.list[i].is_active === true){
                            _tmpSpAdGrp.push(new SuperAdmin(_rawSAData.list[i].email_group_id, _rawSAData.list[i].email_group_name,_rawSAData.list[i].email_id, _rawSAData.list[i].is_active));
                        }
                        
                    }
                    _tmpSpAdGrp.sort((_a:SuperAdmin,_b:SuperAdmin) => {
                        return ('' + _a.superAdminName).localeCompare(_b.superAdminName);
                    });
                    this._superAdmin = _tmpSpAdGrp;
                }

                let _tmpIssues: Array<GenDataType> = [];
                let _rawIssuesData:any = this.getDocTypeData(respJson.data,'pm_issuesList');
                if(_rawIssuesData != null) {
                    for(var i=0; i<_rawIssuesData.list.length; i++) {
                        if(_rawIssuesData.list[i].is_active === true){
                            _tmpIssues.push(new GenDataType(_rawIssuesData.list[i].genType_id, _rawIssuesData.list[i].genType_name, _rawIssuesData.list[i].is_active));
                        }
                        
                    }
                    this._natureOfIssuesList = _tmpIssues;
                }

                let _tmpCNtype: Array<GenDataType> = [];
                let _rawCNTyData:any = this.getDocTypeData(respJson.data,'pm_changeNoteTypeList');
                if(_rawCNTyData != null) {
                    for(var i=0; i<_rawCNTyData.list.length; i++) {
                        if(_rawCNTyData.list[i].is_active === true){
                            _tmpCNtype.push(new GenDataType(_rawCNTyData.list[i].genType_id, _rawCNTyData.list[i].genType_name, _rawCNTyData.list[i].is_active));
                        }
                        
                    }
                    this._changeNoteTypeList = _tmpCNtype;
                }

                let _tmpGUL1: Array<GenUserDef> = [];
                let _rawGUL1Data:any = this.getDocTypeData(respJson.data,'pm_approverL1List');
                if(_rawGUL1Data != null) {
                    for(var i=0; i<_rawGUL1Data.list.length; i++) {
                        if(_rawGUL1Data.list[i].is_active === true){
                            _tmpGUL1.push(new GenUserDef(_rawGUL1Data.list[i].user_id, _rawGUL1Data.list[i].user_name, _rawGUL1Data.list[i].user_email, _rawGUL1Data.list[i].is_active));
                        }
                        
                    }
                    this._approverL1List = _tmpGUL1;
                }

                let _tmpGUL2: Array<GenUserDef> = [];
                let _rawGUL2Data:any = this.getDocTypeData(respJson.data,'pm_approverL2List');
                if(_rawGUL2Data != null) {
                    for(var i=0; i<_rawGUL2Data.list.length; i++) {
                        if(_rawGUL2Data.list[i].is_active === true){
                            _tmpGUL2.push(new GenUserDef(_rawGUL2Data.list[i].user_id, _rawGUL2Data.list[i].user_name, _rawGUL2Data.list[i].user_email, _rawGUL2Data.list[i].is_active));
                        }
                        
                    }
                    this._approverL2List = _tmpGUL2;
                }

                let _tmpTempRaise: Array<OptionsDef> = [];
                let _rawTempRaiseData:any = this.getDocTypeData(respJson.data,'ds_tempRiseLimit');
                if(_rawTempRaiseData != null) {
                    for(var i=0; i<_rawTempRaiseData.list.length; i++) {
                        if(_rawTempRaiseData.list[i].is_active === true){
                            _tmpTempRaise.push(new OptionsDef(_rawTempRaiseData.list[i].option_id, _rawTempRaiseData.list[i].option_name, _rawTempRaiseData.list[i].is_active));
                        }
                        
                    }
                    this._tempRiseList = _tmpTempRaise;
                }
                let _tmpEarthSys: Array<OptionsDef> = [];
                let _rawEarthSysData:any = this.getDocTypeData(respJson.data,'ds_earthingSys');
                if(_rawEarthSysData != null) {
                    for(var i=0; i<_rawEarthSysData.list.length; i++) {
                        if(_rawEarthSysData.list[i].is_active === true){
                            _tmpEarthSys.push(new OptionsDef(_rawEarthSysData.list[i].option_id, _rawEarthSysData.list[i].option_name, _rawEarthSysData.list[i].is_active));
                        }
                        
                    }
                    this._earthingSystemList = _tmpEarthSys;
                }

                let _tmpvcbModel: Array<OptionsConnectedDef> = [];
                let _tmpGnrlvcbModel: Array<string> = [];
                let _rawvcbModelData:any = this.getDocTypeData(respJson.data,'ds_vcbModel');
                if(_rawvcbModelData != null) {
                    for(var i=0; i<_rawvcbModelData.list.length; i++) {
                        if(_rawvcbModelData.list[i].is_active === true){
                            _tmpvcbModel.push(new OptionsConnectedDef(_rawvcbModelData.list[i].option_id, _rawvcbModelData.list[i].option_name,_rawvcbModelData.list[i].connected_option_id, _rawvcbModelData.list[i].is_active));

                            if(_rawvcbModelData.list[i].connected_option_id.length == 0){
                                _tmpGnrlvcbModel.push(_rawvcbModelData.list[i].option_id);
                            }
                        }
                        
                    }
                    this._vcbModel = _tmpvcbModel;
                    this._generalVcbModelIds = _tmpGnrlvcbModel;
                }

                let _tmpvcbModelDetail: Array<OptionsConnectedDef> = [];
                let _tmpGnrlvcbModelDetail: Array<string> = [];
                let _rawvcbModelDetailData:any = this.getDocTypeData(respJson.data,'ds_vcbModelDetail');
                if(_rawvcbModelDetailData != null) {
                    for(var i=0; i<_rawvcbModelDetailData.list.length; i++) {
                        if(_rawvcbModelDetailData.list[i].is_active === true){
                            _tmpvcbModelDetail.push(new OptionsConnectedDef(_rawvcbModelDetailData.list[i].option_id, _rawvcbModelDetailData.list[i].option_name,_rawvcbModelDetailData.list[i].connected_option_id, _rawvcbModelDetailData.list[i].is_active));
                        }
                        if(_rawvcbModelDetailData.list[i].connected_option_id.length == 0){
                            _tmpGnrlvcbModelDetail.push(_rawvcbModelDetailData.list[i].option_id);
                        }
                        
                    }
                    this._vcbModelDetail = _tmpvcbModelDetail;
                    this._generalVcbModelDetailIds = _tmpGnrlvcbModelDetail;
                }

                let _tmpvcbType: Array<OptionsDef> = [];
                let _rawvcbTypeData:any = this.getDocTypeData(respJson.data,'ds_vcbType');
                if(_rawvcbTypeData != null) {
                    for(var i=0; i<_rawvcbTypeData.list.length; i++) {
                        if(_rawvcbTypeData.list[i].is_active === true){
                            _tmpvcbType.push(new OptionsDef(_rawvcbTypeData.list[i].option_id, _rawvcbTypeData.list[i].option_name, _rawvcbTypeData.list[i].is_active));
                        }
                        
                    }
                    this._vcbType = _tmpvcbType;
                }

                let _tmpvcbPole: Array<OptionsDef> = [];
                let _rawvcbPoleData:any = this.getDocTypeData(respJson.data,'ds_vcbPole');
                if(_rawvcbPoleData != null) {
                    for(var i=0; i<_rawvcbPoleData.list.length; i++) {
                        if(_rawvcbPoleData.list[i].is_active === true){
                            _tmpvcbPole.push(new OptionsDef(_rawvcbPoleData.list[i].option_id, _rawvcbPoleData.list[i].option_name, _rawvcbPoleData.list[i].is_active));
                        }
                        
                    }
                    this._vcbPole = _tmpvcbPole;
                }

                let _tmplvCompDoor: Array<OptionsDef> = [];
                let _rawlvCompDoorData:any = this.getDocTypeData(respJson.data,'ds_lvCompDoor');
                if(_rawlvCompDoorData != null) {
                    for(var i=0; i<_rawlvCompDoorData.list.length; i++) {
                        if(_rawlvCompDoorData.list[i].is_active === true){
                            _tmplvCompDoor.push(new OptionsDef(_rawlvCompDoorData.list[i].option_id, _rawlvCompDoorData.list[i].option_name, _rawlvCompDoorData.list[i].is_active));
                        }
                        
                    }
                    this._lvCompDoor = _tmplvCompDoor;
                }

                let _tmpRestofPanel: Array<OptionsDef> = [];
                let _rawRestofPanelData:any = this.getDocTypeData(respJson.data,'ds_restOfPanel');
                if(_rawRestofPanelData != null) {
                    for(var i=0; i<_rawRestofPanelData.list.length; i++) {
                        if(_rawRestofPanelData.list[i].is_active === true){
                            _tmpRestofPanel.push(new OptionsDef(_rawRestofPanelData.list[i].option_id, _rawRestofPanelData.list[i].option_name, _rawRestofPanelData.list[i].is_active));
                        }
                        
                    }
                    this._restOfPanel = _tmpRestofPanel;
                }

                let _tmplvCompDoorV2: Array<OptionsDef> = [];
                let _rawlvCompDoorV2Data:any = this.getDocTypeData(respJson.data,'ds_lvCompDoorV2');
                if(_rawlvCompDoorV2Data != null) {
                    for(var i=0; i<_rawlvCompDoorV2Data.list.length; i++) {
                        if(_rawlvCompDoorV2Data.list[i].is_active === true){
                            _tmplvCompDoorV2.push(new OptionsDef(_rawlvCompDoorV2Data.list[i].option_id, _rawlvCompDoorV2Data.list[i].option_name, _rawlvCompDoorV2Data.list[i].is_active));
                        }
                        
                    }
                    this._lvCompDoorV2 = _tmplvCompDoorV2;
                }

                let _tmpbreakerCompDoor: Array<OptionsDef> = [];
                let _rawbreakerCompDoorData:any = this.getDocTypeData(respJson.data,'ds_breakerCompDoor');
                if(_rawbreakerCompDoorData != null) {
                    for(var i=0; i<_rawbreakerCompDoorData.list.length; i++) {
                        if(_rawbreakerCompDoorData.list[i].is_active === true){
                            _tmpbreakerCompDoor.push(new OptionsDef(_rawbreakerCompDoorData.list[i].option_id, _rawbreakerCompDoorData.list[i].option_name, _rawbreakerCompDoorData.list[i].is_active));
                        }
                        
                    }
                    this._breakerCompDoor = _tmpbreakerCompDoor;
                }

                let _tmprearCover: Array<OptionsDef> = [];
                let _rawrearCoverData:any = this.getDocTypeData(respJson.data,'ds_rearCover');
                if(_rawrearCoverData != null) {
                    for(var i=0; i<_rawrearCoverData.list.length; i++) {
                        if(_rawrearCoverData.list[i].is_active === true){
                            _tmprearCover.push(new OptionsDef(_rawrearCoverData.list[i].option_id, _rawrearCoverData.list[i].option_name, _rawrearCoverData.list[i].is_active));
                        }
                        
                    }
                    this._rearCover = _tmprearCover;
                }

                let _tmppowerCable: Array<OptionsDef> = [];
                let _rawpowerCableData:any = this.getDocTypeData(respJson.data,'ds_powerCable');
                if(_rawpowerCableData != null) {
                    for(var i=0; i<_rawpowerCableData.list.length; i++) {
                        if(_rawpowerCableData.list[i].is_active === true){
                            _tmppowerCable.push(new OptionsDef(_rawpowerCableData.list[i].option_id, _rawpowerCableData.list[i].option_name, _rawpowerCableData.list[i].is_active));
                        }
                        
                    }
                    this._powerCable = _tmppowerCable;
                }

                let _tmpcontrolCable: Array<OptionsDef> = [];
                let _rawcontrolCableData:any = this.getDocTypeData(respJson.data,'ds_controlCable');
                if(_rawcontrolCableData != null) {
                    for(var i=0; i<_rawcontrolCableData.list.length; i++) {
                        if(_rawcontrolCableData.list[i].is_active === true){
                            _tmpcontrolCable.push(new OptionsDef(_rawcontrolCableData.list[i].option_id, _rawcontrolCableData.list[i].option_name, _rawcontrolCableData.list[i].is_active));
                        }
                        
                    }
                    this._controlCable = _tmpcontrolCable;
                }
                
                let _tmpbusductEntry: Array<OptionsDef> = [];
                let _rawbusductEntryData:any = this.getDocTypeData(respJson.data,'ds_busductEntry');
                if(_rawbusductEntryData != null) {
                    for(var i=0; i<_rawbusductEntryData.list.length; i++) {
                        if(_rawbusductEntryData.list[i].is_active === true){
                            _tmpbusductEntry.push(new OptionsDef(_rawbusductEntryData.list[i].option_id, _rawbusductEntryData.list[i].option_name, _rawbusductEntryData.list[i].is_active));
                        }
                        
                    }
                    this._busductEntry = _tmpbusductEntry;
                }

                let _tmpcableRun: Array<OptionsDef> = [];
                let _rawcableRunData:any = this.getDocTypeData(respJson.data,'ds_cableRun');
                if(_rawcableRunData != null) {
                    for(var i=0; i<_rawcableRunData.list.length; i++) {
                        if(_rawcableRunData.list[i].is_active === true){
                            _tmpcableRun.push(new OptionsDef(_rawcableRunData.list[i].option_id, _rawcableRunData.list[i].option_name, _rawcableRunData.list[i].is_active));
                        }
                        
                    }
                    this._cableRun = _tmpcableRun;
                }

                let _tmpcableRunList: Array<OptionsDef> = [];
                let _rawcableRunListData:any = this.getDocTypeData(respJson.data,'ds_cableRunList');
                if(_rawcableRunListData != null) {
                    for(var i=0; i<_rawcableRunListData.list.length; i++) {
                        if(_rawcableRunListData.list[i].is_active === true){
                            _tmpcableRunList.push(new OptionsDef(_rawcableRunListData.list[i].option_id, _rawcableRunListData.list[i].option_name, _rawcableRunListData.list[i].is_active));
                        }
                        
                    }
                    this._cableRunList = _tmpcableRunList;
                }

                let _tmpSingleCC: Array<OptionsConnectedDef> = [];
                let _tmpGnrlSingleCC: Array<string> = [];
                let _rawSCCData:any = this.getDocTypeData(respJson.data,'ds_singleCoreCables');
                if(_rawSCCData != null) {
                    for(var i=0; i<_rawSCCData.list.length; i++) {
                        if(_rawSCCData.list[i].is_active === true){
                            _tmpSingleCC.push(new OptionsConnectedDef(_rawSCCData.list[i].option_id, _rawSCCData.list[i].option_name,_rawSCCData.list[i].connected_option_id, _rawSCCData.list[i].is_active));

                            if(_rawSCCData.list[i].connected_option_id.length == 0){
                                _tmpGnrlSingleCC.push(_rawSCCData.list[i].option_id);
                            }
                        }
                        
                    }
                    this._singleCoreCables = _tmpSingleCC;
                    this._generalSingleCoreCablesIds = _tmpGnrlSingleCC;
                }

                let _tmpExhType: Array<OptionsDef> = [];
                let _rawExhTypeData:any = this.getDocTypeData(respJson.data,'ds_exhType');
                if(_rawExhTypeData != null) {
                    for(var i=0; i<_rawExhTypeData.list.length; i++) {
                        if(_rawExhTypeData.list[i].is_active === true){
                            _tmpExhType.push(new OptionsDef(_rawExhTypeData.list[i].option_id, _rawExhTypeData.list[i].option_name, _rawExhTypeData.list[i].is_active));
                        }
                        
                    }
                    this._exhType = _tmpExhType;
                }

                let _tmpFeederRtBPList: Array<OptionsDef> = [];
                let _rawFeederRtBPListData:any = this.getDocTypeData(respJson.data,'ds_feederRatngBPList');
                if(_rawFeederRtBPListData != null) {
                    for(var i=0; i<_rawFeederRtBPListData.list.length; i++) {
                        if(_rawFeederRtBPListData.list[i].is_active === true){
                            _tmpFeederRtBPList.push(new OptionsDef(_rawFeederRtBPListData.list[i].option_id, _rawFeederRtBPListData.list[i].option_name, _rawFeederRtBPListData.list[i].is_active));
                        }
                        
                    }
                    this._feederRatingBPList = _tmpFeederRtBPList;
                }

                
                let _tmpFeederRtBP: Array<OptionsConnectedDef> = [];
                let _tmpGnrlFRBP: Array<string> = [];
                let _rawFeederRtBPData:any = this.getDocTypeData(respJson.data,'ds_feederRatngBP');
                if(_rawFeederRtBPData != null) {
                    for(var i=0; i<_rawFeederRtBPData.list.length; i++) {
                        if(_rawFeederRtBPData.list[i].is_active === true){
                            _tmpFeederRtBP.push(new OptionsConnectedDef(_rawFeederRtBPData.list[i].option_id, _rawFeederRtBPData.list[i].option_name,_rawFeederRtBPData.list[i].connected_option_id, _rawFeederRtBPData.list[i].is_active));

                            if(_rawFeederRtBPData.list[i].connected_option_id.length == 0){
                                _tmpGnrlFRBP.push(_rawFeederRtBPData.list[i].option_id);
                            }
                        }
                        
                    }
                    this._feederRatingBP = _tmpFeederRtBP;
                    this._generalFeederRatingBPIds = _tmpGnrlFRBP;
                }

                let _tmpBrkrPS: Array<DSBreakerPS> = [];
                let _rawBrkrPSData:any = this.getDocTypeData(respJson.data,'ds_breakerPS');
                if(_rawBrkrPSData != null) {
                    for(var i=0; i<_rawBrkrPSData.list.length; i++) {
                        if(_rawBrkrPSData.list[i].is_active === true){
                            _tmpBrkrPS.push(new DSBreakerPS(_rawBrkrPSData.list[i].option_id, _rawBrkrPSData.list[i].option_name, _rawBrkrPSData.list[i].rtd_volt, _rawBrkrPSData.list[i].dry_freq,
                                 _rawBrkrPSData.list[i].rated_imp_volt, _rawBrkrPSData.list[i].shrt_time_curr, _rawBrkrPSData.list[i].shrt_time_curr_sec,_rawBrkrPSData.list[i].prod_type, _rawBrkrPSData.list[i].switch_type,
                                 _rawBrkrPSData.list[i].vcb_curr, _rawBrkrPSData.list[i].panel_width, _rawBrkrPSData.list[i].rack_type, _rawBrkrPSData.list[i].is_active));
                        }
                        
                    }
                    this._dsBreakerPS = _tmpBrkrPS;
                }

                let _tmpFrcCoolVCBCurr: Array<OptionsConnectedDef> = [];
                let _tmpGnrlFrcVCB: Array<string> = [];
                let _rawFrcCoolVCBCurrData:any = this.getDocTypeData(respJson.data,'ds_frcCoolVCBCurr');
                if(_rawFrcCoolVCBCurrData != null) {
                    for(var i=0; i<_rawFrcCoolVCBCurrData.list.length; i++) {
                        if(_rawFrcCoolVCBCurrData.list[i].is_active === true){
                            _tmpFrcCoolVCBCurr.push(new OptionsConnectedDef(_rawFrcCoolVCBCurrData.list[i].option_id, _rawFrcCoolVCBCurrData.list[i].option_name, _rawFrcCoolVCBCurrData.list[i].connected_option_id, _rawFrcCoolVCBCurrData.list[i].is_active));
                        }
                        if (_rawFrcCoolVCBCurrData.list[i].connected_option_id.length == 0) {
                            _tmpGnrlFrcVCB.push(_rawFrcCoolVCBCurrData.list[i].option_id);
                        }

                        
                    }
                    this._forceCoolingVCBCurr = _tmpFrcCoolVCBCurr;
                    this._generalForceCoolingVCBCurrIds = _tmpGnrlFrcVCB;
                }
                let _tmpForceCooling: Array<DSForceCooling> = [];
                let _rawForceCoolingData:any = this.getDocTypeData(respJson.data,'ds_forceCooling');
                if(_rawForceCoolingData != null) {
                    for(var i=0; i<_rawForceCoolingData.list.length; i++) {
                        if(_rawForceCoolingData.list[i].is_active === true){
                            _tmpForceCooling.push(new DSForceCooling(_rawForceCoolingData.list[i].option_id, _rawForceCoolingData.list[i].option_name, _rawForceCoolingData.list[i].bus_curr, _rawForceCoolingData.list[i].vcb_curr,
                                 _rawForceCoolingData.list[i].vcb_pole, _rawForceCoolingData.list[i].amb_temp, _rawForceCoolingData.list[i].main_busbar, _rawForceCoolingData.list[i].prod_type ,
                                 _rawForceCoolingData.list[i].applic_id ,  _rawForceCoolingData.list[i].no_of_fans , _rawForceCoolingData.list[i].location_of_fans, _rawForceCoolingData.list[i].is_active));
                        }
                        
                    }
                    this._forceCooling = _tmpForceCooling;
                }

                let _tmpLocOfFans: Array<OptionsDef> = [];
                let _rawLocOfFansData:any = this.getDocTypeData(respJson.data,'ds_locationOfFans');
                if(_rawLocOfFansData != null) {
                    for(var i=0; i<_rawLocOfFansData.list.length; i++) {
                        if(_rawLocOfFansData.list[i].is_active === true){
                            _tmpLocOfFans.push(new OptionsDef(_rawLocOfFansData.list[i].option_id, _rawLocOfFansData.list[i].option_name, _rawLocOfFansData.list[i].is_active));
                        }
                        
                    }
                    this._locationOfFans = _tmpLocOfFans;
                }

                let _tmpSlvPt: Array<OptionsDef> = [];
                let _rawSlvPtData:any = this.getDocTypeData(respJson.data,'ds_silverPlt');
                if(_rawSlvPtData != null) {
                    for(var i=0; i<_rawSlvPtData.list.length; i++) {
                        if(_rawSlvPtData.list[i].is_active === true){
                            _tmpSlvPt.push(new OptionsDef(_rawSlvPtData.list[i].option_id, _rawSlvPtData.list[i].option_name, _rawSlvPtData.list[i].is_active));
                        }
                        
                    }
                    this._silverPlt = _tmpSlvPt;
                }
                

                let _tmpFeederNBList: Array<OptionsDef> = [];
                let _rawFeederNBListData:any = this.getDocTypeData(respJson.data,'ds_feederTypNBList');
                if(_rawFeederNBListData != null) {
                    for(var i=0; i<_rawFeederNBListData.list.length; i++) {
                        if(_rawFeederNBListData.list[i].is_active === true){
                            _tmpFeederNBList.push(new OptionsDef(_rawFeederNBListData.list[i].option_id, _rawFeederNBListData.list[i].option_name, _rawFeederNBListData.list[i].is_active));
                        }
                        
                    }
                    this._feederTypeNBList = _tmpFeederNBList;
                }

                let _tmpMainBBCB: Array<OptionsDef> = [];
                let _rawMainBBCBData:any = this.getDocTypeData(respJson.data,'ds_mainBusbarCB');
                if(_rawMainBBCBData != null) {
                    for(var i=0; i<_rawMainBBCBData.list.length; i++) {
                        if(_rawMainBBCBData.list[i].is_active === true){
                            _tmpMainBBCB.push(new OptionsDef(_rawMainBBCBData.list[i].option_id, _rawMainBBCBData.list[i].option_name, _rawMainBBCBData.list[i].is_active));
                        }
                        
                    }
                    this._mainBusbarCB = _tmpMainBBCB;
                }

                let _tmpFdCon: Array<OptionsDef> = [];
                let _rawFdConData:any = this.getDocTypeData(respJson.data,'ds_feederConn');
                if(_rawFdConData != null) {
                    for(var i=0; i<_rawFdConData.list.length; i++) {
                        if(_rawFdConData.list[i].is_active === true){
                            _tmpFdCon.push(new OptionsDef(_rawFdConData.list[i].option_id, _rawFdConData.list[i].option_name, _rawFdConData.list[i].is_active));
                        }
                        
                    }
                    this._feederConn = _tmpFdCon;
                }

                let _tmpMatMbb: Array<OptionsDef> = [];
                let _rawMatMbbData:any = this.getDocTypeData(respJson.data,'ds_materialMBB');
                if(_rawMatMbbData != null) {
                    for(var i=0; i<_rawMatMbbData.list.length; i++) {
                        if(_rawMatMbbData.list[i].is_active === true){
                            _tmpMatMbb.push(new OptionsDef(_rawMatMbbData.list[i].option_id, _rawMatMbbData.list[i].option_name, _rawMatMbbData.list[i].is_active));
                        }
                        
                    }
                    this._materialMBB = _tmpMatMbb;
                }

                let _tmpHtSlvMake: Array<OptionsDef> = [];
                let _rawHtSlvMakeData:any = this.getDocTypeData(respJson.data,'ds_htSleevesMake');
                if(_rawHtSlvMakeData != null) {
                    for(var i=0; i<_rawHtSlvMakeData.list.length; i++) {
                        if(_rawHtSlvMakeData.list[i].is_active === true){
                            _tmpHtSlvMake.push(new OptionsDef(_rawHtSlvMakeData.list[i].option_id, _rawHtSlvMakeData.list[i].option_name, _rawHtSlvMakeData.list[i].is_active));
                        }
                        
                    }
                    this._htSleevesMake = _tmpHtSlvMake;
                }

                let _tmpPhId: Array<OptionsConnectedDef> = [];
                let _tmpGnrlPI: Array<string> = [];
                let _rawPhIdData:any = this.getDocTypeData(respJson.data,'ds_phaseIdnftn');
                if(_rawPhIdData != null) {
                    for(var i=0; i<_rawPhIdData.list.length; i++) {
                        if(_rawPhIdData.list[i].is_active === true){
                            _tmpPhId.push(new OptionsConnectedDef(_rawPhIdData.list[i].option_id, _rawPhIdData.list[i].option_name,_rawPhIdData.list[i].connected_option_id, _rawPhIdData.list[i].is_active));

                            if(_rawPhIdData.list[i].connected_option_id.length == 0){
                                _tmpGnrlPI.push(_rawPhIdData.list[i].option_id);
                            }
                        }
                        
                    }
                    this._phaseIdentification = _tmpPhId;
                    this._generalFeederRatingBPIds = _tmpGnrlPI;
                }

                let _tmpErthSz: Array<OptionsConnectedDef> = [];
                let _tmpGnrlEZ: Array<string> = [];
                let _rawErthSzData:any = this.getDocTypeData(respJson.data,'ds_earthBBSize');
                if(_rawErthSzData != null) {
                    for(var i=0; i<_rawErthSzData.list.length; i++) {
                        if(_rawErthSzData.list[i].is_active === true){
                            _tmpErthSz.push(new OptionsConnectedDef(_rawErthSzData.list[i].option_id, _rawErthSzData.list[i].option_name,_rawErthSzData.list[i].connected_option_id, _rawErthSzData.list[i].is_active));

                            if(_rawErthSzData.list[i].connected_option_id.length == 0){
                                _tmpGnrlEZ.push(_rawErthSzData.list[i].option_id);
                            }
                        }
                        
                    }
                    this._earthBBSize = _tmpErthSz;
                    this._generalEarthBBSizeIds = _tmpGnrlEZ;
                }

                let _tmpErSzDtl: Array<OptionsDef> = [];
                let _rawErSzDtlData:any = this.getDocTypeData(respJson.data,'ds_earthBBSizeDetail');
                if(_rawErSzDtlData != null) {
                    for(var i=0; i<_rawErSzDtlData.list.length; i++) {
                        if(_rawErSzDtlData.list[i].is_active === true){
                            _tmpErSzDtl.push(new OptionsDef(_rawErSzDtlData.list[i].option_id, _rawErSzDtlData.list[i].option_name, _rawErSzDtlData.list[i].is_active));
                        }
                        
                    }
                    this._earthBBSizeDetail = _tmpErSzDtl;
                }

                let _tmpApplicFDEC: Array<OptionsDef> = [];
                let _rawApplicFDECData:any = this.getDocTypeData(respJson.data,'ds_applicFrontDrEndCvr');
                if(_rawApplicFDECData != null) {
                    for(var i=0; i<_rawApplicFDECData.list.length; i++) {
                        if(_rawApplicFDECData.list[i].is_active === true){
                            _tmpApplicFDEC.push(new OptionsDef(_rawApplicFDECData.list[i].option_id, _rawApplicFDECData.list[i].option_name, _rawApplicFDECData.list[i].is_active));
                        }
                        
                    }
                    this._applicFrontDrEndCvr = _tmpApplicFDEC;
                }
                
                let _tmpSptColor: Array<OptionsDef> = [];
                let _rawSptColorData:any = this.getDocTypeData(respJson.data,'ds_sptColorList');
                if(_rawSptColorData != null) {
                    for(var i=0; i<_rawSptColorData.list.length; i++) {
                        if(_rawSptColorData.list[i].is_active === true){
                            _tmpSptColor.push(new OptionsDef(_rawSptColorData.list[i].option_id, _rawSptColorData.list[i].option_name, _rawSptColorData.list[i].is_active));
                        }
                        
                    }
                    this._sptColorList = _tmpSptColor;
                }

                let _tmpTypPP: Array<OptionsConnectedDef> = [];
                let _tmpGnrlTyPP: Array<string> = [];
                let _rawTypPPData:any = this.getDocTypeData(respJson.data,'ds_typPaintProc');
                if(_rawTypPPData != null) {
                    for(var i=0; i<_rawTypPPData.list.length; i++) {
                        if(_rawTypPPData.list[i].is_active === true){
                            _tmpTypPP.push(new OptionsConnectedDef(_rawTypPPData.list[i].option_id, _rawTypPPData.list[i].option_name,_rawTypPPData.list[i].connected_option_id, _rawTypPPData.list[i].is_active));

                            if(_rawTypPPData.list[i].connected_option_id.length == 0){
                                _tmpGnrlTyPP.push(_rawTypPPData.list[i].option_id);
                            }
                        }
                        
                    }
                    this._typPaintProc = _tmpTypPP;
                    this._generalTypPaintProcIds = _tmpGnrlTyPP;
                }

                let _tmpPaintPD: Array<OptionsConnectedDef> = [];
                let _tmpGnrlPP: Array<string> = [];
                let _rawPaintPDData:any = this.getDocTypeData(respJson.data,'ds_paintProcDoc');
                if(_rawPaintPDData != null) {
                    for(var i=0; i<_rawPaintPDData.list.length; i++) {
                        if(_rawPaintPDData.list[i].is_active === true){
                            _tmpPaintPD.push(new OptionsConnectedDef(_rawPaintPDData.list[i].option_id, _rawPaintPDData.list[i].option_name,_rawPaintPDData.list[i].connected_option_id, _rawPaintPDData.list[i].is_active));

                            if(_rawPaintPDData.list[i].connected_option_id.length == 0){
                                _tmpGnrlPP.push(_rawPaintPDData.list[i].option_id);
                            }
                        }
                        
                    }
                    this._paintProcDoc = _tmpPaintPD;
                    this._generalPaintProcDocIds = _tmpGnrlPP;
                }

                let _tmpMMC: Array<OptionsDef> = [];
                let _rawMMCData:any = this.getDocTypeData(respJson.data,'ds_mimic');
                if(_rawMMCData != null) {
                    for(var i=0; i<_rawMMCData.list.length; i++) {
                        if(_rawMMCData.list[i].is_active === true){
                            _tmpMMC.push(new OptionsDef(_rawMMCData.list[i].option_id, _rawMMCData.list[i].option_name, _rawMMCData.list[i].is_active));
                        }
                        
                    }
                    this._mimic = _tmpMMC;
                }

                let _tmpMMCV2: Array<OptionsDef> = [];
                let _rawMMCV2Data:any = this.getDocTypeData(respJson.data,'ds_mimicV2');
                if(_rawMMCV2Data != null) {
                    for(var i=0; i<_rawMMCV2Data.list.length; i++) {
                        if(_rawMMCV2Data.list[i].is_active === true){
                            _tmpMMCV2.push(new OptionsDef(_rawMMCV2Data.list[i].option_id, _rawMMCV2Data.list[i].option_name, _rawMMCV2Data.list[i].is_active));
                        }
                        
                    }
                    this._mimicV2 = _tmpMMCV2;
                }

                let _tmpCloseTC: Array<OptionsDef> = [];
                let _rawCloseTCData:any = this.getDocTypeData(respJson.data,'ds_closeTripCirc');
                if(_rawCloseTCData != null) {
                    for(var i=0; i<_rawCloseTCData.list.length; i++) {
                        if(_rawCloseTCData.list[i].is_active === true){
                            _tmpCloseTC.push(new OptionsDef(_rawCloseTCData.list[i].option_id, _rawCloseTCData.list[i].option_name, _rawCloseTCData.list[i].is_active));
                        }
                        
                    }
                    this._closeTripCirc = _tmpCloseTC;
                }

                let _tmpAddTC: Array<OptionsDef> = [];
                let _rawAddTCData:any = this.getDocTypeData(respJson.data,'ds_addTripCoil');
                if(_rawAddTCData != null) {
                    for(var i=0; i<_rawAddTCData.list.length; i++) {
                        if(_rawAddTCData.list[i].is_active === true){
                            _tmpAddTC.push(new OptionsDef(_rawAddTCData.list[i].option_id, _rawAddTCData.list[i].option_name, _rawAddTCData.list[i].is_active,_rawAddTCData.list[i].order_no));
                        }

                    }
                    _tmpAddTC.sort((_a: OptionsDef, _b: OptionsDef) => {
                        return _a.orderNo - _b.orderNo;
                    });

                    this._addTripCoil = _tmpAddTC;
                }

                let _tmpMCA: Array<OptionsDef> = [];
                let _rawMCAData:any = this.getDocTypeData(respJson.data,'ds_meteringConAux');
                if(_rawMCAData != null) {
                    for(var i=0; i<_rawMCAData.list.length; i++) {
                        if(_rawMCAData.list[i].is_active === true){
                            _tmpMCA.push(new OptionsDef(_rawMCAData.list[i].option_id, _rawMCAData.list[i].option_name, _rawMCAData.list[i].is_active));
                        }
                        
                    }
                    this._meteringConAux = _tmpMCA;
                }

                let _tmpSH: Array<OptionsDef> = [];
                let _rawSHData:any = this.getDocTypeData(respJson.data,'ds_spaceHeater');
                if(_rawSHData != null) {
                    for(var i=0; i<_rawSHData.list.length; i++) {
                        if(_rawSHData.list[i].is_active === true){
                            _tmpSH.push(new OptionsDef(_rawSHData.list[i].option_id, _rawSHData.list[i].option_name, _rawSHData.list[i].is_active));
                        }
                        
                    }
                    this._spaceHeater = _tmpSH;
                }

                let _tmpAnnC: Array<OptionsDef> = [];
                let _rawAnnCData:any = this.getDocTypeData(respJson.data,'ds_annunCirc');
                if(_rawAnnCData != null) {
                    for(var i=0; i<_rawAnnCData.list.length; i++) {
                        if(_rawAnnCData.list[i].is_active === true){
                            _tmpAnnC.push(new OptionsDef(_rawAnnCData.list[i].option_id, _rawAnnCData.list[i].option_name, _rawAnnCData.list[i].is_active,_rawAnnCData.list[i].order_no));
                        }
                        
                    }
                    _tmpAnnC.sort((_a: OptionsDef, _b: OptionsDef) => {
                        return _a.orderNo - _b.orderNo;
                    });

                    this._annunCirc = _tmpAnnC;
                }

                let _tmpConWT: Array<OptionsDef> = [];
                let _rawConWTData:any = this.getDocTypeData(respJson.data,'ds_conWireTyp');
                if(_rawConWTData != null) {
                    for(var i=0; i<_rawConWTData.list.length; i++) {
                        if(_rawConWTData.list[i].is_active === true){
                            _tmpConWT.push(new OptionsDef(_rawConWTData.list[i].option_id, _rawConWTData.list[i].option_name, _rawConWTData.list[i].is_active));
                        }
                        
                    }
                    this._conWireTyp = _tmpConWT;
                }

                let _tmpConWTDet: Array<OptionsDef> = [];
                let _rawConWTDetData:any = this.getDocTypeData(respJson.data,'ds_conWireTypDetail');
                if(_rawConWTDetData != null) {
                    for(var i=0; i<_rawConWTDetData.list.length; i++) {
                        if(_rawConWTDetData.list[i].is_active === true){
                            _tmpConWTDet.push(new OptionsDef(_rawConWTDetData.list[i].option_id, _rawConWTDetData.list[i].option_name, _rawConWTDetData.list[i].is_active));
                        }
                        
                    }
                    this._conWireTypDetail = _tmpConWTDet;
                }

                let _tmpAppSt: Array<OptionsConnectedDef> = [];
                let _tmpGnrlApSt: Array<string> = [];
                let _rawAppStData:any = this.getDocTypeData(respJson.data,'ds_applicStand');
                if(_rawAppStData != null) {
                    for(var i=0; i<_rawAppStData.list.length; i++) {
                        if(_rawAppStData.list[i].is_active === true){
                            _tmpAppSt.push(new OptionsConnectedDef(_rawAppStData.list[i].option_id, _rawAppStData.list[i].option_name,_rawAppStData.list[i].connected_option_id, _rawAppStData.list[i].is_active));

                            if(_rawAppStData.list[i].connected_option_id.length == 0){
                                _tmpGnrlApSt.push(_rawAppStData.list[i].option_id);
                            }
                        }
                        
                    }
                    this._applicStand = _tmpAppSt;
                    this._generalApplicStandIds = _tmpGnrlApSt;
                }

                let _tmpInsuGr: Array<OptionsConnectedDef> = [];
                let _tmpGnrlInGr: Array<string> = [];
                let _rawInsuGrData:any = this.getDocTypeData(respJson.data,'ds_insulationGrade');
                if(_rawInsuGrData != null) {
                    for(var i=0; i<_rawInsuGrData.list.length; i++) {
                        if(_rawInsuGrData.list[i].is_active === true){
                            _tmpInsuGr.push(new OptionsConnectedDef(_rawInsuGrData.list[i].option_id, _rawInsuGrData.list[i].option_name,_rawInsuGrData.list[i].connected_option_id, _rawInsuGrData.list[i].is_active));

                            if(_rawInsuGrData.list[i].connected_option_id.length == 0){
                                _tmpGnrlInGr.push(_rawInsuGrData.list[i].option_id);
                            }
                        }
                        
                    }
                    this._insulationGrade = _tmpInsuGr;
                    this._generalInsulationGradeIds = _tmpGnrlInGr;
                }

                let _tmpWrTyV2: Array<OptionsDef> = [];
                let _rawWrTyV2Data:any = this.getDocTypeData(respJson.data,'ds_wireTypV2');
                if(_rawWrTyV2Data != null) {
                    for(var i=0; i<_rawWrTyV2Data.list.length; i++) {
                        if(_rawWrTyV2Data.list[i].is_active === true){
                            _tmpWrTyV2.push(new OptionsDef(_rawWrTyV2Data.list[i].option_id, _rawWrTyV2Data.list[i].option_name, _rawWrTyV2Data.list[i].is_active));
                        }
                        
                    }
                    this._wireTypV2 = _tmpWrTyV2;
                }

                let _tmpCCir: Array<OptionsDef> = [];
                let _rawCCirData:any = this.getDocTypeData(respJson.data,'ds_ctCirc');
                if(_rawCCirData != null) {
                    for(var i=0; i<_rawCCirData.list.length; i++) {
                        if(_rawCCirData.list[i].is_active === true){
                            _tmpCCir.push(new OptionsDef(_rawCCirData.list[i].option_id, _rawCCirData.list[i].option_name, _rawCCirData.list[i].is_active));
                        }
                        
                    }
                    this._ctCirc = _tmpCCir;
                }

                let _tmpPCir: Array<OptionsDef> = [];
                let _rawPCirData:any = this.getDocTypeData(respJson.data,'ds_ptCirc');
                if(_rawPCirData != null) {
                    for(var i=0; i<_rawPCirData.list.length; i++) {
                        if(_rawPCirData.list[i].is_active === true){
                            _tmpPCir.push(new OptionsDef(_rawPCirData.list[i].option_id, _rawPCirData.list[i].option_name, _rawPCirData.list[i].is_active));
                        }
                        
                    }
                    this._ptCirc = _tmpPCir;
                }

                let _tmpDCCir: Array<OptionsDef> = [];
                let _rawDCCirData:any = this.getDocTypeData(respJson.data,'ds_dcConCirc');
                if(_rawDCCirData != null) {
                    for(var i=0; i<_rawDCCirData.list.length; i++) {
                        if(_rawDCCirData.list[i].is_active === true){
                            _tmpDCCir.push(new OptionsDef(_rawDCCirData.list[i].option_id, _rawDCCirData.list[i].option_name, _rawDCCirData.list[i].is_active));
                        }
                        
                    }
                    this._dcConCirc = _tmpDCCir;
                }

                let _tmpDCCirCol: Array<OptionsDef> = [];
                let _rawDCCirColData:any = this.getDocTypeData(respJson.data,'ds_dcConCircColor');
                if(_rawDCCirColData != null) {
                    for(var i=0; i<_rawDCCirColData.list.length; i++) {
                        if(_rawDCCirColData.list[i].is_active === true){
                            _tmpDCCirCol.push(new OptionsDef(_rawDCCirColData.list[i].option_id, _rawDCCirColData.list[i].option_name, _rawDCCirColData.list[i].is_active));
                        }
                        
                    }
                    this._dcConCircColor = _tmpDCCirCol;
                }

                let _tmpACCir: Array<OptionsDef> = [];
                let _rawACCirData:any = this.getDocTypeData(respJson.data,'ds_acConCirc');
                if(_rawACCirData != null) {
                    for(var i=0; i<_rawACCirData.list.length; i++) {
                        if(_rawACCirData.list[i].is_active === true){
                            _tmpACCir.push(new OptionsDef(_rawACCirData.list[i].option_id, _rawACCirData.list[i].option_name, _rawACCirData.list[i].is_active));
                        }
                        
                    }
                    this._acConCirc = _tmpACCir;
                }

                let _tmpACCirCol: Array<OptionsDef> = [];
                let _rawACCirColData:any = this.getDocTypeData(respJson.data,'ds_acConCircColor');
                if(_rawACCirColData != null) {
                    for(var i=0; i<_rawACCirColData.list.length; i++) {
                        if(_rawACCirColData.list[i].is_active === true){
                            _tmpACCirCol.push(new OptionsDef(_rawACCirColData.list[i].option_id, _rawACCirColData.list[i].option_name, _rawACCirColData.list[i].is_active));
                        }
                        
                    }
                    this._acConCircColor = _tmpACCirCol;
                }

                let _tmpErWr: Array<OptionsDef> = [];
                let _rawErWrData:any = this.getDocTypeData(respJson.data,'ds_earthWire');
                if(_rawErWrData != null) {
                    for(var i=0; i<_rawErWrData.list.length; i++) {
                        if(_rawErWrData.list[i].is_active === true){
                            _tmpErWr.push(new OptionsDef(_rawErWrData.list[i].option_id, _rawErWrData.list[i].option_name, _rawErWrData.list[i].is_active));
                        }
                        
                    }
                    this._earthWire = _tmpErWr;
                }

                let _tmpErWrCol: Array<OptionsDef> = [];
                let _rawErWrColData:any = this.getDocTypeData(respJson.data,'ds_earthWireColor');
                if(_rawErWrColData != null) {
                    for(var i=0; i<_rawErWrColData.list.length; i++) {
                        if(_rawErWrColData.list[i].is_active === true){
                            _tmpErWrCol.push(new OptionsDef(_rawErWrColData.list[i].option_id, _rawErWrColData.list[i].option_name, _rawErWrColData.list[i].is_active));
                        }
                        
                    }
                    this._earthWireColor = _tmpErWrCol;
                }

                let _tmpMnDCCir: Array<OptionsDef> = [];
                let _rawMnDCCirData:any = this.getDocTypeData(respJson.data,'ds_mainDCCirc');
                if(_rawMnDCCirData != null) {
                    for(var i=0; i<_rawMnDCCirData.list.length; i++) {
                        if(_rawMnDCCirData.list[i].is_active === true){
                            _tmpMnDCCir.push(new OptionsDef(_rawMnDCCirData.list[i].option_id, _rawMnDCCirData.list[i].option_name, _rawMnDCCirData.list[i].is_active));
                        }
                        
                    }
                    this._mainDCCirc = _tmpMnDCCir;
                }

                let _tmpMnDCCirCol: Array<OptionsDef> = [];
                let _rawMnDCCirColData:any = this.getDocTypeData(respJson.data,'ds_mainDCCircColor');
                if(_rawMnDCCirColData != null) {
                    for(var i=0; i<_rawMnDCCirColData.list.length; i++) {
                        if(_rawMnDCCirColData.list[i].is_active === true){
                            _tmpMnDCCirCol.push(new OptionsDef(_rawMnDCCirColData.list[i].option_id, _rawMnDCCirColData.list[i].option_name, _rawMnDCCirColData.list[i].is_active));
                        }
                        
                    }
                    this._mainDCCircColor = _tmpMnDCCirCol;
                }

                let _tmpMnACCir: Array<OptionsDef> = [];
                let _rawMnACCirData:any = this.getDocTypeData(respJson.data,'ds_mainACCirc');
                if(_rawMnACCirData != null) {
                    for(var i=0; i<_rawMnACCirData.list.length; i++) {
                        if(_rawMnACCirData.list[i].is_active === true){
                            _tmpMnACCir.push(new OptionsDef(_rawMnACCirData.list[i].option_id, _rawMnACCirData.list[i].option_name, _rawMnACCirData.list[i].is_active));
                        }
                        
                    }
                    this._mainACCirc = _tmpMnACCir;
                }

                let _tmpMnACCirCol: Array<OptionsDef> = [];
                let _rawMnACCirColData:any = this.getDocTypeData(respJson.data,'ds_mainACCircColor');
                if(_rawMnACCirColData != null) {
                    for(var i=0; i<_rawMnACCirColData.list.length; i++) {
                        if(_rawMnACCirColData.list[i].is_active === true){
                            _tmpMnACCirCol.push(new OptionsDef(_rawMnACCirColData.list[i].option_id, _rawMnACCirColData.list[i].option_name, _rawMnACCirColData.list[i].is_active));
                        }
                        
                    }
                    this._mainACCircColor = _tmpMnACCirCol;
                }

                let _tmpFr: Array<OptionsDef> = [];
                let _rawFrData:any = this.getDocTypeData(respJson.data,'ds_ferrulling');
                if(_rawFrData != null) {
                    for(var i=0; i<_rawFrData.list.length; i++) {
                        if(_rawFrData.list[i].is_active === true){
                            _tmpFr.push(new OptionsDef(_rawFrData.list[i].option_id, _rawFrData.list[i].option_name, _rawFrData.list[i].is_active));
                        }
                        
                    }
                    this._ferrulling = _tmpFr;
                }

                let _tmpFerrMat: Array<OptionsDef> = [];
                let _rawFerrMatData:any = this.getDocTypeData(respJson.data,'ds_ferrullingMat');
                if(_rawFerrMatData != null) {
                    for(var i=0; i<_rawFerrMatData.list.length; i++) {
                        if(_rawFerrMatData.list[i].is_active === true){
                            _tmpFerrMat.push(new OptionsDef(_rawFerrMatData.list[i].option_id, _rawFerrMatData.list[i].option_name, _rawFerrMatData.list[i].is_active));
                        }
                        
                    }
                    this._ferrullingMat = _tmpFerrMat;
                }

                let _tmpRackIO: Array<OptionsConnectedDef> = [];
                let _tmpGnrlRackIO: Array<string> = [];
                let _rawRackIOData:any = this.getDocTypeData(respJson.data,'ds_rackInOutMech');
                if(_rawRackIOData != null) {
                    for(var i=0; i<_rawRackIOData.list.length; i++) {
                        if(_rawRackIOData.list[i].is_active === true){
                            _tmpRackIO.push(new OptionsConnectedDef(_rawRackIOData.list[i].option_id, _rawRackIOData.list[i].option_name,_rawRackIOData.list[i].connected_option_id, _rawRackIOData.list[i].is_active));
                        }
                        if (_rawRackIOData.list[i].connected_option_id.length == 0) {
                            _tmpGnrlRackIO.push(_rawRackIOData.list[i].option_id);
                        }

                        
                    }
                    this._rackInOutMech = _tmpRackIO;
                    this._generalRackInOutMechIds = _tmpGnrlRackIO;
                }

                let _tmpMaxDComp: Array<OptionsConnectedDef> = [];
                let _tmpGnrlMaxDc: Array<string> = [];
                let _rawMaxDCompData:any = this.getDocTypeData(respJson.data,'ds_maxDCComp');
                if(_rawMaxDCompData != null) {
                    for(var i=0; i<_rawMaxDCompData.list.length; i++) {
                        if(_rawMaxDCompData.list[i].is_active === true){
                            _tmpMaxDComp.push(new OptionsConnectedDef(_rawMaxDCompData.list[i].option_id, _rawMaxDCompData.list[i].option_name,_rawMaxDCompData.list[i].connected_option_id, _rawMaxDCompData.list[i].is_active));
                        }
                                if(_rawMaxDCompData.list[i].connected_option_id.length == 0){
                                _tmpGnrlMaxDc.push(_rawMaxDCompData.list[i].option_id);
                            }
                        }
                        
                    
                    this._maxDCComp = _tmpMaxDComp;
                    this._generalMaxDCIds = _tmpGnrlMaxDc;
                    
                }
                

                let _tmpConVUv: Array<OptionsDef> = [];
                let _rawConVUvData:any = this.getDocTypeData(respJson.data,'ds_conVoltUVCoil');
                if(_rawConVUvData != null) {
                    for(var i=0; i<_rawConVUvData.list.length; i++) {
                        if(_rawConVUvData.list[i].is_active === true){
                            _tmpConVUv.push(new OptionsDef(_rawConVUvData.list[i].option_id, _rawConVUvData.list[i].option_name, _rawConVUvData.list[i].is_active));
                        }
                        
                    }
                    this._cbConVoltUVCoil = _tmpConVUv;
                }

                let _tmpVCCTrV: Array<OptionsDef> = [];
                let _rawVCCTrVData:any = this.getDocTypeData(respJson.data,'ds_vacContCloseTripVolt');
                if(_rawVCCTrVData != null) {
                    for(var i=0; i<_rawVCCTrVData.list.length; i++) {
                        if(_rawVCCTrVData.list[i].is_active === true){
                            _tmpVCCTrV.push(new OptionsDef(_rawVCCTrVData.list[i].option_id, _rawVCCTrVData.list[i].option_name, _rawVCCTrVData.list[i].is_active));
                        }
                        
                    }
                    this._cbCloseTripVolt = _tmpVCCTrV;
                }

                let _tmpLtc: Array<OptionsDef> = [];
                let _rawLtcData:any = this.getDocTypeData(respJson.data,'ds_latchTyp');
                if(_rawLtcData != null) {
                    for(var i=0; i<_rawLtcData.list.length; i++) {
                        if(_rawLtcData.list[i].is_active === true){
                            _tmpLtc.push(new OptionsDef(_rawLtcData.list[i].option_id, _rawLtcData.list[i].option_name, _rawLtcData.list[i].is_active));
                        }
                        
                    }
                    this._cbLatchType = _tmpLtc;
                }

                let _tmpCtMol: Array<OptionsDef> = [];
                let _rawCtMolData:any = this.getDocTypeData(respJson.data,'ds_ctMould');
                if(_rawCtMolData != null) {
                    for(var i=0; i<_rawCtMolData.list.length; i++) {
                        if(_rawCtMolData.list[i].is_active === true){
                            _tmpCtMol.push(new OptionsDef(_rawCtMolData.list[i].option_id, _rawCtMolData.list[i].option_name, _rawCtMolData.list[i].is_active));
                        }
                        
                    }
                    this._ctMould = _tmpCtMol;
                }

                let _tmpCtMolLst: Array<OptionsDef> = [];
                let _rawCtMolLstData:any = this.getDocTypeData(respJson.data,'ds_ctMouldList');
                if(_rawCtMolLstData != null) {
                    for(var i=0; i<_rawCtMolLstData.list.length; i++) {
                        if(_rawCtMolLstData.list[i].is_active === true){
                            _tmpCtMolLst.push(new OptionsDef(_rawCtMolLstData.list[i].option_id, _rawCtMolLstData.list[i].option_name, _rawCtMolLstData.list[i].is_active));
                        }
                        
                    }
                    this._ctMouldList = _tmpCtMolLst;
                }

                let _tmpInsCl: Array<OptionsDef> = [];
                let _rawInsClData:any = this.getDocTypeData(respJson.data,'ds_ctInsulClass');
                if(_rawInsClData != null) {
                    for(var i=0; i<_rawInsClData.list.length; i++) {
                        if(_rawInsClData.list[i].is_active === true){
                            _tmpInsCl.push(new OptionsDef(_rawInsClData.list[i].option_id, _rawInsClData.list[i].option_name, _rawInsClData.list[i].is_active));
                        }
                        
                    }
                    this._insulClass = _tmpInsCl;
                }

                let _tmpInstrSf: Array<OptionsDef> = [];
                let _rawInstrSfData:any = this.getDocTypeData(respJson.data,'ds_ctInstruSafety');
                if(_rawInstrSfData != null) {
                    for(var i=0; i<_rawInstrSfData.list.length; i++) {
                        if(_rawInstrSfData.list[i].is_active === true){
                            _tmpInstrSf.push(new OptionsDef(_rawInstrSfData.list[i].option_id, _rawInstrSfData.list[i].option_name, _rawInstrSfData.list[i].is_active));
                        }
                        
                    }
                    this._instruSafety = _tmpInstrSf;
                }

                let _tmpShTCDr: Array<OptionsDef> = [];
                let _rawShTCDrData:any = this.getDocTypeData(respJson.data,'ds_ctShortTimeCurrDr');
                if(_rawShTCDrData != null) {
                    for(var i=0; i<_rawShTCDrData.list.length; i++) {
                        if(_rawShTCDrData.list[i].is_active === true){
                            _tmpShTCDr.push(new OptionsDef(_rawShTCDrData.list[i].option_id, _rawShTCDrData.list[i].option_name, _rawShTCDrData.list[i].is_active));
                        }
                        
                    }
                    this._ctShortTimeCurrDr = _tmpShTCDr;
                }

                let _tmpCCRat: Array<OptionsDef> = [];
                let _rawCCRatData:any = this.getDocTypeData(respJson.data,'ds_ctCbCtRatio');
                if(_rawCCRatData != null) {
                    for(var i=0; i<_rawCCRatData.list.length; i++) {
                        if(_rawCCRatData.list[i].is_active === true){
                            _tmpCCRat.push(new OptionsDef(_rawCCRatData.list[i].option_id, _rawCCRatData.list[i].option_name, _rawCCRatData.list[i].is_active));
                        }
                        
                    }
                    this._ctCbCtRatio = _tmpCCRat;
                }

                let _tmpPotTfMoun: Array<OptionsConnectedValueDef> = [];
                let _tmpGnrlPotTfMoun: Array<string> = [];
                let _rawPotTfMounData: any = this.getDocTypeData(respJson.data, 'ds_ptTrfMountingTyp');
                if (_rawPotTfMounData != null) {
                    for (var i = 0; i < _rawPotTfMounData.list.length; i++) {
                        if (_rawPotTfMounData.list[i].is_active === true) {
                            _tmpPotTfMoun.push(new OptionsConnectedValueDef(_rawPotTfMounData.list[i].option_id, _rawPotTfMounData.list[i].option_name, _rawPotTfMounData.list[i].connected_value, _rawPotTfMounData.list[i].connected_option_id, _rawPotTfMounData.list[i].is_active, _rawPotTfMounData.list[i].connected_value_list));
                        }
                        if (_rawPotTfMounData.list[i].connected_option_id.length == 0) {
                            _tmpGnrlPotTfMoun.push(_rawPotTfMounData.list[i].option_id);
                        }


                    }
                    this._potTrafoMountingTyp = _tmpPotTfMoun;
                    this._generalPotTrafoMountingTypIds = _tmpGnrlPotTfMoun;
                }

                let _tmpPotTfMounLst: Array<OptionsDef> = [];
                let _rawPotTfMounLstData:any = this.getDocTypeData(respJson.data,'ds_ptTrfMountingTypList');
                if(_rawPotTfMounLstData != null) {
                    for(var i=0; i<_rawPotTfMounLstData.list.length; i++) {
                        if(_rawPotTfMounLstData.list[i].is_active === true){
                            _tmpPotTfMounLst.push(new OptionsDef(_rawPotTfMounLstData.list[i].option_id, _rawPotTfMounLstData.list[i].option_name, _rawPotTfMounLstData.list[i].is_active));
                        }
                        
                    }
                    this._potTrafoMountingTypList = _tmpPotTfMounLst;
                }

                let _tmpNumRelMk: Array<OptionsDef> = [];
                let _rawNumRelMkData:any = this.getDocTypeData(respJson.data,'ds_numRelMake');
                if(_rawNumRelMkData != null) {
                    for(var i=0; i<_rawNumRelMkData.list.length; i++) {
                        if(_rawNumRelMkData.list[i].is_active === true){
                            _tmpNumRelMk.push(new OptionsDef(_rawNumRelMkData.list[i].option_id, _rawNumRelMkData.list[i].option_name, _rawNumRelMkData.list[i].is_active));
                        }
                        
                    }
                    this._numRelMake = _tmpNumRelMk;
                }

                let _tmpNumRelMkDt: Array<OptionsDef> = [];
                let _rawNumRelMkDtData:any = this.getDocTypeData(respJson.data,'ds_numRelMakeDetail');
                if(_rawNumRelMkDtData != null) {
                    for(var i=0; i<_rawNumRelMkDtData.list.length; i++) {
                        if(_rawNumRelMkDtData.list[i].is_active === true){
                            _tmpNumRelMkDt.push(new OptionsDef(_rawNumRelMkDtData.list[i].option_id, _rawNumRelMkDtData.list[i].option_name, _rawNumRelMkDtData.list[i].is_active));
                        }
                        
                    }
                    this._numRelMakeDetail = _tmpNumRelMkDt;
                }

                let _tmpNRCommP: Array<OptionsConnectedDef> = [];
                let _tmpGnrlNumRelCommPrtcl: Array<string> = [];
                let _rawNRCommPData:any = this.getDocTypeData(respJson.data,'ds_numRelCommPrtcl');
                if(_rawNRCommPData != null) {
                    for(var i=0; i<_rawNRCommPData.list.length; i++) {
                        if(_rawNRCommPData.list[i].is_active === true){
                            _tmpNRCommP.push(new OptionsConnectedDef(_rawNRCommPData.list[i].option_id, _rawNRCommPData.list[i].option_name,_rawNRCommPData.list[i].connected_option_id, _rawNRCommPData.list[i].is_active));
                        }
                        if(_rawNRCommPData.list[i].connected_option_id.length == 0){
                                _tmpGnrlNumRelCommPrtcl.push(_rawNRCommPData.list[i].option_id);
                            }
                        
                    }
                    this._numRelCommPrtcl = _tmpNRCommP;
                    this._generalNumRelCommPrtclIds = _tmpGnrlNumRelCommPrtcl;
                }

                let _tmpNRComPort: Array<OptionsConnectedDef> = [];
                let _tmpGnrlNumRelCommPort: Array<string> = [];
                let _rawNRComPortData:any = this.getDocTypeData(respJson.data,'ds_numRelCommPort');
                if(_rawNRComPortData != null) {
                    for(var i=0; i<_rawNRComPortData.list.length; i++) {
                        if(_rawNRComPortData.list[i].is_active === true){
                            _tmpNRComPort.push(new OptionsConnectedDef(_rawNRComPortData.list[i].option_id, _rawNRComPortData.list[i].option_name,_rawNRComPortData.list[i].connected_option_id, _rawNRComPortData.list[i].is_active));
                        }
                                if(_rawNRComPortData.list[i].connected_option_id.length == 0){
                                _tmpGnrlNumRelCommPort.push(_rawNRComPortData.list[i].option_id);
                            }
                        }
                        
                    
                    this._numRelCommPort = _tmpNRComPort;
                    this._generalNumRelCommPortIds = _tmpGnrlNumRelCommPort;
                    
                }

                let _tmpNRTimeSy: Array<OptionsDef> = [];
                let _rawNRTimeSyData:any = this.getDocTypeData(respJson.data,'ds_numRelTimeSync');
                if(_rawNRTimeSyData != null) {
                    for(var i=0; i<_rawNRTimeSyData.list.length; i++) {
                        if(_rawNRTimeSyData.list[i].is_active === true){
                            _tmpNRTimeSy.push(new OptionsDef(_rawNRTimeSyData.list[i].option_id, _rawNRTimeSyData.list[i].option_name, _rawNRTimeSyData.list[i].is_active));
                        }
                        
                    }
                    this._numRelTimeSync = _tmpNRTimeSy;
                }

                let _tmpNRCoat: Array<OptionsDef> = [];
                let _rawNRCoatData:any = this.getDocTypeData(respJson.data,'ds_numRelCoating');
                if(_rawNRCoatData != null) {
                    for(var i=0; i<_rawNRCoatData.list.length; i++) {
                        if(_rawNRCoatData.list[i].is_active === true){
                            _tmpNRCoat.push(new OptionsDef(_rawNRCoatData.list[i].option_id, _rawNRCoatData.list[i].option_name, _rawNRCoatData.list[i].is_active));
                        }
                        
                    }
                    this._numRelCoating = _tmpNRCoat;
                }

                let _tmpNRTrReqRtd: Array<OptionsDef> = [];
                let _rawNRTrReqRtdData:any = this.getDocTypeData(respJson.data,'ds_numRelTransReqRTDList');
                if(_rawNRTrReqRtdData != null) {
                    for(var i=0; i<_rawNRTrReqRtdData.list.length; i++) {
                        if(_rawNRTrReqRtdData.list[i].is_active === true){
                            _tmpNRTrReqRtd.push(new OptionsDef(_rawNRTrReqRtdData.list[i].option_id, _rawNRTrReqRtdData.list[i].option_name, _rawNRTrReqRtdData.list[i].is_active));
                        }
                        
                    }
                    this._numRelTransReqRTDList = _tmpNRTrReqRtd;
                }

                let _tmpARTrpCo: Array<OptionsDef> = [];
                let _rawARTrpCoData:any = this.getDocTypeData(respJson.data,'ds_auxRelTripCoil1_2');
                if(_rawARTrpCoData != null) {
                    for(var i=0; i<_rawARTrpCoData.list.length; i++) {
                        if(_rawARTrpCoData.list[i].is_active === true){
                            _tmpARTrpCo.push(new OptionsDef(_rawARTrpCoData.list[i].option_id, _rawARTrpCoData.list[i].option_name, _rawARTrpCoData.list[i].is_active));
                        }
                        
                    }
                    this._auxRelTripCoil1_2 = _tmpARTrpCo;
                }

                let _tmpMMList: Array<OptionsDef> = [];
                let _rawMMListData:any = this.getDocTypeData(respJson.data,'ds_metMultiMeterList');
                if(_rawMMListData != null) {
                    for(var i=0; i<_rawMMListData.list.length; i++) {
                        if(_rawMMListData.list[i].is_active === true){
                            _tmpMMList.push(new OptionsDef(_rawMMListData.list[i].option_id, _rawMMListData.list[i].option_name, _rawMMListData.list[i].is_active));
                        }
                        
                    }
                    this._metMultiMeterList = _tmpMMList;
                }

                let _tmpMMComm: Array<OptionsDef> = [];
                let _rawMMCommData:any = this.getDocTypeData(respJson.data,'ds_metMultiComm');
                if(_rawMMCommData != null) {
                    for(var i=0; i<_rawMMCommData.list.length; i++) {
                        if(_rawMMCommData.list[i].is_active === true){
                            _tmpMMComm.push(new OptionsDef(_rawMMCommData.list[i].option_id, _rawMMCommData.list[i].option_name, _rawMMCommData.list[i].is_active));
                        }
                        
                    }
                    this._metMultiComm = _tmpMMComm;
                }

                let _tmpMMCommPort: Array<OptionsDef> = [];
                let _rawMMCommPortData:any = this.getDocTypeData(respJson.data,'ds_metMultiCommPort');
                if(_rawMMCommPortData != null) {
                    for(var i=0; i<_rawMMCommPortData.list.length; i++) {
                        if(_rawMMCommPortData.list[i].is_active === true){
                            _tmpMMCommPort.push(new OptionsDef(_rawMMCommPortData.list[i].option_id, _rawMMCommPortData.list[i].option_name, _rawMMCommPortData.list[i].is_active));
                        }
                        
                    }
                    this._metMultiCommPort = _tmpMMCommPort;
                }

                let _tmpSpecificMake: Array<OptionsDef> = [];
                let _rawSpecificMakeData: any = this.getDocTypeData(respJson.data, 'ds_metSpecificMake');
                if (_rawSpecificMakeData != null) {
                    for (var i = 0; i < _rawSpecificMakeData.list.length; i++) {
                        if (_rawSpecificMakeData.list[i].is_active === true) {
                            _tmpSpecificMake.push(new OptionsDef(_rawSpecificMakeData.list[i].option_id, _rawSpecificMakeData.list[i].option_name, _rawSpecificMakeData.list[i].is_active));
                        }

                    }
                    this._metSpecificMake = _tmpSpecificMake;
                }

                let _tmpMTriComm: Array<OptionsDef> = [];
                let _rawMTriCommData:any = this.getDocTypeData(respJson.data,'ds_metTriComm');
                if(_rawMTriCommData != null) {
                    for(var i=0; i<_rawMTriCommData.list.length; i++) {
                        if(_rawMTriCommData.list[i].is_active === true){
                            _tmpMTriComm.push(new OptionsDef(_rawMTriCommData.list[i].option_id, _rawMTriCommData.list[i].option_name, _rawMTriCommData.list[i].is_active));
                        }
                        
                    }
                    this._metTriComm = _tmpMTriComm;
                }

                let _tmpMTriCommPort: Array<OptionsDef> = [];
                let _rawMTriCommPortData:any = this.getDocTypeData(respJson.data,'ds_metTriCommPort');
                if(_rawMTriCommPortData != null) {
                    for(var i=0; i<_rawMTriCommPortData.list.length; i++) {
                        if(_rawMTriCommPortData.list[i].is_active === true){
                            _tmpMTriCommPort.push(new OptionsDef(_rawMTriCommPortData.list[i].option_id, _rawMTriCommPortData.list[i].option_name, _rawMTriCommPortData.list[i].is_active));
                        }
                        
                    }
                    this._metTriCommPort = _tmpMTriCommPort;
                }

                let _tmpMAmmTyp: Array<OptionsDef> = [];
                let _rawMAmmTypData:any = this.getDocTypeData(respJson.data,'ds_metAmmTyp');
                if(_rawMAmmTypData != null) {
                    for(var i=0; i<_rawMAmmTypData.list.length; i++) {
                        if(_rawMAmmTypData.list[i].is_active === true){
                            _tmpMAmmTyp.push(new OptionsDef(_rawMAmmTypData.list[i].option_id, _rawMAmmTypData.list[i].option_name, _rawMAmmTypData.list[i].is_active));
                        }
                        
                    }
                    this._metAmmType = _tmpMAmmTyp;
                }

                let _tmpMAmmDisp: Array<OptionsConnectedDef> = [];
                let _tmpGnrlMAmmDisp: Array<string> = [];
                let _rawMAmmDispData:any = this.getDocTypeData(respJson.data,'ds_metAmmDisplay');
                if(_rawMAmmDispData != null) {
                    for(var i=0; i<_rawMAmmDispData.list.length; i++) {
                        if(_rawMAmmDispData.list[i].is_active === true){
                            _tmpMAmmDisp.push(new OptionsConnectedDef(_rawMAmmDispData.list[i].option_id, _rawMAmmDispData.list[i].option_name,_rawMAmmDispData.list[i].connected_option_id, _rawMAmmDispData.list[i].is_active));
                        }
                                 if(_rawMAmmDispData.list[i].connected_option_id.length == 0){
                                _tmpGnrlMAmmDisp.push(_rawMAmmDispData.list[i].option_id);
                            }
                        }
                        
                    this._metAmmDisplay = _tmpMAmmDisp;
                    this._generalMetAmmDisplayIds = _tmpGnrlMAmmDisp;
                    
                }

                let _tmpSurgAr: Array<OptionsConnectedDef> = [];
                let _tmpGnrlSurgAr: Array<string> = [];
                let _rawSurgArData:any = this.getDocTypeData(respJson.data,'ds_surgeArr');
                if(_rawSurgArData != null) {
                    for(var i=0; i<_rawSurgArData.list.length; i++) {
                        if(_rawSurgArData.list[i].is_active === true){
                            _tmpSurgAr.push(new OptionsConnectedDef(_rawSurgArData.list[i].option_id, _rawSurgArData.list[i].option_name,_rawSurgArData.list[i].connected_option_id, _rawSurgArData.list[i].is_active));
                        }
                                 if(_rawSurgArData.list[i].connected_option_id.length == 0){
                                _tmpGnrlSurgAr.push(_rawSurgArData.list[i].option_id);
                            }
                        }
                        
                    this._surgeArr = _tmpSurgAr;
                    this._generalSurgeArrIds = _tmpGnrlSurgAr;
                    
                }

                let _tmpAnnTyp: Array<OptionsDef> = [];
                let _rawAnnTypData:any = this.getDocTypeData(respJson.data,'ds_annunTyp');
                if(_rawAnnTypData != null) {
                    for(var i=0; i<_rawAnnTypData.list.length; i++) {
                        if(_rawAnnTypData.list[i].is_active === true){
                            _tmpAnnTyp.push(new OptionsDef(_rawAnnTypData.list[i].option_id, _rawAnnTypData.list[i].option_name, _rawAnnTypData.list[i].is_active));
                        }
                        
                    }
                    this._annunTyp = _tmpAnnTyp;
                }

                let _tmpAnnComP: Array<OptionsDef> = [];
                let _rawAnnComPData:any = this.getDocTypeData(respJson.data,'ds_annunCommPort');
                if(_rawAnnComPData != null) {
                    for(var i=0; i<_rawAnnComPData.list.length; i++) {
                        if(_rawAnnComPData.list[i].is_active === true){
                            _tmpAnnComP.push(new OptionsDef(_rawAnnComPData.list[i].option_id, _rawAnnComPData.list[i].option_name, _rawAnnComPData.list[i].is_active));
                        }
                        
                    }
                    this._annunCommPort = _tmpAnnComP;
                }

                let _tmpSwBrkTp: Array<OptionsDef> = [];
                let _rawSwBrkTpData:any = this.getDocTypeData(respJson.data,'ds_swBreakTrip');
                if(_rawSwBrkTpData != null) {
                    for(var i=0; i<_rawSwBrkTpData.list.length; i++) {
                        if(_rawSwBrkTpData.list[i].is_active === true){
                            _tmpSwBrkTp.push(new OptionsDef(_rawSwBrkTpData.list[i].option_id, _rawSwBrkTpData.list[i].option_name, _rawSwBrkTpData.list[i].is_active));
                        }
                        
                    }
                    this._swBreakTrip = _tmpSwBrkTp;
                }

                let _tmpSwRem: Array<OptionsDef> = [];
                let _rawSwRemData:any = this.getDocTypeData(respJson.data,'ds_swRemHandleTyp');
                if(_rawSwRemData != null) {
                    for(var i=0; i<_rawSwRemData.list.length; i++) {
                        if(_rawSwRemData.list[i].is_active === true){
                            _tmpSwRem.push(new OptionsDef(_rawSwRemData.list[i].option_id, _rawSwRemData.list[i].option_name, _rawSwRemData.list[i].is_active));
                        }
                        
                    }
                    this._swRemHandleType = _tmpSwRem;
                }

                let _tmpSwVolt: Array<OptionsDef> = [];
                let _rawSwVoltData:any = this.getDocTypeData(respJson.data,'ds_swVoltSelector');
                if(_rawSwVoltData != null) {
                    for(var i=0; i<_rawSwVoltData.list.length; i++) {
                        if(_rawSwVoltData.list[i].is_active === true){
                            _tmpSwVolt.push(new OptionsDef(_rawSwVoltData.list[i].option_id, _rawSwVoltData.list[i].option_name, _rawSwVoltData.list[i].is_active));
                        }
                        
                    }
                    this._swVoltSelector = _tmpSwVolt;
                }

                let _tmpEthComA: Array<OptionsConnectedValueDef> = [];
                let _tmpGnrlEthComA: Array<string> = [];
                let _rawEthComAData:any = this.getDocTypeData(respJson.data,'ds_ethCommArch');
                if(_rawEthComAData != null) {
                    for(var i=0; i<_rawEthComAData.list.length; i++) {
                        if(_rawEthComAData.list[i].is_active === true){
                            _tmpEthComA.push(new OptionsConnectedValueDef(_rawEthComAData.list[i].option_id, _rawEthComAData.list[i].option_name,  _rawEthComAData.list[i].connected_value,  _rawEthComAData.list[i].connected_option_id, _rawEthComAData.list[i].is_active));
                        }
                                 if(_rawEthComAData.list[i].connected_option_id.length == 0){
                                _tmpGnrlEthComA.push(_rawEthComAData.list[i].option_id);
                            }
                        }
                        
                    this._ethCommArch = _tmpEthComA;
                    this._generalEthCommArchIds = _tmpGnrlEthComA;
                    
                }

                let _tmpEthConfPp: Array<OptionsConnectedDef> = [];
                let _tmpGnrlEthConfPp: Array<string> = [];
                let _rawEthConfPpData:any = this.getDocTypeData(respJson.data,'ds_ethConfPopup');
                if(_rawEthConfPpData != null) {
                    for(var i=0; i<_rawEthConfPpData.list.length; i++) {
                        if(_rawEthConfPpData.list[i].is_active === true){
                            _tmpEthConfPp.push(new OptionsConnectedDef(_rawEthConfPpData.list[i].option_id, _rawEthConfPpData.list[i].option_name,_rawEthConfPpData.list[i].connected_option_id, _rawEthConfPpData.list[i].is_active));
                        }
                                 if(_rawEthConfPpData.list[i].connected_option_id.length == 0){
                                _tmpGnrlEthConfPp.push(_rawEthConfPpData.list[i].option_id);
                            }
                        }
                        
                    this._ethConfPopup = _tmpEthConfPp;
                    this._generalEthConfPopupIds = _tmpGnrlEthConfPp;
                    
                }

                let _tmpEthRem: Array<OptionsDef> = [];
                let _rawEthRemData:any = this.getDocTypeData(respJson.data,'ds_ethRemComm');
                if(_rawEthRemData != null) {
                    for(var i=0; i<_rawEthRemData.list.length; i++) {
                        if(_rawEthRemData.list[i].is_active === true){
                            _tmpEthRem.push(new OptionsDef(_rawEthRemData.list[i].option_id, _rawEthRemData.list[i].option_name, _rawEthRemData.list[i].is_active));
                        }
                        
                    }
                    this._ethRemComm = _tmpEthRem;
                }

                let _tmpEthAuxSup: Array<OptionsDef> = [];
                let _rawEthAuxSupData:any = this.getDocTypeData(respJson.data,'ds_ethAuxSupply');
                if(_rawEthAuxSupData != null) {
                    for(var i=0; i<_rawEthAuxSupData.list.length; i++) {
                        if(_rawEthAuxSupData.list[i].is_active === true){
                            _tmpEthAuxSup.push(new OptionsDef(_rawEthAuxSupData.list[i].option_id, _rawEthAuxSupData.list[i].option_name, _rawEthAuxSupData.list[i].is_active));
                        }
                        
                    }
                    this._ethAuxSupply = _tmpEthAuxSup;
                }

                let _tmpEthPwrSup: Array<OptionsDef> = [];
                let _rawEthPwrSupData:any = this.getDocTypeData(respJson.data,'ds_ethPowerSup1_2');
                if(_rawEthPwrSupData != null) {
                    for(var i=0; i<_rawEthPwrSupData.list.length; i++) {
                        if(_rawEthPwrSupData.list[i].is_active === true){
                            _tmpEthPwrSup.push(new OptionsDef(_rawEthPwrSupData.list[i].option_id, _rawEthPwrSupData.list[i].option_name, _rawEthPwrSupData.list[i].is_active));
                        }
                        
                    }
                    this._ethPowerSup1_2 = _tmpEthPwrSup;
                }

                let _tmpEthCoat: Array<OptionsDef> = [];
                let _rawEthCoatData:any = this.getDocTypeData(respJson.data,'ds_ethCoating');
                if(_rawEthCoatData != null) {
                    for(var i=0; i<_rawEthCoatData.list.length; i++) {
                        if(_rawEthCoatData.list[i].is_active === true){
                            _tmpEthCoat.push(new OptionsDef(_rawEthCoatData.list[i].option_id, _rawEthCoatData.list[i].option_name, _rawEthCoatData.list[i].is_active));
                        }
                        
                    }
                    this._ethCoating = _tmpEthCoat;
                }

                let _tmpEthMntg: Array<OptionsDef> = [];
                let _rawEthMntgData:any = this.getDocTypeData(respJson.data,'ds_ethMounting');
                if(_rawEthMntgData != null) {
                    for(var i=0; i<_rawEthMntgData.list.length; i++) {
                        if(_rawEthMntgData.list[i].is_active === true){
                            _tmpEthMntg.push(new OptionsDef(_rawEthMntgData.list[i].option_id, _rawEthMntgData.list[i].option_name, _rawEthMntgData.list[i].is_active));
                        }
                        
                    }
                    this._ethMounting = _tmpEthMntg;
                }

                let _tmpErtDevB: Array<OptionsDef> = [];
                let _rawErtDevBData:any = this.getDocTypeData(respJson.data,'ds_erthDeviceBus');
                if(_rawErtDevBData != null) {
                    for(var i=0; i<_rawErtDevBData.list.length; i++) {
                        if(_rawErtDevBData.list[i].is_active === true){
                            _tmpErtDevB.push(new OptionsDef(_rawErtDevBData.list[i].option_id, _rawErtDevBData.list[i].option_name, _rawErtDevBData.list[i].is_active));
                        }
                        
                    }
                    this._erthDeviceBus = _tmpErtDevB;
                }

                let _tmpErtDevC: Array<OptionsDef> = [];
                let _rawErtDevCData:any = this.getDocTypeData(respJson.data,'ds_erthDeviceCable');
                if(_rawErtDevCData != null) {
                    for(var i=0; i<_rawErtDevCData.list.length; i++) {
                        if(_rawErtDevCData.list[i].is_active === true){
                            _tmpErtDevC.push(new OptionsDef(_rawErtDevCData.list[i].option_id, _rawErtDevCData.list[i].option_name, _rawErtDevCData.list[i].is_active));
                        }
                        
                    }
                    this._erthDeviceCable = _tmpErtDevC;
                }

                let _tmpSplDevVolInd: Array<OptionsDef> = [];
                let _rawSplDevVolIndData:any = this.getDocTypeData(respJson.data,'ds_splDevVolIndicator');
                if(_rawSplDevVolIndData != null) {
                    for(var i=0; i<_rawSplDevVolIndData.list.length; i++) {
                        if(_rawSplDevVolIndData.list[i].is_active === true){
                            _tmpSplDevVolInd.push(new OptionsDef(_rawSplDevVolIndData.list[i].option_id, _rawSplDevVolIndData.list[i].option_name, _rawSplDevVolIndData.list[i].is_active));
                        }
                        
                    }
                    this._splDevVolIndicator = _tmpSplDevVolInd;
                }

                let _tmpSplDevMntg: Array<OptionsDef> = [];
                let _rawSplDevMntgData:any = this.getDocTypeData(respJson.data,'ds_splDevMounting');
                if(_rawSplDevMntgData != null) {
                    for(var i=0; i<_rawSplDevMntgData.list.length; i++) {
                        if(_rawSplDevMntgData.list[i].is_active === true){
                            _tmpSplDevMntg.push(new OptionsDef(_rawSplDevMntgData.list[i].option_id, _rawSplDevMntgData.list[i].option_name, _rawSplDevMntgData.list[i].is_active));
                        }
                        
                    }
                    this._splDevMounting = _tmpSplDevMntg;
                }

                let _tmpSplDevTempMSys: Array<OptionsDef> = [];
                let _rawSplDevTempMSysData:any = this.getDocTypeData(respJson.data,'ds_splDevTempMSys');
                if(_rawSplDevTempMSysData != null) {
                    for(var i=0; i<_rawSplDevTempMSysData.list.length; i++) {
                        if(_rawSplDevTempMSysData.list[i].is_active === true){
                            _tmpSplDevTempMSys.push(new OptionsDef(_rawSplDevTempMSysData.list[i].option_id, _rawSplDevTempMSysData.list[i].option_name, _rawSplDevTempMSysData.list[i].is_active));
                        }
                        
                    }
                    this._splDevTempMSys = _tmpSplDevTempMSys;
                }

                let _tmpSplDevSensorTyp: Array<OptionsDef> = [];
                let _rawSplDevSensorTypData:any = this.getDocTypeData(respJson.data,'ds_splDevSensorTyp');
                if(_rawSplDevSensorTypData != null) {
                    for(var i=0; i<_rawSplDevSensorTypData.list.length; i++) {
                        if(_rawSplDevSensorTypData.list[i].is_active === true){
                            _tmpSplDevSensorTyp.push(new OptionsDef(_rawSplDevSensorTypData.list[i].option_id, _rawSplDevSensorTypData.list[i].option_name, _rawSplDevSensorTypData.list[i].is_active));
                        }
                        
                    }
                    this._splDevSensorTyp = _tmpSplDevSensorTyp;
                }

                let _tmpSplDevList: Array<OptionsDef> = [];
                let _rawSplDevListData:any = this.getDocTypeData(respJson.data,'ds_splDevList');
                if(_rawSplDevListData != null) {
                    for(var i=0; i<_rawSplDevListData.list.length; i++) {
                        if(_rawSplDevListData.list[i].is_active === true){
                            _tmpSplDevList.push(new OptionsDef(_rawSplDevListData.list[i].option_id, _rawSplDevListData.list[i].option_name, _rawSplDevListData.list[i].is_active));
                        }
                        
                    }
                    this._splDevList = _tmpSplDevList;
                }

                let _tmpFfrCoat: Array<OptionsDef> = [];
                let _rawFfrCoatData:any = this.getDocTypeData(respJson.data,'ds_ffrCoating');
                if(_rawFfrCoatData != null) {
                    for(var i=0; i<_rawFfrCoatData.list.length; i++) {
                        if(_rawFfrCoatData.list[i].is_active === true){
                            _tmpFfrCoat.push(new OptionsDef(_rawFfrCoatData.list[i].option_id, _rawFfrCoatData.list[i].option_name, _rawFfrCoatData.list[i].is_active));
                        }
                        
                    }
                    this._ffrCoating = _tmpFfrCoat;
                }

                

                this.isUnitDataLoaded = true;
                this._dataDefsLoadTime = new Date();               
            return true;
        }
        else
            return false;
        }))
        .pipe(catchError((error:any) => throwError(error || 'Server error')))
    
        return deflist;    
    }

    mAccess(_modId:string){
        return true;
        // for(var i=0;i<this._accessLevels.length;i++){
        //     if(this._accessLevels[i].Id == _modId){
        //         return true;
        //     }
        // }
        // return false;
    }
    hasEditAccess(_modId:string,_pid:string){
        if(this._accessLevel == 'admin' || this._accessLevel == 'edit')
            return true;
        else
            return false;

        // for(var i=0;i<this._accessLevels.length;i++){
        //     if(this._accessLevels[i].Id == _modId){
        //         return this._accessLevels[i].hasWriteAccess(_pid);
        //     }
        // }
        // return false;
    }
    hasReadAccess(_modId:string,_pid:string){
        return true;
        // for(var i=0;i<this._accessLevels.length;i++){
        //     if(this._accessLevels[i].Id == _modId){
        //         return this._accessLevels[i].hasReadAccess(_pid);
        //     }
        // }
        // return false;
    }
    // getAccessGrantLevel(_modId:string):Observable<boolean>{

    // }
    
// ........ get DefName by Id Methods.........
public getPlantName(_plntId:string):string{
    let _tempPlant:Plant = this._plants.find(pm => pm.plantId === _plntId);
    if(!_tempPlant){
        return "-";
    }
    return _tempPlant.plantName;
 }
 public getMarketingEngineerName(_mrktEngId:string):string{
    let _mrktEngnr:MarketingEngineer = this._marketingEngineers.find(mktEng => mktEng.marketingEngineerId === _mrktEngId);
    if(!_mrktEngnr){
        return "-";
    }
    return _mrktEngnr.marketingEngineerName;
 }
 public getMarketingEngineerEmail(_mrktEngId:string):string{
     
    let _mrktEngnr:MarketingEngineer = this._marketingEngineers.find((mktEng:MarketingEngineer) =>{
        return mktEng.marketingEngineerId == _mrktEngId;
    });
    
    if(!_mrktEngnr){
        return null;
    }
    return _mrktEngnr.emailId;
 }
 public getProjectManagerName(_pmId:string):string{
    let _tempPm:ProjectManager = this._projectManagers.find(pm => pm.projectManagerId === _pmId);
    if(!_tempPm){
        return "-";
    }
    return _tempPm.projectManagerName;
 }
 public getProjectManagerEmailId(_pmId:string):string{
    let _tempPm:ProjectManager = this._projectManagers.find(pm => pm.projectManagerId === _pmId);
    if(!_tempPm){
        return "-";
    }
    return _tempPm.emailId;
 }
 public getC30EngineerEmail(_c30DesignEngineer:string):string{
    let _tempElec:C30Engineer = this._c30DesignEngineer.find(elecEngg => elecEngg.c30EngineerEmailId === _c30DesignEngineer);
    if(!_tempElec){
        return "-";
    }
    return _tempElec.c30EngineerName;
 }
 public getElecDesignEngineerName(_elecEnggId:string):string{
    let _tempElec:ElectricalDesignEngineer = this._electricalDesignEngineer.find(elecEngg => elecEngg.electricalDesignEngineerId === _elecEnggId);
    if(!_tempElec){
        return "-";
    }
    return _tempElec.electricalDesignEngineerName;
 }
 public getElecDesignEngineerEmailId(_elecEnggId:string):string{
    let _tempElec:ElectricalDesignEngineer = this._electricalDesignEngineer.find(elecEngg => elecEngg.electricalDesignEngineerId === _elecEnggId);
    if(!_tempElec){
        return "-";
    }
    return _tempElec.electricalDesignEngineerEmailId;
 }
 public getMechDesignEngineerName(_mechEnggId:string):string{
    let _tempMech:MechanicalDesignEngineer = this._mechanicalDesignEngineer.find(mEngg => mEngg.mechanicalDesignEngineerId === _mechEnggId);
    if(!_tempMech){
        return "-";
    }
    return _tempMech.mechanicalDesignEngineerName;
 }
 public getMechDesignEngineerEmail(_mechEnggId:string):string{
    let _tempMech:MechanicalDesignEngineer = this._mechanicalDesignEngineer.find(mEngg => mEngg.mechanicalDesignEngineerId === _mechEnggId);
    if(!_tempMech){
        return null;
    }
    return _tempMech.emailId;
 }
 public getRevenueMonthName(_RevMonId:string):string{
    let _tempRevMonth:RevenueMonth = this._revenueMonths.find(pm => pm.monthId === _RevMonId);
    if(!_tempRevMonth){
        return "-";
    }
    return _tempRevMonth.monthName;
 }
 

 public getsaleChannelName(_saleChId:string):string{
    let _temSaleCh:SaleChannel = this._saleChannels.find(sc => sc.saleChannelId === _saleChId);
    if(!_temSaleCh){
        return "-";
    }
    return _temSaleCh.saleChannelName;
 }
 public getRegionName(_regId:string):string{
    let _temReg:Region = this._regions.find(reg => reg.regionId === _regId);
    if(!_temReg){
        return "-";
    }
    return _temReg.regionName;
 }
 public getOrderTypeName(_ordertId:string):string{
     let _tmpOrderT:OrderType = this._ordertypes.find(ordert => ordert.ordertypeId === _ordertId);
     if(!_tmpOrderT){
         return "-"
     }
     return _tmpOrderT.ordertypeName;
 }
 public getRelayConfigName(_relaycId:string):string{
    let _tmpRelayC:RelayConfig = this._relayconfigs.find(relayc => relayc.relayconfigId === _relaycId);
    if(!_tmpRelayC){
        return "-"
    }
    return _tmpRelayC.relayconfigName;
}
 public getWarrantyMonths(_warrMonthId:string):string{
     let _temWarnty:WarrantyMonths = this._warrantyMonths.find(wrnty => wrnty.warrantyMonthsId === _warrMonthId);
    if(!_temWarnty){
        return "-";
    }
    return _temWarnty.warrantyMonthsName;
 }
 public getPaymentTermName(_paytermId:string):string{
    let _temPayTerm:PaymentTermDef = this._paymentTermList.find(payTerm => payTerm.paymentTermId === _paytermId);
    if(!_temPayTerm){
        return "-";
    }
    return _temPayTerm.paymentTermName;
 }
 public getKioskApplicabilityOptionName(_applicId:string):string{
     let _temKisokApplicOpt: KIOSKApplicability = this._kioskApplicability.find(applicOpt => applicOpt.kioskApplicabilityId === _applicId);
    if(!_temKisokApplicOpt){
        return "-";
    }
    return _temKisokApplicOpt.kioskApplicabilityName;
 }
 public getApplicabilityOptionName(_applicId:string):string{
    let _temApplicOpt: ApplicabilityOptionDef = this._applicabilityOptions.find(applicOpt => applicOpt.applicId === _applicId);
    if(!_temApplicOpt){
        return "-";
    }
    return _temApplicOpt.applicName;
 }
 public getYesNoDispName(_yesNoOptId:string):string{
    let _temYesNoOpt: YesNoOption = this._yesNoOptions.find(yesNoOpt => yesNoOpt.optionId === _yesNoOptId);
    if(!_temYesNoOpt){
        return "-";
    }
    return _temYesNoOpt.optionDisplayName;
 }
 public getAdvPayMilestoneName(_advPayMilestoneId):string{
    let _temAdvPayMilestone: AdvancePayMilestone = this._advancePayMilestones.find(advPayMilestone => advPayMilestone.advancePayMilestoneId === _advPayMilestoneId);
    if(!_temAdvPayMilestone){
        return "-";
    }
    
    return _temAdvPayMilestone.advancePayMilestoneName;
 }
 public getAdvPayAcgABGMilestoneName(_advPayMilestoneId): string {
    let _temAdvPayMilestone: AdvancePayMilestone = this._advancePayMilestonesABGACG.find(advPayMilestone => advPayMilestone.advancePayMilestoneId === _advPayMilestoneId);
    if (!_temAdvPayMilestone) {
        return "-";
    }
    
    return _temAdvPayMilestone.advancePayMilestoneName;
}
 public getPBGPayConditionName(_pbgCondId:string){
    let _pbgCondition: PBGPayCondition = this._pbgPayCondition.find(pbgPayMilestone => pbgPayMilestone.pbgPayConditionId === _pbgCondId);
    if(!_pbgCondition){
        return "-";
    }
    
    return _pbgCondition.pbgPayConditionName;
 }
 public getCPBGPayConditionName(_cpbgCondId:string){
    let _cpbgCondition: CPBGPayCondition = this._cpbgPayCondition.find(cpbgPayMilestone => cpbgPayMilestone.cpbgPayConditionId === _cpbgCondId);
    if(!_cpbgCondition){
        return "-";
    }
    
    return _cpbgCondition.cpbgPayConditionName;
 }
 public getAdvPayPercentName(__advPatPercentId:string):string{
     let _temAdvPayPercent: AdvancePayPercent = this._advancePayPercents.find(advPayPer=> advPayPer.advancePayPercentId === __advPatPercentId);
    if(!_temAdvPayPercent){
        return "-";
    }
    
    return _temAdvPayPercent.advancePayPercentDisplay;
 }
 public getAdvPayConditionName(_advPayConditionId:string):string{
    let _temAdvPayCondition: AdvancePayCondition = this._advancePayConditions.find(advPayCondi=> advPayCondi.advancePayConditionId === _advPayConditionId);
    if(!_temAdvPayCondition){
        return "-";
    }
    
     return _temAdvPayCondition.advancePayConditionName;
 }
public getDeliveryTermName(_delivId:string):string{
    let _temDelivTerm: DeliveryTermDef = this._deliveryTermList.find(delivTerm=> delivTerm.deliveryTermId === _delivId);
    if(!_temDelivTerm){
        return "-";
    }
    
    return _temDelivTerm.deliveryTermName;
}
public getLDPercentName(_ldPerId:string):string{
    let _temldPercent: LDPercentDef = this._ldPercentList.find(ldPercent=> ldPercent.ldPercentId === _ldPerId);
    if(!_temldPercent){
        return "-";
    }
    
    return _temldPercent.ldPercentName;
}
public getLDCapName(_ldCapId:string):string{
    let _tempLdCap: LDCAPDef = this._ldCAPList.find(ldCap=> ldCap.ldCapId === _ldCapId);
    if(!_tempLdCap){
        return "-";
    }
    
    return _tempLdCap.ldCAPName;
}
public getEquipmentTypeName(_equipTypeId:string):string{
    let _tempEqupType: EquipmentType = this._typeOfEquipments.find(eType=> eType.equipmentTypeId === _equipTypeId);
    if(!_tempEqupType){
        return "-";
    }
    
    return _tempEqupType.equipmentTypeName;
}
public getBreakerTypeName(_breakerTypeId:string):string{
    let _tempBrkType: BreakerType = this._breakerType.find(bType=> bType.breakerTypeId === _breakerTypeId);
    if(!_tempBrkType){
        return "-";
    }
    
    return _tempBrkType.breakerTypeName;
}
public getProductVariantName(_prodVariId:string):string{
    let _tempProdVarient: ProductVariant = this._productVariants.find(prodVarient=> prodVarient.productVariantId === _prodVariId);
    if(!_tempProdVarient){
        return "-";
    }
    
    return _tempProdVarient.productVariantName;
}
public getProductVariantId_DS(_prodVariName:string):string{
    let _tempProdVarient: ProductVariant = this._productVariants.find(prodVarient=> prodVarient.productVariantName.includes(_prodVariName));
    if(!_tempProdVarient){
        return "-";
    }
    
    return _tempProdVarient.productVariantId;
}
public getBoardName(_boardname: string): string {
    let _tempBoardName: BoardnameDef = this._boardnameList.find(boardnam => boardnam.boardname === _boardname);
    if (!_tempBoardName) {
        return "-";
    }

    return _tempBoardName.boardname;
}

public getdelayreason(_delayreason: string): string {
    let _tempDelayReason: DelayReason = this._delayReasonList.find(boardnam => boardnam.delayreason === _delayreason);
    if (!_tempDelayReason) {
        return "-";
    }

    return _tempDelayReason.delayreason;
}
public getPanelNumName(_panelNumId:string):string{
    let _tempPanelNum: PanelNumDef = this._noOfPanelsList.find(panelNum=> panelNum.noOfPanelsId === _panelNumId);
    if(!_tempPanelNum){
        return "-";
    }
   
    return _tempPanelNum.noOfPanelsName;
}
public getInsulationKVName(_insulationKVId:string):string{
    //_insulationLevel
    let _insKV: InsulationLevel = this._insulationLevel.find(tmpInsKV => tmpInsKV.insulationLevelId === _insulationKVId);
    if(!_insKV){
        return "-";
    }
    return _insKV.insulationLevelName;
}
public getFeederTypeName(_feederTypeId:string):string{
    let _tempFeederType: FeederTypeDef = this._noOfFeederTypeList.find(feederType=> feederType.noOfFeederTypesId === _feederTypeId);
    if(!_tempFeederType){
        return "-";
    }
   
    return _tempFeederType.noOfFeederTypeName;
}
public getJobComplexityName(_jobComplxId:string):string{
    let _tempJobComplx: JobComplexityDef = this._jobComplexityList.find(jobComplx=> jobComplx.complexityOfJobsId === _jobComplxId);
    if(!_tempJobComplx){
        return "-";
    }
   
    return _tempJobComplx.complexityOfJobsName;
}
public getBusbarMatrialName(_busbarMatId:string):string{
    let _tempBusbarMat: BusbarMaterialDef = this._busbarMaterialList.find(busbarMat=> busbarMat.busbarMaterialId === _busbarMatId);
    if(!_tempBusbarMat){
        return "-";
    }
   
    return _tempBusbarMat.busbarMaterialName;
}
public getBusbarSleeveName(_busbarSlvId:string):string{
    let _tempBusbarSleev: BusbarSleeveDef = this._busbarSleeves.find(busbarSleev=> busbarSleev.busbarSleeveId === _busbarSlvId);
    if(!_tempBusbarSleev){
        return "-";
    }
   
    return _tempBusbarSleev.busbarSleeveName;
}
public getProjectEngineerName(_projEnggId:string):string{
    let _tempProjEngg: ProjectEngineer = this._projectEngineers.find(projEngg=> projEngg.projectEngineerId === _projEnggId);
    if(!_tempProjEngg){
        return "-";
    }
   
    return _tempProjEngg.projectEngineerName;
}
public getProjectEngineerEmail(_projEnggId:string):string{
    let _tempProjEngg: ProjectEngineer = this._projectEngineers.find(projEngg=> projEngg.projectEngineerId === _projEnggId);
    if(!_tempProjEngg){
        return null;
    }
   
    return _tempProjEngg.emailId;;
}
public getManufacturingStrategyName(_manufStrategyValue:string):string{
    let _tempManufStrategy: ManufacturtingStrategy = this._manufacturtingStrategy.find(manufStrategy=> manufStrategy.manufacturtingStrategyValue === _manufStrategyValue);
    if(!_tempManufStrategy){
        return "-";
    }
   
    return _tempManufStrategy.manufacturtingStrategyName;
}
public getNatureOfIssuesTypeName(_niId:string):string{
    let _tmp:GenDataType = this._natureOfIssuesList.find(aff => aff.genTypeId === _niId);
    if(!_tmp){
        return "-"
    }
    return _tmp.genTypeName;
}
public getChangeNoteTypeName(_cnId:string):string{
    let _tmp:GenDataType = this._changeNoteTypeList.find(cnt => cnt.genTypeId === _cnId);
    if(!_tmp){
        return "-"
    }
    return _tmp.genTypeName;
}
public getApproverL1Name(_apId:string):string{
    let _tmp:GenUserDef = this._approverL1List.find(apl => apl.userEmailId === _apId);
    if(!_tmp){
        return "-"
    }
    return _tmp.userName;
}
public getApproverL2Name(_apId:string):string{
    let _tmp:GenUserDef = this._approverL2List.find(apl => apl.userEmailId === _apId);
    if(!_tmp){
        return "-"
    }
    return _tmp.userName;
}
public getFeederRatingBPName(_typeId:string):string{
    let _tmp:OptionsConnectedDef = this._feederRatingBP.find(apl => apl.optionId=== _typeId);
    if(!_tmp){
        return "-"
    }
    return _tmp.optionName;
}
public getCloseTripCircName(_typeId:string):string{
    let _tmp:OptionsDef = this._closeTripCirc.find(apl => apl.optionId=== _typeId);
    if(!_tmp){
        return "-"
    }
    return _tmp.optionName;
}
public getAddTripCoilName(_typeId:string):string{
    let _tmp:OptionsDef = this._addTripCoil.find(apl => apl.optionId=== _typeId);
    if(!_tmp){
        return "-"
    }
    return _tmp.optionName;
}
public getNumRelCommPortName(_typeId:string):string{
    let _tmp:OptionsConnectedDef = this._numRelCommPort.find(apl => apl.optionId=== _typeId);
    if(!_tmp){
        return "-"
    }
    return _tmp.optionName;
}
public getVcbModelName(_typeId:string):string{
    let _tmp:OptionsConnectedDef = this._vcbModel.find(apl => apl.optionId=== _typeId);
    if(!_tmp){
        return "-"
    }
    return _tmp.optionName;
}
public getVcbTypeName(_typeId:string):string{
    let _tmp:OptionsDef = this._vcbType.find(apl => apl.optionId=== _typeId);
    if(!_tmp){
        return "-"
    }
    return _tmp.optionName;
}
public getVcbPoleName(_typeId:string):string{
    let _tmp:OptionsDef = this._vcbPole.find(apl => apl.optionId=== _typeId);
    if(!_tmp){
        return "-"
    }
    return _tmp.optionName;
}
public getVcbDetailName(_typeId:string):string{
    let _tmp:OptionsConnectedDef = this._vcbModelDetail.find(apl => apl.optionId=== _typeId);
    if(!_tmp){
        return "-"
    }
    return _tmp.optionName;
}
public getForceCoolingVCBCurrName(_typeId:string):string{
    let _tmp:OptionsConnectedDef = this._forceCoolingVCBCurr.find(apl => apl.optionId=== _typeId);
    if(!_tmp){
        return "-"
    }
    return _tmp.optionName;
}
public getMaterialMBBName(_typeId:string):string{
    let _tmp:OptionsDef = this._materialMBB.find(apl => apl.optionId=== _typeId);
    if(!_tmp){
        return "-"
    }
    return _tmp.optionName;
}
public downloadFile(_reptype:string, _filter?: { filterType?: string, fromMonth?: string, toMonth?: string }) {
    let url:string
    url  = DataService.downloadFile + "?reptype="+ encodeURIComponent(_reptype);

    if (_filter && _filter.filterType) {
        url += "&filterType=" + encodeURIComponent(_filter.filterType);
    }
    if (_filter && _filter.fromMonth) {
        url += "&fromMonth=" + encodeURIComponent(_filter.fromMonth);
    }
    if (_filter && _filter.toMonth) {
        url += "&toMonth=" + encodeURIComponent(_filter.toMonth);
    }

    window.open(url);
}  
public downloadFileKPI(_reptype:string,_status?:number,_year?:number) {
    let url:string
    url  = DataService.downloadFileKPI + "?reptype="+ _reptype+ "&status="+ _status+ "&year="+ _year;
    window.open(url);
}

    // getDeletedSubOrder(_data:number,range:string):Observable<any>{
    getDeletedSaleOrder(range: string): Observable<any> {
        // let _subscrb = this.http.post(DataService.getDeletedSubOrder,{"limit":_data,"dateRange":range}) 
        let _subscrb = this.http.post(DataService.getDeletedSaleOrder, { "dateRange": range })
            .pipe(map((res: any) => {
                let respJson = res;

                if (respJson.status == "OK") {
                    for (var i = 0; i < respJson.data.length; i++) {
                        delete respJson.data[i]._rid;
                        delete respJson.data[i]._self;
                        delete respJson.data[i]._etag;
                        delete respJson.data[i]._attachments;
                        delete respJson.data[i].prev_LogDocId;
                        delete respJson.data[i].doctype;
                        delete respJson.data[i].factory_ref;
                    }
                    let _salesOrderObjList: Array<SalesOrder> = [];
                    for (var i = 0; i < respJson.data.length; i++) {
                        _salesOrderObjList.push(SalesOrder.getObj(respJson.data[i].data, respJson.data[i]._ts));
                    }

                    return _salesOrderObjList;

                }
                else {
                    return "";
                }
            }))
            .pipe(catchError((error: any) => throwError(error || 'Server error')))
        return _subscrb; 
    }
    getDelSubSaleOrder(range:string):Observable<any>{
        // let _subscrb = this.http.post(DataService.getDeletedSubOrder,{"limit":_data,"dateRange":range}) 
        let _subscrb = this.http.post(DataService.getDelSubSaleOrder, { "dateRange": range })
            .pipe(map((res: any) => {
                let respJson = res;

                if (respJson.status == "OK") {
                    for (var i = 0; i < respJson.data.length; i++) {
                        delete respJson.data[i]._rid;
                        delete respJson.data[i]._self;
                        delete respJson.data[i]._etag;
                        delete respJson.data[i]._attachments;
                        delete respJson.data[i].prev_LogDocId;
                        delete respJson.data[i].doctype;
                        delete respJson.data[i].factory_ref;
                    }
                    let _salesOrderObjList: Array<SalesOrder> = [];
                    for (var i = 0; i < respJson.data.length; i++) {
                        _salesOrderObjList.push(SalesOrder.getObj(respJson.data[i].data, respJson.data[i]._ts));
                    }

                    return _salesOrderObjList;

                }
                else {
                    return "";
                }
            }))
                .pipe(catchError((error: any) => throwError(error || 'Server error')))
        return _subscrb;
    }
    sendaisc40(_data: object): Observable<any> {
        let _subscrb = this.http.post(DataService.sendaisc40, { _data })
            .pipe(map((res: any) => {
                let respJson = res;
                if (respJson.status == "OK") {
                    return respJson;
                }
                else {
                    return "";
                }
            }))
            .pipe(catchError((error: any) => throwError(error.json().error || 'Server error')))
        return _subscrb;
    } 

    downloadPdfFunc(_data: object): Observable<any> {
        let _subscrb = this.http.post(DataService.downloadPdf, {_data})
            .pipe(map((res: any) => {
                let respJson = res;
                if (respJson.status == "OK") {
                    return respJson;
                }
                else {
                    return "";
                }
            }))
            .pipe(catchError((error: any) => throwError(error.json().error || 'Server error')))
        return _subscrb;
    }
    getDataFromSAP(_data: object): Observable<any> {
        let _subscrb = this.http.post(DataService.fetchSapData, {"data": _data, "userEmail": this._userId})
            .pipe(map((res: any) => {
                let respJson = res;
                if (respJson.status == "OK") {
                    return respJson;
                }
                else {
                    return respJson;
                }
            }))
            .pipe(catchError((error: any) => throwError(error.json().error || 'Server error')))
        return _subscrb;
    } 
    getSAPSyncStatus() {
        let _subscrb =  this.http.get(DataService.getSapSynchInfo)
            .pipe(map((res: any) => {
                let respJson = res;
                if (respJson.status == "OK") {
                    let _tmp = respJson.data;
                      this.syncedSAPDateSubject.next(new Date(_tmp.lastUpdated));
                }
                else {
                    this.syncedSAPDateSubject.next(null);
                }
            }))
            .pipe(catchError((error: any) => throwError(error.json().error || 'Server error')))
        return _subscrb;
    }
    uploadPdfFunc(_data: object): Observable<any> {
        let _subscrb = this.http.post(DataService.uploadPdf, {_data})
            .pipe(map((res: any) => {
                let respJson = res;
                if (respJson.status == "OK") {
                    return respJson;
                }
                else {
                    return "";
                }
            }))
            .pipe(catchError((error: any) => throwError(error.json().error || 'Server error')))
        return _subscrb;
    } 
    getMigoDataFromSAP(_soData: object, _subSOData: string, _msg: object): Observable<any> {
        console.log("came here")
        console.log(_soData);        console.log(_subSOData);        console.log(_msg); 
        let _subscrb = this.http.post(DataService.fetchMigoSapData, {"soData": _soData, "subSONo": _subSOData, "userEmail": this._userId, "data": _msg})
            .pipe(map((res: any) => {
                let respJson = res;
                if (respJson.status == "OK") {
                    return respJson;
                }
                else {
                    return respJson;
                }
            }))
            .pipe(catchError((error: any) => throwError(error.error || 'Server error')))
        return _subscrb;
    } 
    fetchMaterialSAPData(_soData: string | object, _subSOData: string, _msg: object): Observable<any> {
        let _subscrb = this.http.post(DataService.fetchMaterialSapData, {"soData": _soData, "subSONo": _subSOData, "userEmail": this._userId, "data": _msg})
            .pipe(map((res: any) => {
                let respJson = res;
                if (respJson.status == "OK") {
                    return respJson;
                }
                else {
                    return respJson;
                }
            }))
            .pipe(catchError((error: any) => throwError(error.error || 'Server error')))
        return _subscrb;
    }
    fetchDispatchSAPData(_soData: string | object, _subSOData: string, _msg: object): Observable<any> {
        let _subscrb = this.http.post(DataService.fetchDispatchSapData, {"soData": _soData, "subSONo": _subSOData, "userEmail": this._userId, "data": _msg})
            .pipe(map((res: any) => {
                let respJson = res;
                if (respJson.status == "OK") {
                    return respJson;
                }
                else {
                    return respJson;
                }
            }))
            .pipe(catchError((error: any) => throwError(error.error || 'Server error')))
        return _subscrb;
    }
    public getDateFormat(_dt : Date):string{
        return GenService.getDateFormatStr(_dt, 'DD-MM-YYYY')
    }
    public getFullDateFormat(_dt : Date):string{
        return GenService.getDateFormatStr(_dt, 'W, MMM DD, YYYY')
    }

    public logFile(_data: object): Observable<any> {
        let _subscrb = this.http.post(DataService.getLogFile, { "data": _data })
            .pipe(map((res: any) => {
                let respJson = res;
                if (respJson.status == "OK") {
                    return respJson;
                }
                else {
                    return "";
                }
            }))
            .pipe(catchError((error: any) => throwError(error || 'Server error')))
        return _subscrb;
    }

    public createDatasheetVersion(_path: string, _content: string): Observable<any> {
        return this.http.post(DataService.createDatasheetVersionUrl, { "data": { "path": _path, "content": _content } })
            .pipe(map((res: any) => res))
            .pipe(catchError((error: any) => throwError(error || 'Server error')));
    }

    public getDatasheetVersion(_path: string): Observable<any> {
        const url = DataService.getDatasheetVersionUrl + "?path=" + encodeURIComponent(_path);
        return this.http.get(url)
            .pipe(map((res: any) => res))
            .pipe(catchError((error: any) => throwError(error || 'Server error')));
    }

    public downloadFileContent(_relPath:string, _name:string):Observable<any> {
        let url:string;
        //url  = DataService.downloadFileUrl + "?relpath=" + _relPath 
          //      + "&name=" + _name;
          url  = DataService.downloadFileUrl + "?name=" + _name 
                + "&relpath=" + _relPath;
    // '/downloadfile?actname='+encodeURIComponent(_fObj.filename)+'&fref=' + _fObj.fileref;
        // const requestOptions : any = {
        //     headers: new HttpHeaders(),
        //     responseType : new HttpHeaders()
        //     };
        // requestOptions.headers.append('Content-Type', 'application/json');
        // requestOptions.responseType.append('responseType', 'arraybuffer');
        const requestOptions: any = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json'
            }),
            'responseType': 'arraybuffer'
        };

        let _subscribe = this.http.get(url, requestOptions).pipe(map((_resp:any) =>{
            return _resp;
        }))
        .pipe(catchError((error:any) => throwError(error || 'Server error')));
        
        return _subscribe;
    }

    /**
   * Extracts the first number from a string like '28 kV'.
   * Returns the number as a float, or null if not found.
   */
    public extractNumberKv(expression: string): number | null {
        if (!expression) return null;
        const match = expression.match(/([0-9]*\.?[0-9]+)/);
        return match ? parseFloat(match[1]) : null;
    }

    /**
     * Extracts the first number (integer or decimal) from a string like '40 kA - 3 s'.
     * Returns the number as a float, or null if not found.
     */
    public extractNumberkA(expression: string): number | null {
        if (!expression) return null;
        const match = expression.match(/([0-9]*\.?[0-9]+)/);
        return match ? parseFloat(match[1]) : null;
    }

    /**
     * Extracts the seconds value from an expression like '40 kA - 0.1 s'.
     * Returns the first number before 's' (seconds) after a dash or space.
     */
    extractSeconds(expression: string): number | null {
        if (!expression) return null;
        // Match: dash or space, then number (int/float), then optional space, then 's'
        const match = expression.match(/[-\s]([0-9]+(?:\.[0-9]+)?)\s*s\b/i);
        return match ? parseFloat(match[1]) : null;
    }

    /**
     * Extracts the ampere value from expressions like '=> 3150 Amp' or '3150 Amp'.
     * Returns the first number before 'Amp' (case-insensitive).
     */
    extractAmpere(expression: string): number | null {
        if (!expression) return null;
        const match = expression.match(/([0-9]+(?:\.[0-9]+)?)\s*amp/i);
        return match ? parseFloat(match[1]) : null;
    }

    /**
     * Extracts the number (integer or decimal) followed by space and "kA" from a string like '40 kA - 3 s'.
     * Returns the number as a float along with "kA", or empty if not found.
     */
    extractKaValue(input: string): string {
    if (!input) return '';
    const match = input.match(/(\d+(?:\.\d+)?)\s*kA/i);
    return match ? `${match[1]} kA` : '';
    }

    /**
     * Extracts the number (integer or decimal) followed by space and "A" from a string like '40 A'.
     * Returns the number as a float along with "A", or empty if not found.
     */
    extractAValue(input: string): string {
    if (!input) return '';
    // Match "40", "40A", or "40 A"
    const match = input.match(/^(\d+(?:\.\d+)?)(?:\s*A)?$/i) || input.match(/(\d+(?:\.\d+)?)\s*A/i);
    return match ? `${match[1]} A` : '';
    }

    /**
    * Compares a numeric string and a string with a '>' operator (e.g., '25', '>20').
    * Returns true if the numeric value is greater than the value after '>', else false.
    */
    compareTwoInputs(input1: number, input2: string): boolean {
        if (!input1 || !input2) return false;
        let num1 = Number(input1);
        if (input2.startsWith('>')) {
            let num2 = Number(input2.substring(1));
            return num1 > num2;
        }
        if (input2.startsWith('=')) {
            let num2 = Number(input2.substring(1));
            return num1 == num2;
        }
        return false;
    }
    /**
    * Compares a numeric string and a string with a '>' operator (e.g., '25', '>20').
    * Returns true if the numeric value is greater than the value after '>', else false.
    */
    compareTwoInputs_v2(input1: number, input2: string, input3: number): boolean {
        if (!input1 || !input2) return false;
        let num1 = Number(input1);
        if (input2.startsWith('>=')) {
            let num2 = input3;
            return num1 >= num2;
        }
        else if (input2.startsWith('<=')) {
            let num2 = input3;
            return num1 <= num2;
        }
        else {
            let num2 = input3;
            return num1 == num2;
        }
        return false;
    }

 //public functions end
}

